var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _path, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNofotajet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 347.3 342",
    style: {
      enableBackground: "new 0 0 347.3 342"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#F0F0F0;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#E6E6E6;}\r\n\t.st5{fill:#FAFAFA;}\r\n\t.st6{display:inline;fill:#F5F5F5;}\r\n\t.st7{display:inline;fill:#E0E0E0;}\r\n\t.st8{display:none;fill:#E0E0E0;}\r\n\t.st9{fill:#E0E0E0;}\r\n\t.st10{fill:#DB8559;}\r\n\t.st11{opacity:5.000000e-02;fill:#FFFFFF;}\r\n\t.st12{opacity:0.15;}\r\n\t.st13{display:inline;fill:#DB8559;}\r\n\t.st14{display:inline;opacity:0.2;fill:#FFFFFF;}\r\n\t.st15{display:inline;fill:#263238;}\r\n\t.st16{fill:#455A64;}\r\n\t.st17{fill:#37474F;}\r\n\t.st18{opacity:0.2;fill:#FFFFFF;}\r\n\t.st19{fill:#263238;}\r\n\t.st20{opacity:0.3;fill:#FFFFFF;}\r\n\t.st21{opacity:0.4;fill:#FFFFFF;}\r\n\t.st22{opacity:0.75;fill:#FFFFFF;}\r\n\t.st23{opacity:0.6;fill:#FFFFFF;}\r\n\t.st24{opacity:0.3;}\r\n\t.st25{opacity:0.5;}\r\n\t.st26{opacity:0.1;}\r\n\t.st27{display:inline;opacity:0.5;}\r\n\t.st28{opacity:0.2;}\r\n\t.st29{fill:#EBEBEB;}\r\n\t.st30{display:inline;opacity:0.1;}\r\n\t.st31{opacity:0.7;fill:#FFFFFF;}\r\n\t.st32{opacity:0.55;fill:#FFFFFF;}\r\n\t.st33{opacity:0.55;}\r\n\t.st34{fill:#AAAAAA;}\r\n\t.st35{opacity:0.35;fill:#FFFFFF;}\r\n\t.st36{opacity:0.8;fill:#FFFFFF;}\r\n\t.st37{fill:#8E8D8D;}\r\n\t.st38{fill:#B5B5B5;}\r\n\t.st39{opacity:0.5;fill:#FFFFFF;}\r\n\t.st40{fill:#A5A5A5;}\r\n\t.st41{enable-background:new    ;}\r\n\t.st42{opacity:0.4;}\r\n\t.st43{opacity:0.6;}\r\n\t.st44{opacity:0.8;}\r\n\t.st45{opacity:0.9;fill:#FFFFFF;}\r\n\t.st46{fill:#222020;}\r\n\t.st47{fill:#919395;}\r\n\t.st48{fill:#404040;}\r\n\t.st49{fill:#D0D1D2;}\r\n\t.st50{fill:#2A2A2A;}\r\n\t.st51{fill:#A6A7AA;}\r\n\t.st52{fill:#F1F1F1;}\r\n\t.st53{fill:#E4E5E5;}\r\n\t.st54{fill:#808083;}\r\n\t.st55{fill:url(#SVGID_1_);}\r\n\t.st56{fill:url(#SVGID_00000127750490007785481630000013344614640422488457_);}\r\n\t.st57{fill:#FAF1E9;}\r\n\t.st58{fill:url(#SVGID_00000096766950267271503960000008565399080312583558_);}\r\n\t.st59{fill:url(#SVGID_00000080199093791711778990000001530825240049441429_);}\r\n\t.st60{fill:#F5F5F5;}\r\n\t.st61{fill:#2E353B;}\r\n\t.st62{fill:#E51F28;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "City",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "City_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "11.5,246 11.5,96.6 35.9,82.5 54.3,93.1 54.3,129.7 63.5,124.4 63.5,110.3 72.7,105 72.7,51.2  100.2,35.3 112.4,42.4 112.4,58.9 124.7,51.8 136.9,58.9 136.9,89.5 149.2,96.6 149.2,67.2 161.4,60.1 176.7,68.9 176.7,104.3  192,95.5 192,38.9 210.4,28.3 231.8,40.7 231.8,86.5 241,91.9 241,110.4 253.2,117.5 253.2,54 268.5,45.1 286.9,55.7 286.9,70.8  296.1,76.1 296.1,116.9 308.3,123.9 308.3,96.4 326.7,85.8 335.9,91.1 335.9,246  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,163.1 119.7,161.6 119.7,159.3 122.3,160.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,171.4 119.7,169.9 119.7,167.7 122.3,169.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,158.9 119.7,157.4 119.7,155.1 122.3,156.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,154.4 119.7,152.9 119.7,150.7 122.3,152.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,167.3 119.7,165.8 119.7,163.5 122.3,165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,137.7 119.7,136.2 119.7,133.9 122.3,135.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,133.5 119.7,132 119.7,129.8 122.3,131.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,141.9 119.7,140.4 119.7,138.1 122.3,139.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,150.3 119.7,148.8 119.7,146.5 122.3,148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,146.1 119.7,144.6 119.7,142.3 122.3,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,184 119.7,182.5 119.7,180.2 122.3,181.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,205.2 119.7,203.7 119.7,201.4 122.3,202.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,196.5 119.7,195 119.7,192.8 122.3,194.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,201 119.7,199.5 119.7,197.2 122.3,198.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,213.5 119.7,212 119.7,209.8 122.3,211.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,209.4 119.7,207.9 119.7,205.6 122.3,207.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,179.8 119.7,178.3 119.7,176 122.3,177.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,192.3 119.7,190.8 119.7,188.6 122.3,190.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,175.6 119.7,174.1 119.7,171.9 122.3,173.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,129.3 119.7,127.8 119.7,125.6 122.3,127.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,188.2 119.7,186.7 119.7,184.4 122.3,185.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,77.7 119.7,76.2 119.7,73.9 122.3,75.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,73.5 119.7,72 119.7,69.7 122.3,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,69.3 119.7,67.8 119.7,65.6 122.3,67.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,214.6 114.3,213.1 114.3,210.8 116.9,212.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,210.4 114.3,208.9 114.3,206.7 116.9,208.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,218.8 114.3,217.3 114.3,215 116.9,216.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,223 114.3,221.5 114.3,219.2 116.9,220.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,217.7 119.7,216.2 119.7,214 122.3,215.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,90.2 119.7,88.7 119.7,86.5 122.3,88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,112 119.7,110.5 119.7,108.3 122.3,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,107.6 119.7,106.1 119.7,103.8 122.3,105.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,116.8 119.7,115.3 119.7,113 122.3,114.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,102.8 119.7,101.3 119.7,99 122.3,100.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,121 119.7,119.5 119.7,117.2 122.3,118.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,125.2 119.7,123.7 119.7,121.4 122.3,122.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,81.9 119.7,80.4 119.7,78.1 122.3,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,86.1 119.7,84.6 119.7,82.3 122.3,83.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,98.6 119.7,97.1 119.7,94.8 122.3,96.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,94.4 119.7,92.9 119.7,90.6 122.3,92.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,80.5 74.4,79 74.4,76.7 77,78.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,156.7 74.4,155.2 74.4,153 77,154.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,152.5 74.4,151 74.4,148.8 77,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,148.4 74.4,146.9 74.4,144.6 77,146.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,160.9 74.4,159.4 74.4,157.1 77,158.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,165.1 74.4,163.6 74.4,161.3 77,162.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,122.7 74.4,121.2 74.4,118.9 77,120.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,131.6 74.4,130.1 74.4,127.9 77,129.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,144.2 74.4,142.7 74.4,140.4 77,141.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,127.5 74.4,126 74.4,123.7 77,125.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,135.8 74.4,134.3 74.4,132.1 77,133.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,169.6 74.4,168.1 74.4,165.8 77,167.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,140 74.4,138.5 74.4,136.2 77,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,203 74.4,201.5 74.4,199.2 77,200.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,198.8 74.4,197.3 74.4,195.1 77,196.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,211.7 74.4,210.2 74.4,207.9 77,209.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,194.6 74.4,193.1 74.4,190.9 77,192.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,207.2 74.4,205.7 74.4,203.4 77,204.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,182.1 74.4,180.6 74.4,178.3 77,179.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,190.5 74.4,189 74.4,186.7 77,188.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,177.9 74.4,176.4 74.4,174.2 77,175.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,173.7 74.4,172.2 74.4,170 77,171.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,186.3 74.4,184.8 74.4,182.5 77,184  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,84.7 74.4,83.2 74.4,80.9 77,82.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,59.6 74.4,58.1 74.4,55.8 77,57.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,118.5 74.4,117 74.4,114.7 77,116.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,63.8 74.4,62.3 74.4,60 77,61.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,72.1 74.4,70.6 74.4,68.4 77,69.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,68 74.4,66.5 74.4,64.2 77,65.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,105.9 74.4,104.4 74.4,102.1 77,103.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,101.7 74.4,100.2 74.4,97.9 77,99.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,114.2 74.4,112.7 74.4,110.5 77,112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,110.1 74.4,108.6 74.4,106.3 77,107.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,76.3 74.4,74.8 74.4,72.6 77,74.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,97.2 74.4,95.7 74.4,93.5 77,95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,221.9 119.7,220.4 119.7,218.1 122.3,219.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,206.2 114.3,204.7 114.3,202.5 116.9,204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,88.9 74.4,87.4 74.4,85.1 77,86.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,93 74.4,91.5 74.4,89.3 77,90.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,67.7 209.5,66.2 209.5,64 212.1,65.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,126.6 209.5,125.1 209.5,122.8 212.1,124.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,135 209.5,133.5 209.5,131.2 212.1,132.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,147.5 209.5,146 209.5,143.7 212.1,145.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,139.2 209.5,137.7 209.5,135.4 212.1,136.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,143.3 209.5,141.8 209.5,139.6 212.1,141.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,130.8 209.5,129.3 209.5,127 212.1,128.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,101.2 209.5,99.7 209.5,97.4 212.1,98.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,105.4 209.5,103.9 209.5,101.6 212.1,103.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,109.6 209.5,108.1 209.5,105.8 212.1,107.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,114.1 209.5,112.6 209.5,110.3 212.1,111.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,118.3 209.5,116.8 209.5,114.5 212.1,116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,122.4 209.5,120.9 209.5,118.7 212.1,120.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,177.1 209.5,175.6 209.5,173.3 212.1,174.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,181.3 209.5,179.8 209.5,177.5 212.1,179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,185.4 209.5,183.9 209.5,181.7 212.1,183.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,189.6 209.5,188.1 209.5,185.8 212.1,187.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,172.9 209.5,171.4 209.5,169.1 212.1,170.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,164.5 209.5,163 209.5,160.8 212.1,162.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,160.3 209.5,158.8 209.5,156.6 212.1,158.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,168.7 209.5,167.2 209.5,164.9 212.1,166.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,156.2 209.5,154.7 209.5,152.4 212.1,153.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,151.7 209.5,150.2 209.5,147.9 212.1,149.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,193.8 209.5,192.3 209.5,190 212.1,191.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,220.2 204.2,218.7 204.2,216.5 206.8,218  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,97 209.5,95.5 209.5,93.2 212.1,94.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,216.1 204.2,214.6 204.2,212.3 206.8,213.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,203.5 204.2,202 204.2,199.7 206.8,201.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,207.7 204.2,206.2 204.2,203.9 206.8,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,211.9 204.2,210.4 204.2,208.1 206.8,209.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,55.2 209.5,53.7 209.5,51.4 212.1,52.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,84.5 209.5,83 209.5,80.7 212.1,82.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,80.3 209.5,78.8 209.5,76.5 212.1,78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,92.8 209.5,91.3 209.5,89.1 212.1,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,88.7 209.5,87.2 209.5,84.9 212.1,86.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,76.1 209.5,74.6 209.5,72.3 212.1,73.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,63.6 209.5,62.1 209.5,59.8 212.1,61.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,71.9 209.5,70.4 209.5,68.2 212.1,69.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,59.4 209.5,57.9 209.5,55.6 212.1,57.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,215.8 74.4,214.3 74.4,212.1 77,213.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,134.6 114.3,133.1 114.3,130.8 116.9,132.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,138.8 114.3,137.3 114.3,135 116.9,136.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,198.3 209.5,196.8 209.5,194.5 212.1,196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,147.1 114.3,145.6 114.3,143.4 116.9,144.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,151.3 114.3,149.8 114.3,147.5 116.9,149  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,155.8 114.3,154.3 114.3,152 116.9,153.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,122.1 114.3,120.6 114.3,118.3 116.9,119.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,117.9 114.3,116.4 114.3,114.1 116.9,115.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,113.7 114.3,112.2 114.3,109.9 116.9,111.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,126.2 114.3,124.7 114.3,122.5 116.9,124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,130.4 114.3,128.9 114.3,126.6 116.9,128.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,189.2 114.3,187.7 114.3,185.5 116.9,187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,160 114.3,158.5 114.3,156.2 116.9,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,193.4 114.3,191.9 114.3,189.6 116.9,191.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,180.9 114.3,179.4 114.3,177.1 116.9,178.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,197.9 114.3,196.4 114.3,194.1 116.9,195.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,185.1 114.3,183.6 114.3,181.3 116.9,182.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,164.1 114.3,162.6 114.3,160.4 116.9,161.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,176.7 114.3,175.2 114.3,172.9 116.9,174.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,168.3 114.3,166.8 114.3,164.6 116.9,166.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,172.5 114.3,171 114.3,168.7 116.9,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,143 114.3,141.5 114.3,139.2 116.9,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,223.4 209.5,221.9 209.5,219.6 212.1,221.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,219.2 209.5,217.7 209.5,215.4 212.1,216.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,202.1 114.3,200.6 114.3,198.3 116.9,199.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,108.9 114.3,107.4 114.3,105.1 116.9,106.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,206.6 209.5,205.1 209.5,202.9 212.1,204.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,210.8 209.5,209.3 209.5,207 212.1,208.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,215 209.5,213.5 209.5,211.2 212.1,212.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.1,202.4 209.5,200.9 209.5,198.7 212.1,200.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,91.3 114.3,89.8 114.3,87.5 116.9,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,95.5 114.3,94 114.3,91.7 116.9,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,99.7 114.3,98.2 114.3,95.9 116.9,97.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,104.4 114.3,102.9 114.3,100.7 116.9,102.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,87.1 114.3,85.6 114.3,83.4 116.9,84.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,70.4 114.3,68.9 114.3,66.6 116.9,68.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,74.6 114.3,73.1 114.3,70.8 116.9,72.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,66.2 114.3,64.7 114.3,62.4 116.9,63.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,82.9 114.3,81.4 114.3,79.2 116.9,80.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "116.9,78.8 114.3,77.3 114.3,75 116.9,76.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,215.2 24.6,213.7 24.6,211.4 27.2,212.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,220 74.4,218.5 74.4,216.3 77,217.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,195 19.2,193.5 19.2,191.3 21.8,192.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,203.7 19.2,202.2 19.2,199.9 21.8,201.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,190.9 19.2,189.4 19.2,187.1 21.8,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,207.9 19.2,206.4 19.2,204.1 21.8,205.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,182.5 19.2,181 19.2,178.7 21.8,180.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,170 19.2,168.4 19.2,166.2 21.8,167.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,174.1 19.2,172.6 19.2,170.4 21.8,171.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,178.3 19.2,176.8 19.2,174.5 21.8,176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,212 19.2,210.5 19.2,208.3 21.8,209.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,220.4 19.2,218.9 19.2,216.6 21.8,218.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,224.6 19.2,223.1 19.2,220.8 21.8,222.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,216.2 19.2,214.7 19.2,212.5 21.8,214  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,165.8 19.2,164.3 19.2,162 21.8,163.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,186.7 19.2,185.2 19.2,182.9 21.8,184.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,161.6 19.2,160.1 19.2,157.8 21.8,159.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,111 19.2,109.5 19.2,107.2 21.8,108.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,115.2 19.2,113.7 19.2,111.4 21.8,112.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,106.8 19.2,105.3 19.2,103 21.8,104.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,144.6 19.2,143.1 19.2,140.8 21.8,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,119.5 19.2,118 19.2,115.7 21.8,117.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,148.8 19.2,147.3 19.2,145 21.8,146.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,157.1 19.2,155.6 19.2,153.4 21.8,154.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,152.9 19.2,151.4 19.2,149.2 21.8,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,140.4 19.2,138.9 19.2,136.6 21.8,138.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,123.7 19.2,122.2 19.2,119.9 21.8,121.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,127.9 19.2,126.4 19.2,124.1 21.8,125.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,132 19.2,130.5 19.2,128.3 21.8,129.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,136.2 19.2,134.7 19.2,132.4 21.8,133.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,189.8 24.6,188.3 24.6,186 27.2,187.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,211 24.6,209.5 24.6,207.2 27.2,208.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,199.3 204.2,197.8 204.2,195.6 206.8,197.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,223.5 24.6,222 24.6,219.8 27.2,221.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,202.3 24.6,200.8 24.6,198.6 27.2,200.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,198.2 24.6,196.7 24.6,194.4 27.2,195.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,206.8 24.6,205.3 24.6,203 27.2,204.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,194 24.6,192.5 24.6,190.2 27.2,191.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,219.3 24.6,217.8 24.6,215.6 27.2,217.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,185.6 24.6,184.1 24.6,181.8 27.2,183.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,122.6 24.6,121.1 24.6,118.8 27.2,120.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,118.3 24.6,116.8 24.6,114.5 27.2,116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,131 24.6,129.5 24.6,127.2 27.2,128.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,135.1 24.6,133.6 24.6,131.4 27.2,132.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,109.9 24.6,108.4 24.6,106.1 27.2,107.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,139.3 24.6,137.8 24.6,135.6 27.2,137.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,114.1 24.6,112.6 24.6,110.3 27.2,111.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,126.8 24.6,125.3 24.6,123 27.2,124.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,168.9 24.6,167.4 24.6,165.1 27.2,166.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,173.1 24.6,171.6 24.6,169.3 27.2,170.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,177.2 24.6,175.7 24.6,173.5 27.2,175  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,164.7 24.6,163.2 24.6,160.9 27.2,162.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,181.4 24.6,179.9 24.6,177.7 27.2,179.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,160.2 24.6,158.7 24.6,156.5 27.2,158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,147.7 24.6,146.2 24.6,143.9 27.2,145.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,151.9 24.6,150.4 24.6,148.1 27.2,149.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,156.1 24.6,154.6 24.6,152.3 27.2,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.2,143.5 24.6,142 24.6,139.7 27.2,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.8,199.2 19.2,197.7 19.2,195.4 21.8,196.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,155.7 79.8,154.2 79.8,151.9 82.4,153.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,151.5 79.8,150 79.8,147.7 82.4,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,159.8 79.8,158.3 79.8,156.1 82.4,157.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,164 79.8,162.5 79.8,160.3 82.4,161.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,121.6 79.8,120.1 79.8,117.9 82.4,119.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,143.1 79.8,141.6 79.8,139.4 82.4,140.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,130.6 79.8,129.1 79.8,126.8 82.4,128.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,168.2 79.8,166.7 79.8,164.4 82.4,165.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,125.8 79.8,124.3 79.8,122 82.4,123.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,134.8 79.8,133.3 79.8,131 82.4,132.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,138.9 79.8,137.4 79.8,135.2 82.4,136.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,147.3 79.8,145.8 79.8,143.5 82.4,145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,197.8 79.8,196.3 79.8,194 82.4,195.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,193.6 79.8,192.1 79.8,189.8 82.4,191.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,201.9 79.8,200.4 79.8,198.2 82.4,199.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,210.3 79.8,208.8 79.8,206.5 82.4,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,206.1 79.8,204.6 79.8,202.4 82.4,203.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,176.9 79.8,175.4 79.8,173.1 82.4,174.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,172.7 79.8,171.2 79.8,168.9 82.4,170.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,181 79.8,179.5 79.8,177.3 82.4,178.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,189.4 79.8,187.9 79.8,185.6 82.4,187.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,185.2 79.8,183.7 79.8,181.5 82.4,183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,66.9 79.8,65.4 79.8,63.1 82.4,64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,214.8 79.8,213.3 79.8,211 82.4,212.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "77,224.2 74.4,222.7 74.4,220.4 77,221.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,71.1 79.8,69.6 79.8,67.3 82.4,68.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,117.4 79.8,115.9 79.8,113.6 82.4,115.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,104.8 79.8,103.3 79.8,101 82.4,102.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,100.3 79.8,98.8 79.8,96.6 82.4,98.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,109 79.8,107.5 79.8,105.2 82.4,106.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,96.2 79.8,94.7 79.8,92.4 82.4,93.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,113.2 79.8,111.7 79.8,109.4 82.4,110.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,79.4 79.8,77.9 79.8,75.7 82.4,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,75.3 79.8,73.8 79.8,71.5 82.4,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,83.6 79.8,82.1 79.8,79.8 82.4,81.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,87.8 79.8,86.3 79.8,84 82.4,85.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,92 79.8,90.5 79.8,88.2 82.4,89.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,62.7 79.8,61.2 79.8,58.9 82.4,60.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,171 13.8,169.5 13.8,167.2 16.4,168.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,145.6 13.8,144.1 13.8,141.9 16.4,143.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,179.4 13.8,177.9 13.8,175.6 16.4,177.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,183.6 13.8,182.1 13.8,179.8 16.4,181.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,187.7 13.8,186.2 13.8,184 16.4,185.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,166.8 13.8,165.3 13.8,163.1 16.4,164.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,149.8 13.8,148.3 13.8,146.1 16.4,147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,162.7 13.8,161.2 13.8,158.9 16.4,160.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,154 13.8,152.5 13.8,150.2 16.4,151.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,158.5 13.8,157 13.8,154.7 16.4,156.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,175.2 13.8,173.7 13.8,171.4 16.4,172.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,217.3 13.8,215.8 13.8,213.5 16.4,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,191.9 13.8,190.4 13.8,188.2 16.4,189.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,213.1 13.8,211.6 13.8,209.3 16.4,210.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,221.5 13.8,220 13.8,217.7 16.4,219.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,196.1 13.8,194.6 13.8,192.3 16.4,193.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,200.6 13.8,199.1 13.8,196.8 16.4,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,219 79.8,217.5 79.8,215.2 82.4,216.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,208.9 13.8,207.4 13.8,205.2 16.4,206.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,204.8 13.8,203.3 13.8,201 16.4,202.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,141.5 13.8,140 13.8,137.7 16.4,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,223.1 79.8,221.6 79.8,219.4 82.4,220.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,128.9 13.8,127.4 13.8,125.2 16.4,126.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,124.7 13.8,123.2 13.8,121 16.4,122.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,120.6 13.8,119.1 13.8,116.8 16.4,118.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,133.1 13.8,131.6 13.8,129.3 16.4,130.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,137.3 13.8,135.8 13.8,133.5 16.4,135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,103.7 13.8,102.2 13.8,99.9 16.4,101.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,116.4 13.8,114.9 13.8,112.6 16.4,114.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,107.9 13.8,106.4 13.8,104.1 16.4,105.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.4,112.1 13.8,110.6 13.8,108.3 16.4,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,199.7 320,201.2 320,198.9 322.6,197.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,79.6 255.3,78.1 255.3,75.8 257.9,77.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,83.8 255.3,82.3 255.3,80 257.9,81.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,75.4 255.3,73.9 255.3,71.6 257.9,73.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,87.9 255.3,86.4 255.3,84.2 257.9,85.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,92.1 255.3,90.6 255.3,88.4 257.9,89.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,96.3 255.3,94.8 255.3,92.5 257.9,94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,214.6 330.8,216.1 330.8,213.9 333.4,212.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,223 330.8,224.5 330.8,222.2 333.4,220.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,218.8 330.8,220.3 330.8,218 333.4,216.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,67 255.3,65.5 255.3,63.3 257.9,64.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,71.2 255.3,69.7 255.3,67.4 257.9,68.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,129.7 255.3,128.2 255.3,126 257.9,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,100.5 255.3,99 255.3,96.7 257.9,98.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,133.9 255.3,132.4 255.3,130.2 257.9,131.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,138.1 255.3,136.6 255.3,134.3 257.9,135.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,121.4 255.3,119.9 255.3,117.6 257.9,119.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,125.6 255.3,124.1 255.3,121.8 257.9,123.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,104.7 255.3,103.2 255.3,100.9 257.9,102.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,108.8 255.3,107.3 255.3,105.1 257.9,106.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,117.2 255.3,115.7 255.3,113.4 257.9,114.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,113 255.3,111.5 255.3,109.3 257.9,110.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,210.4 330.8,211.9 330.8,209.7 333.4,208.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,151.3 330.8,152.8 330.8,150.6 333.4,149.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,143 330.8,144.5 330.8,142.2 333.4,140.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,147.2 330.8,148.7 330.8,146.4 333.4,144.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,142.6 255.3,141.1 255.3,138.8 257.9,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,155.8 330.8,157.3 330.8,155 333.4,153.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,134.6 330.8,136.1 330.8,133.8 333.4,132.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,126.3 330.8,127.8 330.8,125.5 333.4,124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,138.8 330.8,140.3 330.8,138 333.4,136.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,130.4 330.8,131.9 330.8,129.7 333.4,128.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,164.2 330.8,165.7 330.8,163.4 333.4,161.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,160 330.8,161.5 330.8,159.2 333.4,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,189.3 330.8,190.8 330.8,188.5 333.4,187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,122.1 330.8,123.6 330.8,121.3 333.4,119.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,197.9 330.8,199.4 330.8,197.1 333.4,195.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,202.1 330.8,203.6 330.8,201.3 333.4,199.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,168.3 330.8,169.9 330.8,167.6 333.4,166.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,206.3 330.8,207.8 330.8,205.5 333.4,204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,172.5 330.8,174 330.8,171.8 333.4,170.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,176.7 330.8,178.2 330.8,175.9 333.4,174.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,180.9 330.8,182.4 330.8,180.1 333.4,178.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,185.1 330.8,186.6 330.8,184.3 333.4,182.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,193.4 330.8,194.9 330.8,192.7 333.4,191.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,107.8 260.7,106.3 260.7,104 263.3,105.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,103.6 260.7,102.1 260.7,99.8 263.3,101.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,112 260.7,110.5 260.7,108.2 263.3,109.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,116.1 260.7,114.6 260.7,112.4 263.3,113.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,120.3 260.7,118.8 260.7,116.6 263.3,118.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,82.7 260.7,81.2 260.7,78.9 263.3,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,146.8 255.3,145.3 255.3,143 257.9,144.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,99.4 260.7,97.9 260.7,95.6 263.3,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,124.5 260.7,123 260.7,120.7 263.3,122.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,95.2 260.7,93.7 260.7,91.5 263.3,93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,91.1 260.7,89.6 260.7,87.3 263.3,88.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,158.2 260.7,156.7 260.7,154.5 263.3,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,149.9 260.7,148.4 260.7,146.1 263.3,147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,154.1 260.7,152.6 260.7,150.3 263.3,151.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,78.5 260.7,77 260.7,74.7 263.3,76.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,162.4 260.7,160.9 260.7,158.7 263.3,160.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,166.6 260.7,165.1 260.7,162.8 263.3,164.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,132.9 260.7,131.4 260.7,129.1 263.3,130.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,128.7 260.7,127.2 260.7,124.9 263.3,126.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,137 260.7,135.5 260.7,133.3 263.3,134.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,145.7 260.7,144.2 260.7,141.9 263.3,143.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,141.2 260.7,139.7 260.7,137.5 263.3,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,86.9 260.7,85.4 260.7,83.1 263.3,84.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,188.9 255.3,187.4 255.3,185.1 257.9,186.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,74.3 260.7,72.8 260.7,70.6 263.3,72.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,180.2 255.3,178.7 255.3,176.4 257.9,177.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,167.7 255.3,166.2 255.3,163.9 257.9,165.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,184.7 255.3,183.2 255.3,180.9 257.9,182.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,176 255.3,174.5 255.3,172.3 257.9,173.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,155.1 255.3,153.6 255.3,151.4 257.9,152.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,150.9 255.3,149.4 255.3,147.2 257.9,148.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,159.3 255.3,157.8 255.3,155.5 257.9,157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,163.5 255.3,162 255.3,159.7 257.9,161.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,171.8 255.3,170.3 255.3,168.1 257.9,169.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,222.3 255.3,220.8 255.3,218.5 257.9,220  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,218.1 255.3,216.6 255.3,214.4 257.9,215.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,70.2 260.7,68.7 260.7,66.4 263.3,67.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,213.9 255.3,212.4 255.3,210.2 257.9,211.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,197.2 255.3,195.7 255.3,193.5 257.9,195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,193 255.3,191.5 255.3,189.3 257.9,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,201.4 255.3,199.9 255.3,197.6 257.9,199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,205.6 255.3,204.1 255.3,201.8 257.9,203.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,209.8 255.3,208.3 255.3,206 257.9,207.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,191.3 320,192.8 320,190.5 322.6,189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,187.1 320,188.6 320,186.4 322.6,184.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,182.9 320,184.4 320,182.2 322.6,180.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,195.5 320,197 320,194.7 322.6,193.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,204.1 320,205.6 320,203.4 322.6,201.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,162 320,163.5 320,161.3 322.6,159.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,208.3 320,209.8 320,207.6 322.6,206.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,178.8 320,180.3 320,178 322.6,176.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,166.2 320,167.7 320,165.5 322.6,164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,170.4 320,171.9 320,169.6 322.6,168.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,174.6 320,176.1 320,173.8 322.6,172.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,195.2 204.2,193.7 204.2,191.4 206.8,192.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,212.5 320,214 320,211.7 322.6,210.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,170.8 260.7,169.3 260.7,167 263.3,168.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,216.7 320,218.2 320,215.9 322.6,214.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,220.9 320,222.4 320,220.1 322.6,218.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,157.6 320,159.1 320,156.8 322.6,155.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,153.4 320,154.9 320,152.6 322.6,151.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,107.1 320,108.6 320,106.3 322.6,104.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,102.9 320,104.4 320,102.1 322.6,100.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,136.7 320,138.2 320,135.9 322.6,134.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,140.8 320,142.3 320,140.1 322.6,138.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,132.5 320,134 320,131.7 322.6,130.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,145 320,146.5 320,144.3 322.6,142.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,149.2 320,150.7 320,148.4 322.6,146.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,124.1 320,125.6 320,123.4 322.6,121.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,115.4 320,116.9 320,114.7 322.6,113.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,119.9 320,121.4 320,119.2 322.6,117.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,111.2 320,112.7 320,110.5 322.6,109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.6,128.3 320,129.8 320,127.5 322.6,126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,163.1 325.4,164.6 325.4,162.3 328,160.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,209.4 325.4,210.9 325.4,208.6 328,207.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,217.7 325.4,219.2 325.4,217 328,215.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,221.9 325.4,223.4 325.4,221.2 328,219.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,205.2 325.4,206.7 325.4,204.4 328,202.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,192.4 325.4,193.9 325.4,191.6 328,190.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,196.6 325.4,198.1 325.4,195.8 328,194.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,201 325.4,202.5 325.4,200.3 328,198.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,105 330.8,106.5 330.8,104.2 333.4,102.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,100.8 330.8,102.3 330.8,100.1 333.4,98.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,109.2 330.8,110.7 330.8,108.4 333.4,106.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,113.7 330.8,115.2 330.8,112.9 333.4,111.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,96.7 330.8,98.2 330.8,95.9 333.4,94.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,188.2 325.4,189.7 325.4,187.4 328,185.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,213.6 325.4,215.1 325.4,212.8 328,211.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,125.2 325.4,126.7 325.4,124.4 328,122.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,121 325.4,122.5 325.4,120.2 328,118.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,129.4 325.4,130.9 325.4,128.6 328,127.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,133.5 325.4,135 325.4,132.8 328,131.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,116.8 325.4,118.3 325.4,116.1 328,114.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,137.7 325.4,139.2 325.4,137 328,135.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,184 325.4,185.5 325.4,183.2 328,181.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,112.3 325.4,113.8 325.4,111.5 328,110  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,99.8 325.4,101.3 325.4,99 328,97.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,108.1 325.4,109.6 325.4,107.4 328,105.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,103.9 325.4,105.4 325.4,103.2 328,101.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,167.3 325.4,168.8 325.4,166.5 328,165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "333.4,117.9 330.8,119.4 330.8,117.1 333.4,115.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,171.5 325.4,173 325.4,170.7 328,169.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,175.6 325.4,177.1 325.4,174.9 328,173.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,141.9 325.4,143.4 325.4,141.1 328,139.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,179.8 325.4,181.3 325.4,179.1 328,177.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,146.1 325.4,147.6 325.4,145.3 328,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,158.9 325.4,160.4 325.4,158.2 328,156.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,150.3 325.4,151.8 325.4,149.5 328,148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328,154.5 325.4,156 325.4,153.7 328,152.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,128.7 198.8,127.2 198.8,125 201.4,126.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,132.9 198.8,131.4 198.8,129.2 201.4,130.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,137.1 198.8,135.6 198.8,133.3 201.4,134.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,145.5 198.8,144 198.8,141.7 201.4,143.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,141.3 198.8,139.8 198.8,137.5 201.4,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,112 198.8,110.5 198.8,108.3 201.4,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,149.9 198.8,148.4 198.8,146.2 201.4,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,107.8 198.8,106.3 198.8,104.1 201.4,105.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,120.4 198.8,118.9 198.8,116.6 201.4,118.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,116.2 198.8,114.7 198.8,112.4 201.4,113.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,124.6 198.8,123.1 198.8,120.8 201.4,122.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,154.1 198.8,152.6 198.8,150.4 201.4,151.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,183.4 198.8,181.9 198.8,179.6 201.4,181.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,179.2 198.8,177.7 198.8,175.4 201.4,176.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,187.6 198.8,186.1 198.8,183.8 201.4,185.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,103.3 198.8,101.8 198.8,99.6 201.4,101.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,175 198.8,173.5 198.8,171.3 201.4,172.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,192 198.8,190.5 198.8,188.3 201.4,189.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,162.5 198.8,161 198.8,158.7 201.4,160.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,158.3 198.8,156.8 198.8,154.5 201.4,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,166.7 198.8,165.2 198.8,162.9 201.4,164.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,170.8 198.8,169.3 198.8,167.1 201.4,168.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,214 193.4,212.5 193.4,210.2 196,211.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,222.4 193.4,220.9 193.4,218.6 196,220.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,49 198.8,47.5 198.8,45.2 201.4,46.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,218.2 193.4,216.7 193.4,214.4 196,215.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,53.2 198.8,51.7 198.8,49.4 201.4,50.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,201.5 193.4,200 193.4,197.7 196,199.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,205.6 193.4,204.1 193.4,201.9 196,203.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,99.1 198.8,97.6 198.8,95.4 201.4,96.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,196.2 198.8,194.7 198.8,192.4 201.4,193.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,209.8 193.4,208.3 193.4,206.1 196,207.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,57.3 198.8,55.8 198.8,53.6 201.4,55.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,78.2 198.8,76.7 198.8,74.5 201.4,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,82.4 198.8,80.9 198.8,78.7 201.4,80.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,95 198.8,93.5 198.8,91.2 201.4,92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,90.8 198.8,89.3 198.8,87 201.4,88.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,86.6 198.8,85.1 198.8,82.8 201.4,84.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,65.7 198.8,64.2 198.8,61.9 201.4,63.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,74.1 198.8,72.6 198.8,70.3 201.4,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,61.5 198.8,60 198.8,57.7 201.4,59.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,69.9 198.8,68.4 198.8,66.1 201.4,67.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,221.3 198.8,219.8 198.8,217.5 201.4,219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,200.4 198.8,198.9 198.8,196.6 201.4,198.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,131.9 204.2,130.4 204.2,128.1 206.8,129.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,127.7 204.2,126.2 204.2,123.9 206.8,125.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,175 260.7,173.5 260.7,171.2 263.3,172.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,140.2 204.2,138.7 204.2,136.5 206.8,138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,123.5 204.2,122 204.2,119.7 206.8,121.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,111 204.2,109.5 204.2,107.2 206.8,108.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,115.1 204.2,113.6 204.2,111.4 206.8,112.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,119.3 204.2,117.8 204.2,115.5 206.8,117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,148.6 204.2,147.1 204.2,144.8 206.8,146.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,144.4 204.2,142.9 204.2,140.6 206.8,142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,174 204.2,172.5 204.2,170.2 206.8,171.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,182.3 204.2,180.8 204.2,178.6 206.8,180.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,178.1 204.2,176.6 204.2,174.4 206.8,175.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,186.5 204.2,185 204.2,182.7 206.8,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,190.7 204.2,189.2 204.2,186.9 206.8,188.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,157.2 204.2,155.7 204.2,153.5 206.8,155  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,161.4 204.2,159.9 204.2,157.6 206.8,159.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,153.1 204.2,151.6 204.2,149.3 206.8,150.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,169.8 204.2,168.3 204.2,166 206.8,167.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,165.6 204.2,164.1 204.2,161.8 206.8,163.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,136 204.2,134.5 204.2,132.3 206.8,133.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,197.3 193.4,195.8 193.4,193.5 196,195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,56.3 204.2,54.8 204.2,52.5 206.8,54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,52.1 204.2,50.6 204.2,48.3 206.8,49.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,204.6 198.8,203.1 198.8,200.8 201.4,202.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,208.8 198.8,207.3 198.8,205 201.4,206.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,212.9 198.8,211.4 198.8,209.2 201.4,210.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.4,217.1 198.8,215.6 198.8,213.4 201.4,214.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,81.4 204.2,79.9 204.2,77.6 206.8,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,85.5 204.2,84 204.2,81.8 206.8,83.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,89.7 204.2,88.2 204.2,85.9 206.8,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,102.3 204.2,100.8 204.2,98.5 206.8,100  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,98.1 204.2,96.6 204.2,94.3 206.8,95.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,93.9 204.2,92.4 204.2,90.1 206.8,91.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,77.2 204.2,75.7 204.2,73.4 206.8,74.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,64.6 204.2,63.1 204.2,60.9 206.8,62.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,68.8 204.2,67.3 204.2,65 206.8,66.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,60.5 204.2,59 204.2,56.7 206.8,58.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,73 204.2,71.5 204.2,69.2 206.8,70.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "206.8,106.4 204.2,104.9 204.2,102.7 206.8,104.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,127.6 266.1,126.1 266.1,123.8 268.7,125.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,131.8 266.1,130.3 266.1,128 268.7,129.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,136 266.1,134.5 266.1,132.2 268.7,133.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,140.2 266.1,138.7 266.1,136.4 268.7,137.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,144.3 266.1,142.8 266.1,140.6 268.7,142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,106.7 266.1,105.2 266.1,102.9 268.7,104.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,110.9 266.1,109.4 266.1,107.1 268.7,108.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,148.8 266.1,147.3 266.1,145 268.7,146.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,123.4 266.1,121.9 266.1,119.7 268.7,121.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,115.1 266.1,113.6 266.1,111.3 268.7,112.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,193.1 193.4,191.6 193.4,189.3 196,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,182.3 266.1,180.8 266.1,178.5 268.7,180  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,153 266.1,151.5 266.1,149.2 268.7,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,178.1 266.1,176.6 266.1,174.3 268.7,175.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,190.9 266.1,189.4 266.1,187.1 268.7,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,186.4 266.1,184.9 266.1,182.7 268.7,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,173.9 266.1,172.4 266.1,170.1 268.7,171.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,102.5 266.1,101 266.1,98.8 268.7,100.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,161.4 266.1,159.9 266.1,157.6 268.7,159.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,157.2 266.1,155.7 266.1,153.4 268.7,154.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,165.5 266.1,164 266.1,161.8 268.7,163.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,169.7 266.1,168.2 266.1,165.9 268.7,167.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,212.9 260.7,211.4 260.7,209.1 263.3,210.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,98.4 266.1,96.9 266.1,94.6 268.7,96.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,204.5 260.7,203 260.7,200.7 263.3,202.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,200.3 260.7,198.8 260.7,196.6 263.3,198.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,195.1 266.1,193.6 266.1,191.3 268.7,192.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,208.7 260.7,207.2 260.7,204.9 263.3,206.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,183.3 260.7,181.8 260.7,179.6 263.3,181.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,217.1 260.7,215.6 260.7,213.3 263.3,214.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,179.1 260.7,177.6 260.7,175.4 263.3,176.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,192 260.7,190.5 260.7,188.2 263.3,189.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,187.8 260.7,186.3 260.7,184 263.3,185.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,196.2 260.7,194.7 260.7,192.4 263.3,193.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,81.6 266.1,80.1 266.1,77.9 268.7,79.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,221.2 260.7,219.7 260.7,217.5 263.3,219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,85.8 266.1,84.3 266.1,82 268.7,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,90 266.1,88.5 266.1,86.2 268.7,87.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,94.2 266.1,92.7 266.1,90.4 268.7,91.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,77.4 266.1,75.9 266.1,73.7 268.7,75.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,73.3 266.1,71.8 266.1,69.5 268.7,71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "257.9,62.9 255.3,61.4 255.3,59.1 257.9,60.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.3,66 260.7,64.5 260.7,62.3 263.3,63.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,69.1 266.1,67.6 266.1,65.4 268.7,66.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,119.3 266.1,117.8 266.1,115.5 268.7,117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,134 193.4,132.5 193.4,130.2 196,131.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,125.6 193.4,124.1 193.4,121.9 196,123.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,129.8 193.4,128.3 193.4,126 196,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,142.4 193.4,140.9 193.4,138.6 196,140.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,104.7 193.4,103.2 193.4,101 196,102.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,138.2 193.4,136.7 193.4,134.4 196,135.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,108.9 193.4,107.4 193.4,105.1 196,106.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,121.4 193.4,119.9 193.4,117.7 196,119.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,113.1 193.4,111.6 193.4,109.3 196,110.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,117.3 193.4,115.8 193.4,113.5 196,115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,199.3 266.1,197.8 266.1,195.5 268.7,197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,180.3 193.4,178.8 193.4,176.5 196,178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,171.9 193.4,170.4 193.4,168.1 196,169.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,176.1 193.4,174.6 193.4,172.3 196,173.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,184.4 193.4,182.9 193.4,180.7 196,182.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,188.9 193.4,187.4 193.4,185.2 196,186.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,155.2 193.4,153.7 193.4,151.4 196,152.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,159.4 193.4,157.9 193.4,155.6 196,157.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,151 193.4,149.5 193.4,147.2 196,148.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,167.7 193.4,166.2 193.4,164 196,165.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,163.5 193.4,162 193.4,159.8 196,161.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,146.8 193.4,145.3 193.4,143.1 196,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,100.2 193.4,98.7 193.4,96.4 196,97.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,224.4 266.1,222.9 266.1,220.6 268.7,222.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,54.2 193.4,52.7 193.4,50.5 196,52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,50 193.4,48.5 193.4,46.3 196,47.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,45.9 193.4,44.4 193.4,42.1 196,43.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,203.5 266.1,202 266.1,199.7 268.7,201.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,207.6 266.1,206.1 266.1,203.9 268.7,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,211.8 266.1,210.3 266.1,208 268.7,209.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,216 266.1,214.5 266.1,212.2 268.7,213.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "268.7,220.2 266.1,218.7 266.1,216.4 268.7,217.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,87.7 193.4,86.2 193.4,83.9 196,85.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,79.3 193.4,77.8 193.4,75.5 196,77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,83.5 193.4,82 193.4,79.7 196,81.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,91.8 193.4,90.3 193.4,88.1 196,89.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,96 193.4,94.5 193.4,92.3 196,93.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,62.6 193.4,61.1 193.4,58.8 196,60.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,58.4 193.4,56.9 193.4,54.6 196,56.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,66.8 193.4,65.3 193.4,63 196,64.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,70.9 193.4,69.4 193.4,67.2 196,68.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "196,75.1 193.4,73.6 193.4,71.4 196,72.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,87.6 99.3,89.1 99.3,86.8 101.9,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,83.4 99.3,84.9 99.3,82.6 101.9,81.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,91.8 99.3,93.3 99.3,91 101.9,89.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,96.4 99.3,97.9 99.3,95.6 101.9,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,100.6 99.3,102.1 99.3,99.8 101.9,98.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,70.7 99.3,72.2 99.3,69.9 101.9,68.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,151.1 99.3,152.6 99.3,150.3 101.9,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,62.3 99.3,63.8 99.3,61.5 101.9,60  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,66.5 99.3,68 99.3,65.7 101.9,64.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,104.7 99.3,106.3 99.3,104 101.9,102.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,74.8 99.3,76.3 99.3,74.1 101.9,72.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,146.9 99.3,148.4 99.3,146.1 101.9,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,158.4 93.9,159.9 93.9,157.6 96.5,156.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,130.2 99.3,131.7 99.3,129.4 101.9,127.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,134.3 99.3,135.9 99.3,133.6 101.9,132.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,142.7 99.3,144.2 99.3,141.9 101.9,140.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,108.9 99.3,110.4 99.3,108.2 101.9,106.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,58.1 99.3,59.6 99.3,57.4 101.9,55.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,113.1 99.3,114.6 99.3,112.3 101.9,110.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,117.3 99.3,118.8 99.3,116.5 101.9,115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,121.8 99.3,123.3 99.3,121 101.9,119.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,126 99.3,127.5 99.3,125.2 101.9,123.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,79.2 99.3,80.7 99.3,78.4 101.9,76.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,183.7 93.9,185.2 93.9,183 96.5,181.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,187.9 93.9,189.4 93.9,187.2 96.5,185.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,192.1 93.9,193.6 93.9,191.3 96.5,189.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,179.6 93.9,181.1 93.9,178.8 96.5,177.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,196.3 93.9,197.8 93.9,195.5 96.5,194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,162.5 93.9,164.1 93.9,161.8 96.5,160.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,200.5 93.9,202 93.9,199.7 96.5,198.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,167 93.9,168.5 93.9,166.3 96.5,164.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,171.2 93.9,172.7 93.9,170.4 96.5,168.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,175.4 93.9,176.9 93.9,174.6 96.5,173.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,213.3 93.9,214.8 93.9,212.5 96.5,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,204.6 93.9,206.1 93.9,203.9 96.5,202.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,221.7 93.9,223.2 93.9,220.9 96.5,219.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,53.9 99.3,55.4 99.3,53.2 101.9,51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,209.1 93.9,210.6 93.9,208.4 96.5,206.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,217.5 93.9,219 93.9,216.7 96.5,215.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,138.5 99.3,140 99.3,137.8 101.9,136.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,80.3 104.7,81.8 104.7,79.5 107.3,78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,84.5 104.7,86 104.7,83.7 107.3,82.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,88.7 104.7,90.2 104.7,87.9 107.3,86.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,101.6 104.7,103.1 104.7,100.9 107.3,99.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,93.3 104.7,94.8 104.7,92.5 107.3,91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,59.2 104.7,60.7 104.7,58.4 107.3,56.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,67.5 104.7,69 104.7,66.8 107.3,65.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,63.4 104.7,64.9 104.7,62.6 107.3,61.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,71.7 104.7,73.2 104.7,71 107.3,69.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,76.1 104.7,77.6 104.7,75.3 107.3,73.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,97.5 104.7,99 104.7,96.7 107.3,95.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,135.4 104.7,136.9 104.7,134.6 107.3,133.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,127.1 104.7,128.6 104.7,126.3 107.3,124.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,131.2 104.7,132.7 104.7,130.5 107.3,129  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,139.6 104.7,141.1 104.7,138.8 107.3,137.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,105.8 104.7,107.3 104.7,105 107.3,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,143.8 104.7,145.3 104.7,143 107.3,141.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,114.2 104.7,115.7 104.7,113.4 107.3,111.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,110 104.7,111.5 104.7,109.2 107.3,107.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,122.9 104.7,124.4 104.7,122.1 107.3,120.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,118.7 104.7,120.2 104.7,117.9 107.3,116.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,184.8 99.3,186.3 99.3,184 101.9,182.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,180.6 99.3,182.1 99.3,179.9 101.9,178.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,176.4 99.3,177.9 99.3,175.7 101.9,174.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,189 99.3,190.5 99.3,188.2 101.9,186.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,197.4 99.3,198.9 99.3,196.6 101.9,195.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,193.2 99.3,194.7 99.3,192.4 101.9,190.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,159.4 99.3,160.9 99.3,158.7 101.9,157.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,172.3 99.3,173.8 99.3,171.5 101.9,170  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,163.9 99.3,165.4 99.3,163.1 101.9,161.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,168.1 99.3,169.6 99.3,167.3 101.9,165.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,214.4 99.3,215.9 99.3,213.6 101.9,212.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,222.7 99.3,224.2 99.3,222 101.9,220.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,50.8 104.7,52.3 104.7,50.1 107.3,48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,155.3 99.3,156.8 99.3,154.5 101.9,153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,210.2 99.3,211.7 99.3,209.4 101.9,207.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,218.5 99.3,220 99.3,217.8 101.9,216.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,201.5 99.3,203 99.3,200.8 101.9,199.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "101.9,206 99.3,207.5 99.3,205.2 101.9,203.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,55 104.7,56.5 104.7,54.2 107.3,52.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,220.6 88.5,222.1 88.5,219.8 91.1,218.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,98 88.5,99.5 88.5,97.2 91.1,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,102.6 88.5,104.1 88.5,101.9 91.1,100.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,106.8 88.5,108.3 88.5,106 91.1,104.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,111 88.5,112.5 88.5,110.2 91.1,108.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,93.8 88.5,95.3 88.5,93.1 91.1,91.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,81.1 88.5,82.6 88.5,80.3 91.1,78.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,89.6 88.5,91.1 88.5,88.9 91.1,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,115.2 88.5,116.7 88.5,114.4 91.1,112.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,76.9 88.5,78.4 88.5,76.1 91.1,74.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,85.4 88.5,86.9 88.5,84.7 91.1,83.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,72.7 88.5,74.2 88.5,71.9 91.1,70.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,119.3 88.5,120.8 88.5,118.6 91.1,117.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,144.8 88.5,146.3 88.5,144 91.1,142.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,157.3 88.5,158.8 88.5,156.5 91.1,155  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,140.6 88.5,142.1 88.5,139.8 91.1,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,153.1 88.5,154.6 88.5,152.4 91.1,150.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,148.9 88.5,150.4 88.5,148.2 91.1,146.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,136.4 88.5,137.9 88.5,135.6 91.1,134.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,123.5 88.5,125 88.5,122.8 91.1,121.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,128 88.5,129.5 88.5,127.3 91.1,125.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,132.2 88.5,133.7 88.5,131.5 91.1,130  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,68.5 88.5,70 88.5,67.8 91.1,66.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,184.3 171.8,185.8 171.8,183.5 174.4,182  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,188.7 171.8,190.2 171.8,188 174.4,186.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,180.1 171.8,181.6 171.8,179.3 174.4,177.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,192.9 171.8,194.4 171.8,192.1 174.4,190.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,197.1 171.8,198.6 171.8,196.3 174.4,194.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,175.9 171.8,177.4 171.8,175.1 174.4,173.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,163.4 171.8,164.9 171.8,162.6 174.4,161.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,167.5 171.8,169 171.8,166.8 174.4,165.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,205.5 171.8,207 171.8,204.7 174.4,203.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,171.7 171.8,173.2 171.8,170.9 174.4,169.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,161.5 88.5,163 88.5,160.7 91.1,159.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,154.2 93.9,155.7 93.9,153.4 96.5,151.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,60.2 88.5,61.7 88.5,59.4 91.1,57.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,64.4 88.5,65.9 88.5,63.6 91.1,62.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,213.8 171.8,215.3 171.8,213 174.4,211.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,209.6 171.8,211.1 171.8,208.9 174.4,207.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,218 171.8,219.5 171.8,217.2 174.4,215.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,222.2 171.8,223.7 171.8,221.4 174.4,219.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,94.9 93.9,96.4 93.9,94.1 96.5,92.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,90.7 93.9,92.2 93.9,89.9 96.5,88.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,103.7 93.9,105.2 93.9,102.9 96.5,101.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,99.5 93.9,101 93.9,98.7 96.5,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,107.9 93.9,109.4 93.9,107.1 96.5,105.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,86.5 93.9,88 93.9,85.8 96.5,84.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,69.6 93.9,71.1 93.9,68.8 96.5,67.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,73.8 93.9,75.3 93.9,73 96.5,71.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,82.3 93.9,83.8 93.9,81.5 96.5,80  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,78 93.9,79.5 93.9,77.2 96.5,75.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,129.1 93.9,130.6 93.9,128.3 96.5,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,112 93.9,113.5 93.9,111.3 96.5,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,137.5 93.9,139 93.9,136.7 96.5,135.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,145.8 93.9,147.3 93.9,145.1 96.5,143.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,133.3 93.9,134.8 93.9,132.5 96.5,131  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,150 93.9,151.5 93.9,149.2 96.5,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,141.6 93.9,143.1 93.9,140.9 96.5,139.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,120.4 93.9,121.9 93.9,119.6 96.5,118.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,165.7 88.5,167.2 88.5,164.9 91.1,163.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,159.2 171.8,160.7 171.8,158.4 174.4,156.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,65.4 93.9,66.9 93.9,64.6 96.5,63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,116.2 93.9,117.7 93.9,115.5 96.5,114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,195.2 88.5,196.7 88.5,194.5 91.1,193  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,191 88.5,192.5 88.5,190.3 91.1,188.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,203.6 88.5,205.1 88.5,202.8 91.1,201.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,199.4 88.5,200.9 88.5,198.6 91.1,197.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,207.8 88.5,209.3 88.5,207 91.1,205.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,186.9 88.5,188.4 88.5,186.1 91.1,184.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,170.1 88.5,171.6 88.5,169.4 91.1,167.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,61.2 93.9,62.7 93.9,60.5 96.5,59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,182.7 88.5,184.2 88.5,181.9 91.1,180.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,178.5 88.5,180 88.5,177.7 91.1,176.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,174.3 88.5,175.8 88.5,173.6 91.1,172.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,57.1 93.9,58.6 93.9,56.3 96.5,54.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,216.4 88.5,217.9 88.5,215.6 91.1,214.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,148 104.7,149.5 104.7,147.2 107.3,145.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.1,212.2 88.5,213.7 88.5,211.5 91.1,210  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "96.5,124.9 93.9,126.4 93.9,124.2 96.5,122.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,148.3 43.3,149.8 43.3,147.6 45.9,146.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,152.5 43.3,154 43.3,151.7 45.9,150.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,157 43.3,158.5 43.3,156.2 45.9,154.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,161.2 43.3,162.7 43.3,160.4 45.9,158.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,165.3 43.3,166.8 43.3,164.6 45.9,163.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,169.5 43.3,171 43.3,168.7 45.9,167.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,127.4 43.3,128.9 43.3,126.7 45.9,125.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,131.6 43.3,133.1 43.3,130.8 45.9,129.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,135.8 43.3,137.3 43.3,135 45.9,133.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,140 43.3,141.5 43.3,139.2 45.9,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,144.1 43.3,145.6 43.3,143.4 45.9,141.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,177.9 43.3,179.4 43.3,177.1 45.9,175.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,173.7 43.3,175.2 43.3,172.9 45.9,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,203.3 43.3,204.8 43.3,202.5 45.9,201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,199.1 43.3,200.6 43.3,198.3 45.9,196.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,211.6 43.3,213.1 43.3,210.8 45.9,209.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,207.4 43.3,208.9 43.3,206.7 45.9,205.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,194.6 43.3,196.1 43.3,193.8 45.9,192.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,123.2 43.3,124.7 43.3,122.5 45.9,121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,182.1 43.3,183.6 43.3,181.3 45.9,179.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,186.2 43.3,187.7 43.3,185.5 45.9,184  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,190.4 43.3,191.9 43.3,189.7 45.9,188.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,223.1 37.9,224.6 37.9,222.3 40.5,220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,215.8 43.3,217.3 43.3,215 45.9,213.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,197.7 37.9,199.2 37.9,196.9 40.5,195.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,152.1 104.7,153.6 104.7,151.4 107.3,149.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,202.2 37.9,203.7 37.9,201.4 40.5,199.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,214.7 37.9,216.2 37.9,214 40.5,212.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,206.4 37.9,207.9 37.9,205.6 40.5,204.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,210.5 37.9,212 37.9,209.8 40.5,208.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,105.9 43.3,107.4 43.3,105.2 45.9,103.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,102.2 43.3,103.7 43.3,101.4 45.9,99.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,119.1 43.3,120.6 43.3,118.3 45.9,116.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,114.9 43.3,116.4 43.3,114.1 45.9,112.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,110.1 43.3,111.6 43.3,109.4 45.9,107.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,218.9 37.9,220.4 37.9,218.1 40.5,216.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,170.6 48.7,172.1 48.7,169.8 51.3,168.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,174.8 48.7,176.3 48.7,174 51.3,172.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,178.9 48.7,180.4 48.7,178.2 51.3,176.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,187.3 48.7,188.8 48.7,186.5 51.3,185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,183.1 48.7,184.6 48.7,182.4 51.3,180.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,162.2 48.7,163.7 48.7,161.5 51.3,160  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,153.9 48.7,155.4 48.7,153.1 51.3,151.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,166.4 48.7,167.9 48.7,165.6 51.3,164.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,158 48.7,159.5 48.7,157.3 51.3,155.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,191.5 48.7,193 48.7,190.7 51.3,189.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,221 48.7,222.5 48.7,220.3 51.3,218.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,149.4 48.7,150.9 48.7,148.6 51.3,147.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,216.9 48.7,218.4 48.7,216.1 51.3,214.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,204.3 48.7,205.8 48.7,203.5 51.3,202  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,212.7 48.7,214.2 48.7,211.9 51.3,210.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,200.1 48.7,201.6 48.7,199.4 51.3,197.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,196 48.7,197.5 48.7,195.2 51.3,193.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,208.5 48.7,210 48.7,207.7 51.3,206.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,99.1 48.7,100.6 48.7,98.3 51.3,96.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.9,220 43.3,221.5 43.3,219.2 45.9,217.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,145.2 48.7,146.7 48.7,144.4 51.3,142.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,128.5 48.7,130 48.7,127.7 51.3,126.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,132.7 48.7,134.2 48.7,131.9 51.3,130.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,136.8 48.7,138.3 48.7,136.1 51.3,134.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,124.3 48.7,125.8 48.7,123.5 51.3,122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,141 48.7,142.5 48.7,140.3 51.3,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,115.9 48.7,117.4 48.7,115.2 51.3,113.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,120.1 48.7,121.6 48.7,119.4 51.3,117.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,111.8 48.7,113.3 48.7,111 51.3,109.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,107 48.7,108.5 48.7,106.2 51.3,104.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "51.3,102.8 48.7,104.3 48.7,102.1 51.3,100.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,133.6 32.5,135.1 32.5,132.9 35.1,131.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,112.2 32.5,113.7 32.5,111.4 35.1,109.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,116.4 32.5,117.9 32.5,115.6 35.1,114.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,125.3 32.5,126.8 32.5,124.5 35.1,123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,129.5 32.5,131 32.5,128.7 35.1,127.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,121.1 32.5,122.6 32.5,120.3 35.1,118.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,179.9 32.5,181.4 32.5,179.2 35.1,177.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,108.4 32.5,109.9 32.5,107.6 35.1,106.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,163.2 32.5,164.7 32.5,162.4 35.1,160.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,167.4 32.5,168.9 32.5,166.6 35.1,165.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,171.6 32.5,173.1 32.5,170.8 35.1,169.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,158.7 32.5,160.2 32.5,158 35.1,156.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,175.7 32.5,177.2 32.5,175 35.1,173.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,142 32.5,143.5 32.5,141.2 35.1,139.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,137.8 32.5,139.3 32.5,137.1 35.1,135.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,146.2 32.5,147.7 32.5,145.4 35.1,143.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,154.6 32.5,156.1 32.5,153.8 35.1,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,150.4 32.5,151.9 32.5,149.6 35.1,148.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,177.5 104.7,179 104.7,176.7 107.3,175.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,181.7 104.7,183.2 104.7,180.9 107.3,179.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,190.1 104.7,191.6 104.7,189.3 107.3,187.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,185.9 104.7,187.4 104.7,185.1 107.3,183.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,194.2 104.7,195.7 104.7,193.5 107.3,192  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,160.8 104.7,162.3 104.7,160 107.3,158.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,156.3 104.7,157.8 104.7,155.6 107.3,154.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,165 104.7,166.5 104.7,164.2 107.3,162.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,169.2 104.7,170.7 104.7,168.4 107.3,166.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,173.3 104.7,174.8 104.7,172.6 107.3,171.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,193.5 37.9,195 37.9,192.8 40.5,191.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,219.6 104.7,221.1 104.7,218.8 107.3,217.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,198.4 104.7,199.9 104.7,197.6 107.3,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,202.9 104.7,204.4 104.7,202.1 107.3,200.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,207.1 104.7,208.6 104.7,206.3 107.3,204.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,211.2 104.7,212.7 104.7,210.5 107.3,209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "107.3,215.4 104.7,216.9 104.7,214.7 107.3,213.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,130.5 37.9,132 37.9,129.8 40.5,128.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,134.7 37.9,136.2 37.9,133.9 40.5,132.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,143.1 37.9,144.6 37.9,142.3 40.5,140.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,126.4 37.9,127.9 37.9,125.6 40.5,124.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,138.9 37.9,140.4 37.9,138.1 40.5,136.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,109.1 37.9,110.6 37.9,108.3 40.5,106.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,147.3 37.9,148.8 37.9,146.5 40.5,145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,113.2 37.9,114.7 37.9,112.5 40.5,111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,122.2 37.9,123.7 37.9,121.4 40.5,119.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,118 37.9,119.5 37.9,117.2 40.5,115.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,164.3 37.9,165.8 37.9,163.5 40.5,162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,176.8 37.9,178.3 37.9,176 40.5,174.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,181 37.9,182.5 37.9,180.2 40.5,178.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,172.6 37.9,174.1 37.9,171.9 40.5,170.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,185.2 37.9,186.7 37.9,184.4 40.5,182.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,189.4 37.9,190.9 37.9,188.6 40.5,187.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,151.4 37.9,152.9 37.9,150.7 40.5,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,168.4 37.9,170 37.9,167.7 40.5,166.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,155.6 37.9,157.1 37.9,154.9 40.5,153.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,160.1 37.9,161.6 37.9,159.3 40.5,157.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "40.5,105.3 37.9,106.8 37.9,104.5 40.5,103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,213.7 32.5,215.2 32.5,212.9 35.1,211.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,209.5 32.5,211 32.5,208.7 35.1,207.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,184.1 32.5,185.6 32.5,183.3 35.1,181.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,205.3 32.5,206.8 32.5,204.5 35.1,203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,222 32.5,223.5 32.5,221.3 35.1,219.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,217.8 32.5,219.3 32.5,217.1 35.1,215.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,188.3 32.5,189.8 32.5,187.5 35.1,186  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,192.5 32.5,194 32.5,191.7 35.1,190.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,200.8 32.5,202.3 32.5,200.1 35.1,198.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "35.1,196.7 32.5,198.2 32.5,195.9 35.1,194.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,201.3 171.8,202.8 171.8,200.5 174.4,199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,222.9 274.6,224.4 274.6,222.1 277.2,220.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,68.7 280,70.2 280,67.9 282.6,66.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,202 274.6,203.5 274.6,201.2 277.2,199.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,72.8 280,74.3 280,72.1 282.6,70.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,206.1 274.6,207.6 274.6,205.4 277.2,203.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,197.8 274.6,199.3 274.6,197 277.2,195.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,214.5 274.6,216 274.6,213.7 277.2,212.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,218.7 274.6,220.2 274.6,217.9 277.2,216.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,210.3 274.6,211.8 274.6,209.5 277.2,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,106.3 280,107.8 280,105.5 282.6,104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,102.1 280,103.6 280,101.3 282.6,99.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,110.5 280,112 280,109.7 282.6,108.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,97.9 280,99.4 280,97.2 282.6,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,114.6 280,116.1 280,113.9 282.6,112.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,93.7 280,95.2 280,93 282.6,91.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,81.2 280,82.7 280,80.4 282.6,78.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,77 280,78.5 280,76.2 282.6,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,85.4 280,86.9 280,84.6 282.6,83.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,89.6 280,91.1 280,88.8 282.6,87.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,126.1 274.6,127.6 274.6,125.4 277.2,123.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,130.3 274.6,131.8 274.6,129.5 277.2,128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,134.5 274.6,136 274.6,133.7 277.2,132.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,118.8 280,120.3 280,118.1 282.6,116.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,138.7 274.6,140.2 274.6,137.9 277.2,136.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,193.6 274.6,195.1 274.6,192.8 277.2,191.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,147.3 274.6,148.8 274.6,146.5 277.2,145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,121.9 274.6,123.4 274.6,121.2 277.2,119.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,109.4 274.6,110.9 274.6,108.6 277.2,107.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,113.6 274.6,115.1 274.6,112.8 277.2,111.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,117.8 274.6,119.3 274.6,117 277.2,115.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,142.8 274.6,144.3 274.6,142.1 277.2,140.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,180.8 274.6,182.3 274.6,180 277.2,178.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,176.6 274.6,178.1 274.6,175.8 277.2,174.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,184.9 274.6,186.4 274.6,184.2 277.2,182.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,151.5 274.6,153 274.6,150.7 277.2,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,172.4 274.6,173.9 274.6,171.6 277.2,170.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,189.4 274.6,190.9 274.6,188.6 277.2,187.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,159.9 274.6,161.4 274.6,159.1 277.2,157.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,155.7 274.6,157.2 274.6,154.9 277.2,153.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,168.2 274.6,169.7 274.6,167.4 277.2,165.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,164 274.6,165.5 274.6,163.3 277.2,161.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,107.4 215.8,108.9 215.8,106.7 218.4,105.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,61.5 215.8,63 215.8,60.7 218.4,59.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,57.3 215.8,58.8 215.8,56.5 218.4,55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,65.6 215.8,67.1 215.8,64.9 218.4,63.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,74 215.8,75.5 215.8,73.2 218.4,71.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,69.8 215.8,71.3 215.8,69.1 218.4,67.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,53.1 215.8,54.6 215.8,52.3 218.4,50.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,219.7 280,221.2 280,219 282.6,217.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,215.6 280,217.1 280,214.8 282.6,213.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,103.3 215.8,104.8 215.8,102.5 218.4,101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,105.2 274.6,106.7 274.6,104.4 277.2,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,116.1 215.8,117.6 215.8,115.4 218.4,113.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,123 280,124.5 280,122.2 282.6,120.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,78.2 215.8,79.7 215.8,77.4 218.4,75.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,112 215.8,113.5 215.8,111.2 218.4,109.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,94.9 215.8,96.4 215.8,94.1 218.4,92.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,86.5 215.8,88 215.8,85.8 218.4,84.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,82.4 215.8,83.9 215.8,81.6 218.4,80.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,90.7 215.8,92.2 215.8,90 218.4,88.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,99.1 215.8,100.6 215.8,98.3 218.4,96.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,144.2 280,145.7 280,143.4 282.6,141.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,152.6 280,154.1 280,151.8 282.6,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,148.4 280,149.9 280,147.6 282.6,146.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,156.7 280,158.2 280,156 282.6,154.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,160.9 280,162.4 280,160.2 282.6,158.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,139.7 280,141.2 280,139 282.6,137.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,127.2 280,128.7 280,126.4 282.6,124.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,131.4 280,132.9 280,130.6 282.6,129.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,135.5 280,137 280,134.8 282.6,133.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,165.1 280,166.6 280,164.3 282.6,162.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,207.2 280,208.7 280,206.4 282.6,204.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,194.7 280,196.2 280,193.9 282.6,192.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,198.8 280,200.3 280,198.1 282.6,196.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,190.5 280,192 280,189.7 282.6,188.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,211.4 280,212.9 280,210.6 282.6,209.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,203 280,204.5 280,202.2 282.6,200.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,181.8 280,183.3 280,181.1 282.6,179.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,186.3 280,187.8 280,185.5 282.6,184  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,177.6 280,179.1 280,176.9 282.6,175.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,173.5 280,175 280,172.7 282.6,171.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,169.3 280,170.8 280,168.5 282.6,167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,193.5 314.2,192 314.2,189.7 316.8,191.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,207.4 308.8,205.9 308.8,203.6 311.4,205.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,190.4 308.8,188.9 308.8,186.6 311.4,188.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,203.2 308.8,201.7 308.8,199.5 311.4,201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,198.8 308.8,197.3 308.8,195 311.4,196.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,161.1 308.8,159.6 308.8,157.4 311.4,158.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,165.3 308.8,163.8 308.8,161.5 311.4,163  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,169.5 308.8,168 308.8,165.7 311.4,167.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,177.8 308.8,176.3 308.8,174.1 311.4,175.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,173.7 308.8,172.2 308.8,169.9 311.4,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,182 308.8,180.5 308.8,178.3 311.4,179.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,194.6 308.8,193.1 308.8,190.8 311.4,192.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,211.6 308.8,210.1 308.8,207.8 311.4,209.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,219.9 308.8,218.4 308.8,216.2 311.4,217.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,215.8 308.8,214.3 308.8,212 311.4,213.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,224.1 308.8,222.6 308.8,220.4 311.4,221.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,186.2 308.8,184.7 308.8,182.4 311.4,183.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,106.1 308.8,104.6 308.8,102.4 311.4,103.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,110.3 308.8,108.8 308.8,106.6 311.4,108.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,102 308.8,100.5 308.8,98.2 311.4,99.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,127.4 308.8,125.9 308.8,123.6 311.4,125.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,144.1 308.8,142.6 308.8,140.3 311.4,141.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,139.9 308.8,138.4 308.8,136.2 311.4,137.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,152.5 308.8,151 308.8,148.7 311.4,150.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,135.7 308.8,134.2 308.8,132 311.4,133.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,148.3 308.8,146.8 308.8,144.5 311.4,146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,119 308.8,117.5 308.8,115.3 311.4,116.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,123.2 308.8,121.7 308.8,119.4 311.4,120.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,114.5 308.8,113 308.8,110.7 311.4,112.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,156.7 308.8,155.2 308.8,152.9 311.4,154.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.4,131.6 308.8,130.1 308.8,127.8 311.4,129.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,147.2 314.2,145.7 314.2,143.5 316.8,145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,218.9 314.2,217.4 314.2,215.1 316.8,216.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,214.7 314.2,213.2 314.2,210.9 316.8,212.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,223.1 314.2,221.6 314.2,219.3 316.8,220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,210.5 314.2,209 314.2,206.8 316.8,208.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,206.3 314.2,204.8 314.2,202.6 316.8,204.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,120.3 215.8,121.8 215.8,119.6 218.4,118.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,197.7 314.2,196.2 314.2,193.9 316.8,195.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,201.9 314.2,200.4 314.2,198.1 316.8,199.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,96.9 274.6,98.4 274.6,96.1 277.2,94.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,88.5 274.6,90 274.6,87.7 277.2,86.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,92.7 274.6,94.2 274.6,91.9 277.2,90.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,189.3 314.2,187.8 314.2,185.6 316.8,187.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,80.1 274.6,81.6 274.6,79.4 277.2,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,84.3 274.6,85.8 274.6,83.5 277.2,82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,75.9 274.6,77.4 274.6,75.2 277.2,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,71.8 274.6,73.3 274.6,71 277.2,69.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.6,64.5 280,66 280,63.8 282.6,62.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,67.6 274.6,69.1 274.6,66.9 277.2,65.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,176.8 314.2,175.3 314.2,173 316.8,174.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,117.6 314.2,116.1 314.2,113.9 316.8,115.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,122.1 314.2,120.6 314.2,118.4 316.8,119.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,126.3 314.2,124.8 314.2,122.6 316.8,124.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,134.7 314.2,133.2 314.2,130.9 316.8,132.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,130.5 314.2,129 314.2,126.7 316.8,128.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,138.9 314.2,137.4 314.2,135.1 316.8,136.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,105.1 314.2,103.6 314.2,101.3 316.8,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,113.4 314.2,111.9 314.2,109.7 316.8,111.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,109.3 314.2,107.8 314.2,105.5 316.8,107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,159.8 314.2,158.3 314.2,156 316.8,157.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,164.2 314.2,162.7 314.2,160.5 316.8,162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,172.6 314.2,171.1 314.2,168.8 316.8,170.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,168.4 314.2,166.9 314.2,164.7 316.8,166.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,143 314.2,141.5 314.2,139.3 316.8,140.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,181 314.2,179.5 314.2,177.2 316.8,178.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.2,101 274.6,102.5 274.6,100.3 277.2,98.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,151.4 314.2,149.9 314.2,147.6 316.8,149.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,155.6 314.2,154.1 314.2,151.8 316.8,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.8,185.1 314.2,183.6 314.2,181.4 316.8,182.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,129.6 171.8,131.1 171.8,128.9 174.4,127.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,202.5 226.6,204 226.6,201.7 229.2,200.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,78.1 166.4,79.6 166.4,77.3 169,75.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,215 226.6,216.5 226.6,214.2 229.2,212.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,206.6 226.6,208.1 226.6,205.9 229.2,204.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,210.8 226.6,212.3 226.6,210.1 229.2,208.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,219.2 226.6,220.7 226.6,218.4 229.2,216.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,86.7 166.4,88.2 166.4,86 169,84.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,82.6 166.4,84.1 166.4,81.8 169,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,116 166.4,117.5 166.4,115.2 169,113.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,120.2 166.4,121.7 166.4,119.4 169,117.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,111.8 166.4,113.3 166.4,111.1 169,109.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,128.6 166.4,130.1 166.4,127.8 169,126.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,90.9 166.4,92.4 166.4,90.2 169,88.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,124.5 215.8,126 215.8,123.7 218.4,122.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,95.1 166.4,96.6 166.4,94.3 169,92.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,99.3 166.4,100.8 166.4,98.5 169,97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,103.5 166.4,105 166.4,102.7 169,101.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,107.6 166.4,109.1 166.4,106.9 169,105.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,152 226.6,153.5 226.6,151.2 229.2,149.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,135 226.6,136.5 226.6,134.2 229.2,132.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,139.2 226.6,140.7 226.6,138.4 229.2,136.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,143.4 226.6,144.9 226.6,142.6 229.2,141.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,147.8 226.6,149.3 226.6,147.1 229.2,145.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,109.9 226.6,111.4 226.6,109.1 229.2,107.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,130.8 226.6,132.3 226.6,130 229.2,128.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,118.3 226.6,119.8 226.6,117.5 229.2,116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,198.3 226.6,199.8 226.6,197.5 229.2,196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,122.5 226.6,124 226.6,121.7 229.2,120.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,126.6 226.6,128.1 226.6,125.9 229.2,124.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,114.1 226.6,115.6 226.6,113.3 229.2,111.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,185.5 226.6,187 226.6,184.7 229.2,183.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,181.3 226.6,182.8 226.6,180.5 229.2,179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,194.1 226.6,195.6 226.6,193.3 229.2,191.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,189.9 226.6,191.4 226.6,189.2 229.2,187.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,177.1 226.6,178.6 226.6,176.3 229.2,174.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,164.5 226.6,166 226.6,163.8 229.2,162.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,172.9 226.6,174.4 226.6,172.1 229.2,170.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,160.4 226.6,161.9 226.6,159.6 229.2,158.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,156.2 226.6,157.7 226.6,155.4 229.2,153.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,168.7 226.6,170.2 226.6,168 229.2,166.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,132.7 166.4,134.2 166.4,132 169,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,92 171.8,93.5 171.8,91.2 174.4,89.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,108.7 171.8,110.2 171.8,107.9 174.4,106.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,96.2 171.8,97.7 171.8,95.4 174.4,93.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,104.5 171.8,106 171.8,103.8 174.4,102.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,100.4 171.8,101.9 171.8,99.6 174.4,98.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,87.8 171.8,89.3 171.8,87 174.4,85.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,75 171.8,76.5 171.8,74.2 174.4,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,79.4 171.8,80.9 171.8,78.7 174.4,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,83.6 171.8,85.1 171.8,82.9 174.4,81.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,133.8 171.8,135.3 171.8,133 174.4,131.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,112.9 171.8,114.4 171.8,112.1 174.4,110.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,142.2 171.8,143.7 171.8,141.4 174.4,139.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,146.6 171.8,148.1 171.8,145.9 174.4,144.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,150.8 171.8,152.3 171.8,150 174.4,148.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,138 171.8,139.5 171.8,137.2 174.4,135.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,155 171.8,156.5 171.8,154.2 174.4,152.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,121.3 171.8,122.8 171.8,120.5 174.4,119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,117.1 171.8,118.6 171.8,116.3 174.4,114.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "174.4,125.4 171.8,126.9 171.8,124.7 174.4,123.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,216.9 166.4,218.4 166.4,216.2 169,214.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,166.5 166.4,168 166.4,165.7 169,164.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,162.3 166.4,163.8 166.4,161.5 169,160  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,174.8 166.4,176.3 166.4,174.1 169,172.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,158.1 166.4,159.6 166.4,157.3 169,155.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,170.7 166.4,172.2 166.4,169.9 169,168.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,141.1 166.4,142.6 166.4,140.3 169,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,145.3 166.4,146.8 166.4,144.5 169,143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,179 166.4,180.5 166.4,178.2 169,176.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,149.7 166.4,151.2 166.4,149 169,147.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,153.9 166.4,155.4 166.4,153.2 169,151.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,136.9 166.4,138.4 166.4,136.1 169,134.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,208.6 166.4,210.1 166.4,207.8 169,206.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,212.7 166.4,214.2 166.4,212 169,210.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,183.2 166.4,184.7 166.4,182.4 169,180.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,221.1 166.4,222.6 166.4,220.3 169,218.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,204.4 166.4,205.9 166.4,203.6 169,202.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,191.8 166.4,193.3 166.4,191.1 169,189.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,200.2 166.4,201.7 166.4,199.4 169,197.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,187.4 166.4,188.9 166.4,186.6 169,185.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,196 166.4,197.5 166.4,195.3 169,193.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169,124.4 166.4,125.9 166.4,123.6 169,122.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,66.7 221.2,68.2 221.2,65.9 223.8,64.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,50 221.2,51.5 221.2,49.2 223.8,47.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,54.2 221.2,55.7 221.2,53.4 223.8,51.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,62.5 221.2,64 221.2,61.8 223.8,60.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,58.3 221.2,59.8 221.2,57.6 223.8,56.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,217.1 215.8,218.6 215.8,216.3 218.4,214.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,221.2 215.8,222.7 215.8,220.5 218.4,219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,91.8 221.2,93.3 221.2,91 223.8,89.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,100.1 221.2,101.6 221.2,99.4 223.8,97.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,96 221.2,97.5 221.2,95.2 223.8,93.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,108.8 221.2,110.3 221.2,108.1 223.8,106.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,104.3 221.2,105.8 221.2,103.6 223.8,102.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,79.2 221.2,80.7 221.2,78.5 223.8,77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,75.1 221.2,76.6 221.2,74.3 223.8,72.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,70.9 221.2,72.4 221.2,70.1 223.8,68.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,83.4 221.2,84.9 221.2,82.7 223.8,81.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,87.6 221.2,89.1 221.2,86.8 223.8,85.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,158.2 215.8,159.7 215.8,157.5 218.4,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,145.4 215.8,146.9 215.8,144.6 218.4,143.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,166.6 215.8,168.1 215.8,165.8 218.4,164.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,149.6 215.8,151.1 215.8,148.8 218.4,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,113 221.2,114.5 221.2,112.3 223.8,110.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,162.4 215.8,163.9 215.8,161.7 218.4,160.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,154.1 215.8,155.6 215.8,153.3 218.4,151.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,128.7 215.8,130.2 215.8,127.9 218.4,126.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,141.2 215.8,142.7 215.8,140.5 218.4,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,132.9 215.8,134.4 215.8,132.1 218.4,130.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,137 215.8,138.5 215.8,136.3 218.4,134.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,191.7 215.8,193.2 215.8,190.9 218.4,189.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,196.2 215.8,197.7 215.8,195.4 218.4,193.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,212.9 215.8,214.4 215.8,212.1 218.4,210.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,170.8 215.8,172.3 215.8,170 218.4,168.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,204.5 215.8,206 215.8,203.7 218.4,202.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,208.7 215.8,210.2 215.8,207.9 218.4,206.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,200.3 215.8,201.8 215.8,199.6 218.4,198.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,187.5 215.8,189 215.8,186.7 218.4,185.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,175 215.8,176.5 215.8,174.2 218.4,172.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,179.1 215.8,180.6 215.8,178.4 218.4,176.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.4,183.3 215.8,184.8 215.8,182.6 218.4,181.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,133.9 221.2,135.4 221.2,133.2 223.8,131.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,46.9 226.6,48.4 226.6,46.1 229.2,44.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,51 226.6,52.5 226.6,50.3 229.2,48.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,55.2 226.6,56.7 226.6,54.5 229.2,53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,59.4 226.6,60.9 226.6,58.6 229.2,57.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,213.9 221.2,215.4 221.2,213.2 223.8,211.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,218.1 221.2,219.6 221.2,217.4 223.8,215.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,222.3 221.2,223.8 221.2,221.5 223.8,220  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,88.7 226.6,90.2 226.6,87.9 229.2,86.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,84.5 226.6,86 226.6,83.7 229.2,82.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,92.9 226.6,94.4 226.6,92.1 229.2,90.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,209.8 221.2,211.3 221.2,209 223.8,207.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,101.2 226.6,102.7 226.6,100.4 229.2,98.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,97 226.6,98.5 226.6,96.3 229.2,94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,63.6 226.6,65.1 226.6,62.8 229.2,61.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,67.8 226.6,69.3 226.6,67 229.2,65.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,71.9 226.6,73.4 226.6,71.2 229.2,69.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,76.1 226.6,77.6 226.6,75.4 229.2,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,80.3 226.6,81.8 226.6,79.5 229.2,78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,129.7 221.2,131.2 221.2,129 223.8,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,142.3 221.2,143.8 221.2,141.5 223.8,140  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,159.3 221.2,160.8 221.2,158.5 223.8,157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,150.9 221.2,152.4 221.2,150.2 223.8,148.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,138.1 221.2,139.6 221.2,137.3 223.8,135.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,155.1 221.2,156.6 221.2,154.4 223.8,152.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,146.5 221.2,148 221.2,145.7 223.8,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,121.4 221.2,122.9 221.2,120.6 223.8,119.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.2,105.7 226.6,107.2 226.6,105 229.2,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,125.6 221.2,127.1 221.2,124.8 223.8,123.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,117.2 221.2,118.7 221.2,116.4 223.8,114.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,184.4 221.2,185.9 221.2,183.6 223.8,182.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,205.6 221.2,207.1 221.2,204.8 223.8,203.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,188.6 221.2,190.1 221.2,187.8 223.8,186.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,193 221.2,194.5 221.2,192.3 223.8,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,197.2 221.2,198.7 221.2,196.5 223.8,195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,201.4 221.2,202.9 221.2,200.6 223.8,199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,171.8 221.2,173.3 221.2,171.1 223.8,169.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,163.5 221.2,165 221.2,162.7 223.8,161.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,180.2 221.2,181.7 221.2,179.4 223.8,177.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,167.7 221.2,169.2 221.2,166.9 223.8,165.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "223.8,176 221.2,177.5 221.2,175.3 223.8,173.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "308.3,96.3 326.7,85.7 335.9,91 317.5,101.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "253.2,54 268.5,45.1 286.9,55.7 271.6,64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.9,70.8 286.9,81.4 296.1,76.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192,38.9 210.4,28.3 231.8,40.7 213.4,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "72.7,51.2 100.2,35.3 112.4,42.4 84.9,58.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "11.5,96.6 35.9,82.5 54.3,93.1 29.8,107.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "149.2,67.2 161.4,60.1 176.7,68.9 164.5,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "112.4,58.9 124.7,51.8 136.9,58.9 124.7,65.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "231.8,86.6 231.8,97.1 241,91.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "72.7,115.6 72.7,105 63.5,110.3  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Floor_00000052065589927282730510000016229595072788215213_",
    className: "st6",
    d: "M50.9,170.9C-17,210-17,273.5,50.9,312.7 c67.8,39.2,177.8,39.2,245.6,0c67.8-39.2,67.8-102.6,0-141.8C228.6,131.7,118.7,131.7,50.9,170.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shadows",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000070832048340575012510000003980762612922270858_",
    className: "st7",
    d: "M266.7,240.6c11.9-6.9,11.9-18,0-24.8 c-11.9-6.9-31.1-6.9-43,0s-11.9,18,0,24.8C235.6,247.4,254.9,247.4,266.7,240.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow_00000034081022985918172260000011288624538986489777_",
    className: "st7",
    points: "100.9,182.3 48.6,212.5  100.9,242.6 153.2,212.5  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_2_",
    className: "st5",
    cx: 177.2,
    cy: 225.7,
    rx: 148.5,
    ry: 85.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000114033585343029091490000011423996104097277313_",
    className: "st8",
    d: "M67.3,233.9l65.8,38c1.6,0.9,4.2,0.9,5.8,0 l97.5-56.3c1.6-0.9,1.6-2.4,0-3.4l-65.8-38c-1.6-0.9-4.2-0.9-5.8,0l-97.5,56.3C65.7,231.5,65.7,233,67.3,233.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_27_",
    className: "st9",
    d: "M194.2,118.5l46.8,27c0.9,0.5,0.9,1.3,0,1.8L212,164c-3.8,2.2-10.1,2.2-13.9,0l-45.8-26.4 c-0.9-0.5-0.9-1.3,0-1.8l30-17.3C185.6,116.6,190.9,116.6,194.2,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000095323394586758157370000007902353471658604930_",
    className: "st9",
    d: "M26.3,276l-1.4-2.8c-0.7-0.4-0.7-1,0-1.4 L87,235.9c0.7-0.4,1.8-0.4,2.5,0l1.4,2.8c0.7,0.4,0.7,1,0,1.4L28.8,276C28.1,276.4,27,276.4,26.3,276z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_12_",
    className: "st8",
    d: "M258.7,257.6l-22.5-13c-1.3-0.8-1.3-2,0-2.7l5.6-3.2c1.3-0.8,3.4-0.8,4.7,0l22.5,13 c1.3,0.8,1.3,2,0,2.7l-5.6,3.2C262.1,258.3,260,258.3,258.7,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000033353737242829970830000002904716115411629983_",
    className: "st8",
    d: "M294.1,239.5c-0.9,0-1.7-0.7-1.9-1.6 l-0.4-2.3c-1-0.2-2-0.4-2.9-0.7l-4.1,1.9c-0.3,0.1-0.6,0.2-1,0.2c-0.4,0-0.8-0.1-1.2-0.3l-4-2.3c-0.5-0.3-0.8-0.8-0.9-1.3 c0-0.6,0.2-1.1,0.7-1.4l2.4-1.7c-0.2-0.3-0.4-0.6-0.6-0.9l-5.1-0.3c-1-0.1-1.7-0.9-1.7-1.9l0-3c0-1,0.8-1.8,1.7-1.9l5.1-0.3 c0.2-0.3,0.4-0.6,0.6-0.9l-2.4-1.7c-0.5-0.3-0.7-0.9-0.7-1.4c0-0.6,0.3-1.1,0.9-1.3l4-2.3c0.3-0.2,0.7-0.3,1.2-0.3 c0.3,0,0.7,0.1,1,0.2l4.1,1.9c0.9-0.3,1.9-0.5,2.9-0.7l0.4-2.3c0.2-0.9,1-1.6,1.9-1.6h5.9c0.9,0,1.7,0.7,1.9,1.6l0.4,2.3 c1,0.2,2,0.4,2.9,0.7l4.1-1.9c0.3-0.1,0.6-0.2,1-0.2c0.4,0,0.8,0.1,1.2,0.3l4,2.3c0.5,0.3,0.8,0.8,0.9,1.3c0,0.6-0.2,1.1-0.7,1.4 l-2.4,1.7c0.2,0.3,0.4,0.6,0.6,0.9l5.1,0.3c1,0.1,1.7,0.9,1.7,1.9l0,3c0,1-0.8,1.8-1.7,1.9l-5.1,0.3c-0.2,0.3-0.4,0.6-0.6,0.9 l2.4,1.7c0.5,0.3,0.7,0.9,0.7,1.4c0,0.6-0.3,1.1-0.8,1.3l-4,2.3c-0.3,0.2-0.7,0.3-1.2,0.3c-0.3,0-0.7-0.1-1-0.2l-4.1-1.9 c-0.9,0.3-1.9,0.5-2.9,0.7l-0.4,2.3c-0.2,0.9-1,1.6-1.9,1.6H294.1z M297.1,221.1c-2.3,0-4.5,0.5-6.1,1.4c-1.4,0.8-2.2,1.8-2.2,2.8 c0,1,0.8,2,2.2,2.8c1.6,0.9,3.8,1.4,6.1,1.4c2.3,0,4.5-0.5,6.1-1.4c1.4-0.8,2.2-1.8,2.2-2.8c0-1-0.8-2-2.2-2.8 C301.6,221.6,299.4,221.1,297.1,221.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sphere_1_x2F_2",
    className: "st10",
    d: "M222.3,151.6c0,2.8-1.8,5.5-5.5,7.6c-7.3,4.2-19,4.2-26.3,0c-3.6-2.1-5.5-4.8-5.5-7.6 c0-10.3,8.3-18.6,18.6-18.6C214,133,222.3,141.4,222.3,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M211,152.1c-0.4,0.3-0.9,0.5-1.2,0.9c-0.7,0.9-0.4,2.2,0.4,3c0.8,0.8,2,1,3.1,1c2.6,0,5.1-1.5,6.4-3.7 c1.2-2,1.4-6.6-1.1-7.8c-1.6-0.8-2.9,1.3-3.7,2.5C213.9,149.7,212.7,151.1,211,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M216.8,159.2c0.1-0.1,0.2-0.1,0.3-0.2c-7,1.6-13.1-0.6-15.9-3.3c-2.4-2.3-4.3-5.4-3.2-9.1 c1.8,0.5,3.7,0.8,5.7,0.8c2.8,0,5.6-0.6,8.2-1.7c1.9-0.8,5.9-2.6,6.8-4.7c0-0.1,0.1-0.1,0.1-0.2c-3.4-4.7-8.9-7.8-15.1-7.8 c-10.3,0-18.6,8.3-18.6,18.6c0,2.8,1.8,5.5,5.5,7.6C197.8,163.4,209.6,163.4,216.8,159.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 203.7,
    cy: 125.5,
    r: 19.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 203.7,
    cy: 125.5,
    r: 19.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 203.7,
    cy: 125.5,
    r: 19.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M212.4,139.6c-6,0.8-12.4-1.1-16.9-5.2c-4.5-4.1-6.9-10.5-6-16.5c0.6-3.7,2.5-7.2,5.2-9.7 c-6.2,3.2-10.4,9.7-10.4,17.2c0,10.7,8.7,19.4,19.4,19.4c5.9,0,11.2-2.7,14.8-6.9C216.5,138.8,214.5,139.4,212.4,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.3,130.6c0-0.7,0-1.4-0.1-2.1c-0.3-3.8-1.5-7.9-3.5-11.1c-4-6.2-12.4-7-16.9-0.9c-2.2,3.1-1.8,7.3-0.8,11 c1,3.7,3.3,7.3,2.6,11.9c-0.3,2.2-1.1,4-3.8,5c1.2,0.2,2.5,0.4,3.8,0.4C212.6,144.8,220.1,138.8,222.3,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M199.9,144.4c1.2,0.2,2.5,0.4,3.8,0.4c7.9,0,14.8-4.8,17.7-11.6c0-0.7,0-2.7-0.1-3.4 c-0.3-3.9-1.5-8-3.6-11.3c-3.4-5.3-9.9-6.7-14.6-3.5c-0.5,0.4-0.9,1-1.3,1.5c-2.2,3.1-1.8,7.3-0.8,11c1,3.7,3.3,7.3,2.6,11.9 C203.4,141.6,202.5,143.4,199.9,144.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M217.8,127.9c-0.4-1.2-1.2-2-2.3-2.3c-1.1-0.3-2.3-0.2-3.6,0.5c-2.5,1.4-3.8,4.5-3,6.9 c0.4,1.2,1.2,2,2.3,2.3c1.1,0.3,2.3,0.2,3.6-0.5C217.2,133.3,218.6,130.3,217.8,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M218,128.4c0,1.2-1.1,4.3-4.3,5.1c-3.3,0.8-4.8-1.6-4.3-4.5c-0.7,1.3-0.9,2.8-0.4,4.1 c0.4,1.2,1.2,2,2.3,2.3c1.1,0.3,2.3,0.2,3.6-0.5C217.1,133.4,218.4,130.7,218,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M212,126.1c-0.2,0.1-0.3,0.2-0.5,0.3l3.1,4.4l1-5.2C214.5,125.2,213.2,125.4,212,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M217.4,128.9c-0.3-0.8-0.9-1.4-1.6-1.6c-0.7-0.2-1.6-0.1-2.5,0.4c-1.7,1-2.7,3.1-2.1,4.8 c0.3,0.8,0.9,1.4,1.6,1.6c0.7,0.2,1.6,0.1,2.5-0.4C216.9,132.7,217.9,130.6,217.4,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M215.7,129.9c-0.1-0.4-0.4-0.6-0.7-0.7c-0.3-0.1-0.8-0.1-1.2,0.2c-0.8,0.5-1.2,1.5-1,2.2 c0.1,0.4,0.4,0.6,0.7,0.7c0.3,0.1,0.8,0.1,1.2-0.2C215.5,131.6,216,130.6,215.7,129.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M213.9,131.8c0.8-0.5,1.2-1.5,1-2.2c-0.1-0.2-0.2-0.4-0.3-0.5c-0.2,0-0.5,0.1-0.7,0.2 c-0.8,0.5-1.2,1.5-1,2.2c0.1,0.2,0.2,0.4,0.3,0.5C213.4,132,213.6,132,213.9,131.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Modem"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.1,108.3c0-0.1,0.1-0.3,0.3-0.4c0.4-0.2,1-0.2,1.3,0c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,18.4,0,18.5 c0,0.1-0.1,0.3-0.3,0.4c-0.4,0.2-1,0.2-1.3,0c-0.2-0.1-0.3-0.2-0.3-0.4C227.1,126.7,227.1,108.4,227.1,108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M228.8,108.7c-0.4,0.2-1,0.2-1.3,0c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.1,0.1-0.3,0.3-0.4c0.4-0.2,1-0.2,1.3,0 c0.2,0.1,0.3,0.2,0.3,0.4S228.9,108.6,228.8,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.7,100c0-0.1,0-0.1,0.1-0.2c0.2-0.1,0.4-0.1,0.6,0c0.1,0,0.1,0.1,0.1,0.2c0,0,0,8.1,0,8.2 c0,0.1,0,0.1-0.1,0.2c-0.2,0.1-0.4,0.1-0.6,0c-0.1,0-0.1-0.1-0.1-0.2C227.7,108.2,227.7,100.1,227.7,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M228.4,100.2c-0.2,0.1-0.4,0.1-0.6,0c-0.1,0-0.1-0.1-0.1-0.2s0-0.1,0.1-0.2c0.2-0.1,0.4-0.1,0.6,0 c0.1,0,0.1,0.1,0.1,0.2S228.5,100.2,228.4,100.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195.7,90.2c0-0.1,0.1-0.3,0.3-0.4c0.4-0.2,1-0.2,1.3,0c0.2,0.1,0.3,0.2,0.3,0.4c0,0.1,0,18.4,0,18.5 c0,0.1-0.1,0.3-0.3,0.4c-0.4,0.2-1,0.2-1.3,0c-0.2-0.1-0.3-0.2-0.3-0.4C195.7,108.5,195.7,90.3,195.7,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M197.3,90.5c-0.4,0.2-1,0.2-1.3,0c-0.2-0.1-0.3-0.2-0.3-0.4s0.1-0.3,0.3-0.4c0.4-0.2,1-0.2,1.3,0 c0.2,0.1,0.3,0.2,0.3,0.4S197.5,90.4,197.3,90.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M196.2,81.9c0-0.1,0-0.1,0.1-0.2c0.2-0.1,0.4-0.1,0.6,0c0.1,0,0.1,0.1,0.1,0.2c0,0,0,8.1,0,8.2 c0,0.1,0,0.1-0.1,0.2c-0.2,0.1-0.4,0.1-0.6,0c-0.1,0-0.1-0.1-0.1-0.2C196.2,90,196.2,81.9,196.2,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M196.9,82.1c-0.2,0.1-0.4,0.1-0.6,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0.1-0.2c0.2-0.1,0.4-0.1,0.6,0 c0.1,0,0.1,0.1,0.1,0.2C197.1,81.9,197,82,196.9,82.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M209.8,158.1l26.7-15.4c0.7-0.4,1.5-1.5,1.6-2.3l0-0.1c0.2-0.8-0.3-1.9-1.1-2.3l-44-25.4 c-3.1-1.8-8.1-1.8-11.2,0l-28.2,16.3c-0.7,0.4-1.3,1.5-1.1,2.3l0,0c0.1,0.8,0.8,1.9,1.6,2.3l42.6,24.6 C200.3,160.1,206.2,160.1,209.8,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M209.8,158.1l26.7-15.4c0.7-0.4,1.5-1.5,1.6-2.3l0-0.1c0.2-0.8-0.3-1.9-1.1-2.3l-44-25.4 c-3.1-1.8-8.1-1.8-11.2,0l-28.2,16.3c-0.7,0.4-1.3,1.5-1.1,2.3l0,0c0.1,0.8,0.8,1.9,1.6,2.3l42.6,24.6 C200.3,160.1,206.2,160.1,209.8,158.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193,106.2l43.3,25c1.4,0.8,2.5,2.7,2.5,4.3l0,1.6c0,1.6-1.1,3.5-2.5,4.3l-26.4,15.3 c-3.6,2.1-9.5,2.1-13.1,0l-42.3-24.4c-1.4-0.8-2.5-2.7-2.5-4.3v-1.6c0-1.6,1.1-3.5,2.5-4.3l27.4-15.8 C184.9,104.4,189.9,104.4,193,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M193,106.2l43.3,25c1.4,0.8,2.5,2.7,2.5,4.3l0,1.6c0,1.6-1.1,3.5-2.5,4.3l-26.4,15.3 c-3.6,2.1-9.5,2.1-13.1,0l-42.3-24.4c-1.4-0.8-2.5-2.7-2.5-4.3v-1.6c0-1.6,1.1-3.5,2.5-4.3l27.4-15.8 C184.9,104.4,189.9,104.4,193,106.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M238.7,133.4c-0.1-0.7-0.8-1.6-1.6-2l-44.1-25.5c-3.1-1.8-8.1-1.8-11.2,0l-28.3,16.3 c-0.7,0.4-1.4,1.3-1.6,2c-0.2,0.7,0.2,1.5,1,2l43.8,25.3c3.6,2.1,9.5,2.1,13,0l27.9-16.1C238.4,135,238.9,134.1,238.7,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M238.7,133.4c-0.1-0.7-0.8-1.6-1.6-2l-44.1-25.5c-3.1-1.8-8.1-1.8-11.2,0l-28.3,16.3 c-0.7,0.4-1.4,1.3-1.6,2c-0.2,0.7,0.2,1.5,1,2l43.8,25.3c3.6,2.1,9.5,2.1,13,0l27.9-16.1C238.4,135,238.9,134.1,238.7,133.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193.1,105.9l43.9,25.4c0.8,0.5,0.8,1.2,0,1.7l-27.2,15.7c-3.6,2.1-9.5,2.1-13,0l-43-24.8 c-0.8-0.5-0.8-1.2,0-1.7l28.1-16.3C185,104.2,190,104.2,193.1,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M193.1,105.9l43.9,25.4c0.8,0.5,0.8,1.2,0,1.7l-27.2,15.7c-3.6,2.1-9.5,2.1-13,0l-43-24.8 c-0.8-0.5-0.8-1.2,0-1.7l28.1-16.3C185,104.2,190,104.2,193.1,105.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M183.8,145.4v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C184,145.1,183.8,145.2,183.8,145.4z M182,144.4v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C182.2,144.1,182,144.2,182,144.4z M192.9,150.7v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C193.1,150.4,192.9,150.5,192.9,150.7z M178.4,142.3v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C178.5,142,178.4,142,178.4,142.3z M180.2,143.3v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C180.3,143,180.2,143.1,180.2,143.3z M189.3,148.6v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2 l0-2.3c0-0.2-0.1-0.5-0.3-0.5C189.4,148.3,189.3,148.4,189.3,148.6z M191.1,149.7v2.3c0,0.2,0.1,0.5,0.3,0.5 c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C191.3,149.4,191.1,149.5,191.1,149.7z M187.5,147.5v2.3 c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C187.6,147.2,187.5,147.3,187.5,147.5z M176.6,141.2 v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C176.7,140.9,176.6,141,176.6,141.2z  M185.7,146.5v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C185.8,146.2,185.7,146.3,185.7,146.5z M162,132.7v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C162.1,132.4,162,132.5,162,132.7z M174.7,140.1v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C174.9,139.8,174.7,139.9,174.7,140.1z M163.8,133.8v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2 l0-2.3c0-0.2-0.1-0.5-0.3-0.5C163.9,133.5,163.8,133.6,163.8,133.8z M160.2,131.7v2.3c0,0.2,0.1,0.5,0.3,0.5 c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C160.3,131.4,160.2,131.5,160.2,131.7z M165.6,134.8v2.3 c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C165.8,134.5,165.6,134.6,165.6,134.8z M172.9,139.1 v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C173,138.8,172.9,138.9,172.9,139.1z M171.1,138 v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C171.2,137.7,171.1,137.8,171.1,138z  M167.5,135.9v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C167.6,135.6,167.5,135.7,167.5,135.9z M169.3,137v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C169.4,136.7,169.3,136.8,169.3,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180.2,143.3v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C180.3,143,180.2,143.1,180.2,143.3z M183.8,145.4v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C184,145.1,183.8,145.2,183.8,145.4z M182,144.4v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C182.2,144.1,182,144.2,182,144.4z M192.9,150.7v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C193.1,150.4,192.9,150.5,192.9,150.7z M178.4,142.3v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2 l0-2.3c0-0.2-0.1-0.5-0.3-0.5C178.5,142,178.4,142,178.4,142.3z M176.6,141.2v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2 l0-2.3c0-0.2-0.1-0.5-0.3-0.5C176.7,140.9,176.6,141,176.6,141.2z M189.3,148.6v2.3c0,0.2,0.1,0.5,0.3,0.5 c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C189.4,148.3,189.3,148.4,189.3,148.6z M187.5,147.5v2.3 c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C187.6,147.2,187.5,147.3,187.5,147.5z M185.7,146.5 v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C185.8,146.2,185.7,146.3,185.7,146.5z  M191.1,149.7v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C191.3,149.4,191.1,149.5,191.1,149.7z M162,132.7v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C162.1,132.4,162,132.5,162,132.7z M163.8,133.8v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C163.9,133.5,163.8,133.6,163.8,133.8z M160.2,131.7v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2 l0-2.3c0-0.2-0.1-0.5-0.3-0.5C160.3,131.4,160.2,131.5,160.2,131.7z M165.6,134.8v2.3c0,0.2,0.1,0.5,0.3,0.5 c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C165.8,134.5,165.6,134.6,165.6,134.8z M174.7,140.1v2.3 c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C174.9,139.8,174.7,139.9,174.7,140.1z M171.1,138 v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5C171.2,137.7,171.1,137.8,171.1,138z  M167.5,135.9v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3c0-0.2-0.1-0.5-0.3-0.5 C167.6,135.6,167.5,135.7,167.5,135.9z M172.9,139.1v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C173,138.8,172.9,138.9,172.9,139.1z M169.3,137v2.3c0,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.3,0,0.3-0.2l0-2.3 c0-0.2-0.1-0.5-0.3-0.5C169.4,136.7,169.3,136.8,169.3,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M185.9,146.3C185.9,146.3,185.9,146.3,185.9,146.3l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1 l0-2.3C186.3,146.6,186.1,146.4,185.9,146.3C185.9,146.3,185.9,146.3,185.9,146.3z M184.1,145.2 C184.1,145.2,184.1,145.3,184.1,145.2l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3 C184.4,145.6,184.3,145.3,184.1,145.2C184.1,145.2,184.1,145.2,184.1,145.2z M182.3,144.1C182.3,144.2,182.3,144.2,182.3,144.1 l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C182.6,144.5,182.5,144.3,182.3,144.1 C182.3,144.2,182.3,144.2,182.3,144.1z M180.5,143.1C180.4,143.1,180.4,143.1,180.5,143.1l0,2.4c0,0.2,0.1,0.5,0.3,0.5 c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C180.8,143.5,180.7,143.2,180.5,143.1C180.5,143.1,180.5,143.1,180.5,143.1z M178.6,142 C178.6,142.1,178.6,142.1,178.6,142l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3 C179,142.4,178.8,142.1,178.6,142C178.7,142,178.6,142,178.6,142z M191.4,149.4C191.4,149.5,191.4,149.5,191.4,149.4l0,2.4 c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C191.7,149.8,191.6,149.6,191.4,149.4 C191.4,149.5,191.4,149.4,191.4,149.4z M187.7,147.3C187.7,147.3,187.7,147.4,187.7,147.3l0,2.4c0,0.2,0.1,0.5,0.3,0.5 c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C188.1,147.7,187.9,147.4,187.7,147.3C187.8,147.3,187.7,147.3,187.7,147.3z M193.2,150.5 C193.2,150.5,193.2,150.5,193.2,150.5l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3 C193.5,150.9,193.4,150.6,193.2,150.5C193.2,150.5,193.2,150.5,193.2,150.5z M189.6,148.4C189.6,148.4,189.5,148.4,189.6,148.4 l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C189.9,148.7,189.8,148.5,189.6,148.4 C189.6,148.4,189.6,148.4,189.6,148.4z M169.5,136.7C169.5,136.8,169.5,136.8,169.5,136.7l0,2.4c0,0.2,0.1,0.5,0.3,0.5 c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C169.9,137.1,169.7,136.9,169.5,136.7C169.6,136.8,169.5,136.7,169.5,136.7z M164.1,133.6 C164.1,133.6,164.1,133.6,164.1,133.6l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3 C164.4,133.9,164.3,133.7,164.1,133.6C164.1,133.6,164.1,133.6,164.1,133.6z M165.9,134.6C165.9,134.6,165.9,134.7,165.9,134.6 l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C166.2,135,166.1,134.7,165.9,134.6 C165.9,134.6,165.9,134.6,165.9,134.6z M162.2,132.5C162.2,132.5,162.2,132.6,162.2,132.5l0,2.4c0,0.2,0.1,0.5,0.3,0.5 c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C162.6,132.9,162.5,132.6,162.2,132.5C162.3,132.5,162.3,132.5,162.2,132.5z M160.4,131.5v2.3 c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C160.8,131.8,160.6,131.6,160.4,131.5 C160.5,131.5,160.4,131.5,160.4,131.5C160.4,131.5,160.4,131.5,160.4,131.5z M171.4,137.8C171.3,137.8,171.3,137.8,171.4,137.8 l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C171.7,138.2,171.6,137.9,171.4,137.8 C171.4,137.8,171.4,137.8,171.4,137.8z M167.7,135.7C167.7,135.7,167.7,135.7,167.7,135.7l0,2.4c0,0.2,0.1,0.5,0.3,0.5 c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C168.1,136,167.9,135.8,167.7,135.7C167.7,135.7,167.7,135.7,167.7,135.7z M175,139.9 C175,139.9,175,140,175,139.9l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C175.3,140.3,175.2,140,175,139.9 C175,139.9,175,139.9,175,139.9z M173.2,138.9C173.2,138.9,173.2,138.9,173.2,138.9l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0 c0,0,0,0,0-0.1l0-2.3C173.5,139.2,173.4,139,173.2,138.9C173.2,138.9,173.2,138.9,173.2,138.9z M176.8,141 C176.8,141,176.8,141,176.8,141l0,2.4c0,0.2,0.1,0.5,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3C177.2,141.3,177,141.1,176.8,141 C176.8,141,176.8,141,176.8,141z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M199.5,143.4l-3.5,2c-0.7,0.4-1.9,0.4-2.6,0l-29-16.7c-0.7-0.4-0.7-1.1,0-1.5l3.5-2c0.7-0.4,1.9-0.4,2.6,0 l29,16.7C200.2,142.3,200.2,143,199.5,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M164.5,127.6l3.5-2c0.7-0.4,1.9-0.4,2.6,0l29,16.7c0.3,0.2,0.4,0.4,0.5,0.6c-0.1,0.2-0.2,0.4-0.5,0.6 l-3.5,2c-0.7,0.4-1.9,0.4-2.6,0l-29-16.7c-0.3-0.2-0.4-0.4-0.5-0.6C164.1,127.9,164.2,127.7,164.5,127.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M168.1,128.4C168.1,128.4,168.1,128.4,168.1,128.4l0.9-0.5c0,0,0,0,0-0.1c0,0-0.1,0-0.1,0L168.1,128.4 C168.1,128.4,168,128.4,168.1,128.4z M169.1,128.2C169.1,128.1,169.1,128.1,169.1,128.2c-0.1,0-0.1,0-0.1,0 c0.1,0.2,0,0.4-0.3,0.5c-0.3,0.2-0.9,0.2-1.2,0c-0.3-0.2-0.3-0.5,0.1-0.7c0.2-0.1,0.6-0.2,0.9-0.2c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c-0.3-0.1-0.7,0-1,0.2c-0.4,0.2-0.4,0.6-0.1,0.8c0.3,0.2,1,0.2,1.4-0.1C169.1,128.6,169.2,128.4,169.1,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.8,131.2l0.4-0.2c0,0,0,0,0-0.1l-0.3-0.2l0.2-0.1l0.3,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1l-0.8-0.5 l0.2-0.1l0.3,0.2c0,0,0.1,0,0.1,0l0.4-0.2c0,0,0,0,0-0.1l-0.7-0.4c0,0-0.1,0-0.1,0l-0.4,0.2c0,0,0,0,0,0.1l0.3,0.2l-0.2,0.1 l-0.5-0.3l-0.3-0.2c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1l0.2,0.1l-0.2,0.1l-0.3-0.2c0,0-0.1,0-0.1,0l-0.4,0.2c0,0,0,0,0,0.1l0.7,0.4 c0,0,0.1,0,0.1,0l0.4-0.2c0,0,0,0,0-0.1l-0.3-0.2l0.2-0.1l1.1,0.6l-0.2,0.1l-0.3-0.2c0,0-0.1,0-0.1,0l-0.4,0.2c0,0,0,0,0,0.1 l0.7,0.4C171.8,131.2,171.8,131.2,171.8,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M176.1,132.9l-0.1-0.4c0,0-0.1,0-0.1,0l-0.2,0.1l-1.5-0.8l0.5-0.1c0,0,0.1,0,0.1,0l0.3,0.2 c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.1,0.4,0.1,0.5,0c0.2-0.1,0.2-0.2,0-0.3c-0.1-0.1-0.3-0.1-0.5,0l-0.3-0.2c-0.1,0-0.1,0-0.2,0 l-0.6,0.1l-0.3-0.2c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.4-0.1-0.5,0c-0.2,0.1-0.2,0.2,0,0.3c0.1,0.1,0.3,0.1,0.5,0l0.6,0.4 l-0.2,0.3c0,0,0,0.1,0,0.1l0.3,0.2l-0.1,0.1c0,0,0,0,0,0.1l0.3,0.2c0,0,0.1,0,0.1,0l0.4-0.2c0,0,0,0,0-0.1l-0.3-0.2 c0,0-0.1,0-0.1,0l-0.1,0.1l-0.3-0.2c0,0,0,0,0-0.1l0.2-0.3l1.1,0.7l-0.2,0.1c0,0,0,0.1,0,0.1L176.1,132.9 C176.1,132.9,176.1,132.9,176.1,132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M178.2,133.6C178.2,133.5,178.1,133.5,178.2,133.6c-0.2,0-0.4,0-0.5,0.1c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0-0.1,0.1-0.2,0.2-0.2C177.8,133.7,178,133.6,178.2,133.6 C178.1,133.6,178.2,133.6,178.2,133.6z M178.4,133.8c-0.1-0.1-0.4-0.1-0.5,0c-0.1,0.1-0.2,0.2-0.1,0.3l-0.4,0.2c0,0,0,0,0,0.1 c0,0,0.1,0,0.1,0l0.4-0.2c0.1,0.1,0.3,0,0.5,0C178.5,134,178.5,133.8,178.4,133.8z M177.5,133.6c0.2-0.1,0.4-0.2,0.6-0.2 c0,0,0.1,0,0.1,0c0,0,0,0-0.1,0C177.8,133.3,177.6,133.4,177.5,133.6c-0.3,0.1-0.4,0.2-0.4,0.4c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0.1,0,0.1,0C177.2,133.8,177.3,133.7,177.5,133.6z M178.8,133.9C178.8,133.9,178.8,133.9,178.8,133.9c-0.1,0-0.1,0-0.1,0 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.4,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.2,0,0.3-0.1,0.5-0.1 C178.7,134.1,178.8,134,178.8,133.9z M179.1,133.9C179.1,133.9,179.1,133.9,179.1,133.9c-0.1,0-0.1,0-0.1,0 c0,0.1-0.1,0.3-0.3,0.4c-0.2,0.1-0.4,0.2-0.6,0.2c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.3,0,0.5-0.1,0.7-0.2 C179,134.2,179.1,134.1,179.1,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.7,136.4l-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2-0.1l-0.1-0.3c0-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.2-0.1,0.2-0.2l-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1l-0.1,0c0,0,0,0-0.1,0v0c-0.2,0.1-0.3,0.2-0.3,0.4l0.3,0.8 c0,0.1,0.3,0.2,0.5,0.2l0,0c0,0,0,0,0.1,0l0.1,0C181.7,136.5,181.8,136.4,181.7,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.3,137.9l-0.2-0.1l0.2-0.1c0.1,0,0.1-0.1,0-0.1l-0.5-0.3c-0.1,0-0.1,0-0.2,0l-0.2,0.1l-0.2-0.1 c-0.1,0-0.1,0-0.2,0l-0.7,0.4c-0.1,0-0.1,0.1,0,0.1l1,0.6c0.1,0,0.1,0,0.2,0l0.7-0.4C185.4,137.9,185.4,137.9,185.3,137.9z  M183.7,137.8C183.7,137.8,183.6,137.8,183.7,137.8l-0.1,0c0,0,0,0,0,0l0.4-0.2c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0L183.7,137.8z  M183.9,137.9C183.9,137.9,183.8,137.9,183.9,137.9l-0.1,0c0,0,0,0,0,0l0.4-0.2c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0L183.9,137.9z  M184.1,138C184.1,138.1,184,138.1,184.1,138l-0.1,0c0,0,0,0,0,0l0.4-0.2c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0L184.1,138z  M184.3,138.2C184.3,138.2,184.2,138.2,184.3,138.2l-0.1,0c0,0,0,0,0,0l0.4-0.2c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0L184.3,138.2z  M184.5,138.3C184.5,138.3,184.4,138.3,184.5,138.3l-0.1,0c0,0,0,0,0,0l0.4-0.2c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0L184.5,138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192,141.7l-0.5-0.3l0.5-0.1c0,0,0.1,0,0.1,0c0,0,0,0-0.1,0l-0.5,0.1l0.1-0.3c0,0,0,0,0,0c0,0-0.1,0-0.1,0 l-0.1,0.3l-0.5-0.3c0,0-0.1,0-0.1,0l-0.9,0.5c0,0,0,0,0,0.1l1.2,0.7c0,0,0.1,0,0.1,0L192,141.7C192,141.7,192,141.7,192,141.7z  M191,142.2l-1.1-0.7l0.8-0.5l1.1,0.7L191,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.7,143.9C194.6,143.8,194.6,143.8,194.7,143.9l-0.4,0.2l-1.1-0.7l0.3-0.2c0,0,0,0,0-0.1 c0,0-0.1,0-0.1,0l-0.3,0.2c0,0,0,0,0,0.1l1.2,0.7c0,0,0.1,0,0.1,0L194.7,143.9C194.7,143.9,194.7,143.9,194.7,143.9z  M193.9,143.5C193.9,143.6,193.9,143.6,193.9,143.5C193.9,143.6,194,143.6,193.9,143.5l0.5,0c0,0,0.1,0,0.1,0c0,0,0,0-0.1,0 l-0.3,0l0.7-0.4c0,0,0,0,0-0.1c0,0-0.1,0-0.1,0l-0.7,0.4l0-0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0L193.9,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.4,139.8c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.2-0.1 c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1 c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l-0.1,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.2,0.1,0.2,0.2c0,0.1,0,0.1-0.2,0.2 c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0.1-0.1l0.3-0.2 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0-0.1c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0.1c0,0,0.1,0,0.1,0 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0C188.3,139.9,188.3,139.9,188.4,139.8C188.3,139.9,188.4,139.8,188.4,139.8z  M187.7,139.7c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0C187.8,139.7,187.7,139.7,187.7,139.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M170.8,127.3c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C171,127,171,127.2,170.8,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M174,129.2c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C174.3,128.9,174.3,129.1,174,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M177.3,131.1c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C177.6,130.7,177.5,131,177.3,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M180.5,133c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C180.8,132.6,180.8,132.8,180.5,133z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M183.8,134.9c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C184.1,134.5,184,134.7,183.8,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M187,136.7c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C187.3,136.4,187.3,136.6,187,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M190.3,138.6c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C190.6,138.3,190.5,138.5,190.3,138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M193.5,140.5c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C193.8,140.1,193.8,140.4,193.5,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M196.8,142.4c-0.3,0.1-0.6,0.2-0.9,0c-0.2-0.1-0.2-0.4,0.1-0.5c0.3-0.1,0.6-0.2,0.9,0 C197.1,142,197.1,142.2,196.8,142.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Smart_Speaker",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M75.1,244.3c0-2.7-1.8-5.4-5.3-7.4c-7.1-4.1-18.7-4.1-25.8,0c-3.6,2-5.3,4.7-5.3,7.4h0v3.3l0,0 c0,2.7,1.8,5.4,5.3,7.4c7.1,4.1,18.7,4.1,25.8,0c3.6-2.1,5.3-4.7,5.3-7.4l0,0L75.1,244.3L75.1,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M44,251.7c7.1,4.1,18.7,4.1,25.8,0c7.1-4.1,7.1-10.8,0-14.9c-7.1-4.1-18.7-4.1-25.8,0 C36.8,240.9,36.8,247.6,44,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M44,251.7c7.1,4.1,18.7,4.1,25.8,0c7.1-4.1,7.1-10.8,0-14.9c-7.1-4.1-18.7-4.1-25.8,0 C36.8,240.9,36.8,247.6,44,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M70,254.8c-0.1,0.1-0.2,0.1-0.3,0.2c-7.1,4.1-18.7,4.1-25.8,0c-2.1-1.2-3.6-2.7-4.5-4.2v-3.2 c0.9,1.5,2.3,3,4.5,4.2c0.2,0.1,0.4,0.2,0.6,0.3l0,0c0,0-0.1,2.9,6.9,4.7C60.3,259,68.5,255.6,70,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M41.8,250.2c-1-0.8-1.8-1.8-2.3-2.7v3.2c0.5,1,1.3,1.9,2.3,2.7V250.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M75.1,237.8c0-2.7-1.8-5.4-5.3-7.4c-7.1-4.1-18.7-4.1-25.8,0c-3.6,2-5.3,4.7-5.3,7.4h0v5.9l0,0 c0,2.7,1.8,5.4,5.3,7.4c7.1,4.1,18.7,4.1,25.8,0c3.6-2.1,5.3-4.7,5.3-7.4l0,0L75.1,237.8L75.1,237.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M51.9,238.2v15.6c0,0,0.1,0,0.1,0v-15.6H51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M50.5,238.2v15.3c0,0,0.1,0,0.1,0v-15.4H50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M51.2,238.2v15.5c0,0,0.1,0,0.1,0v-15.5H51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M52.6,238.2v15.7c0,0,0.1,0,0.1,0v-15.7H52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M49.8,238.2v15.2c0,0,0.1,0,0.1,0v-15.2H49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M49.1,238.2v15c0,0,0.1,0,0.1,0v-15H49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M53.3,238.2V254c0,0,0.1,0,0.1,0v-15.8H53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M56.1,238.2v16c0,0,0.1,0,0.1,0v-16H56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M55.4,238.2v16c0,0,0.1,0,0.1,0v-16H55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M48.4,238.2V253c0,0,0.1,0,0.1,0v-14.8H48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M56.8,238.2v16c0,0,0.1,0,0.1,0v-16H56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M54,238.2v15.9c0,0,0.1,0,0.1,0v-15.9H54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M54.7,238.2v15.9c0,0,0.1,0,0.1,0v-15.9H54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M41.4,238.2v11c0,0,0.1,0.1,0.1,0.1v-11.2H41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M42.1,238.2v11.6c0,0,0.1,0.1,0.1,0.1v-11.7H42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M42.8,238.2v12.2c0,0,0.1,0.1,0.1,0.1v-12.2H42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M40,238.2v9.4c0,0.1,0.1,0.1,0.1,0.2v-9.6H40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M39.3,238.2v8.2c0,0.1,0.1,0.2,0.1,0.3v-8.5H39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M43.5,238.2v12.6c0,0,0.1,0.1,0.1,0.1v-12.7H43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M47.7,238.2v14.6c0,0,0.1,0,0.1,0v-14.6H47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M46.3,238.2v14c0,0,0.1,0,0.1,0.1v-14.1H46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M47,238.2v14.3c0,0,0.1,0,0.1,0.1v-14.4H47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M44.9,238.2v13.4c0,0,0.1,0,0.1,0.1v-13.5H44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M45.6,238.2V252c0,0,0.1,0,0.1,0.1v-13.8H45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M44.2,238.2v13c0,0,0.1,0.1,0.1,0.1v-13.1H44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M40.7,238.2v10.3c0,0.1,0.1,0.1,0.1,0.2v-10.5H40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M70.9,238.2v12.2c0,0,0.1-0.1,0.1-0.1v-12.1H70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M70.2,238.2v12.7c0,0,0.1-0.1,0.1-0.1v-12.6H70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M68.8,238.2v13.4c0,0,0.1,0,0.1-0.1v-13.4H68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M69.5,238.2v13.1c0,0,0.1-0.1,0.1-0.1v-13H69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.3,238.2v14.1c0,0,0.1,0,0.1-0.1v-14H67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M66.6,238.2v14.3c0,0,0.1,0,0.1-0.1v-14.3H66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M68.1,238.2V252c0,0,0.1,0,0.1-0.1v-13.7H68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M71.6,238.2v11.7c0.1,0,0.1-0.1,0.1-0.1v-11.6H71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M74.4,238.2v8.4c0.1-0.1,0.1-0.2,0.1-0.3v-8.1H74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M57.5,238.2v16c0,0,0.1,0,0.1,0v-16H57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M73,238.2v10.4c0-0.1,0.1-0.1,0.1-0.2v-10.2H73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M72.3,238.2v11.1c0,0,0.1-0.1,0.1-0.1v-11H72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M73.7,238.2v9.5c0-0.1,0.1-0.1,0.1-0.2v-9.3H73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M60.3,238.2V254c0,0,0.1,0,0.1,0v-15.8H60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M61.7,238.2v15.6c0,0,0.1,0,0.1,0v-15.6H61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M59.6,238.2v15.9c0,0,0.1,0,0.1,0v-15.9H59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M61,238.2V254c0,0,0.1,0,0.1,0v-15.7H61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M65.9,238.2v14.6c0,0,0.1,0,0.1,0v-14.5H65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M58.9,238.2v15.9c0,0,0.1,0,0.1,0v-15.9H58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M58.2,238.2v16c0,0,0.1,0,0.1,0v-16H58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M65.2,238.2v14.8c0,0,0.1,0,0.1,0v-14.8H65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M62.4,238.2v15.5c0,0,0.1,0,0.1,0v-15.5H62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M64.5,238.2v15c0,0,0.1,0,0.1,0v-15H64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M63.8,238.2v15.2c0,0,0.1,0,0.1,0v-15.2H63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M63.1,238.2v15.4c0,0,0.1,0,0.1,0v-15.3H63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M69.8,250.4c-7.1,4.1-18.8,4.1-25.9,0c-3-1.7-4.8-4-5.3-6.4c0,0.4,0.1,0.8,0.2,1.3c0.7,2,2.5,3.8,5,5.3 c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1c2.5-1.5,4.2-3.3,5-5.3c0.1-0.4,0.2-0.8,0.2-1.3C74.7,246.5,72.8,248.7,69.8,250.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M75,238.3c-0.5,2.3-2.3,4.5-5.2,6.2c-7.1,4.1-18.8,4.1-25.9,0c-2.9-1.7-4.7-3.9-5.2-6.2h-0.1v5.4 c0,0.1,0,0.2,0,0.3c0.6,2.2,2.4,4.3,5.2,5.9c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1c2.8-1.6,4.6-3.7,5.2-5.9 c0-0.1,0-0.2,0-0.3L75,238.3L75,238.3z M43.8,244.6c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1c2.8-1.6,4.6-3.7,5.2-5.9 c-0.4,2.4-2.2,4.7-5.3,6.4c-7.1,4.1-18.8,4.1-25.9,0c-3-1.7-4.9-4-5.3-6.4C39.2,240.9,41,243,43.8,244.6z M69.8,249.8 c-7.1,4.1-18.8,4.1-25.9,0c-3-1.7-4.9-4-5.3-6.4c0.6,2.2,2.4,4.3,5.2,5.9c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1 c2.8-1.6,4.6-3.7,5.2-5.9C74.7,245.8,72.8,248,69.8,249.8z M69.8,249.1c-7.1,4.1-18.8,4.1-25.9,0c-3-1.7-4.9-4-5.3-6.4 c0.6,2.2,2.4,4.3,5.2,5.9c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1c2.8-1.6,4.6-3.7,5.2-5.9 C74.7,245.1,72.8,247.4,69.8,249.1z M69.8,248.5c-7.1,4.1-18.8,4.1-25.9,0c-3-1.7-4.9-4-5.3-6.4c0.6,2.2,2.4,4.3,5.2,5.9 c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1c2.8-1.6,4.6-3.7,5.2-5.9C74.7,244.5,72.8,246.7,69.8,248.5z M38.6,241.4 c0.6,2.2,2.4,4.3,5.2,5.9c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1c2.8-1.6,4.6-3.7,5.2-5.9c-0.4,2.4-2.2,4.7-5.3,6.4 c-7.1,4.1-18.8,4.1-25.9,0C40.9,246,39,243.8,38.6,241.4z M69.8,247.1c-7.1,4.1-18.8,4.1-25.9,0c-3-1.7-4.9-4-5.3-6.4 c0.6,2.2,2.4,4.3,5.2,5.9c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1c2.8-1.6,4.6-3.7,5.2-5.9 C74.7,243.1,72.8,245.4,69.8,247.1z M38.6,240.1c0.6,2.2,2.4,4.3,5.2,5.9c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1 c2.8-1.6,4.6-3.7,5.2-5.9c-0.4,2.4-2.2,4.7-5.3,6.4c-7.1,4.1-18.8,4.1-25.9,0C40.9,244.7,39,242.5,38.6,240.1z M69.8,245.8 c-7.1,4.1-18.8,4.1-25.9,0c-3-1.7-4.9-4-5.3-6.4c0.6,2.2,2.4,4.3,5.2,5.9c3.6,2.1,8.3,3.1,13,3.1c4.7,0,9.4-1,13-3.1 c2.8-1.6,4.6-3.7,5.2-5.9C74.7,241.8,72.8,244.1,69.8,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M43.9,251.1c-0.3-0.2-0.5-0.3-0.8-0.5C43.4,250.8,43.7,251,43.9,251.1c7.2,4.2,18.7,4.2,25.8,0 c0.3-0.2,0.6-0.3,0.8-0.5c-0.2,0.2-0.5,0.3-0.8,0.5C62.7,255.2,51,255.2,43.9,251.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M44,245.2c7.1,4.1,18.7,4.1,25.8,0c7.1-4.1,7.1-10.8,0-14.9c-7.1-4.1-18.7-4.1-25.8,0 C36.8,234.5,36.8,241.1,44,245.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M75.1,225c0-3.8-4.1-8.4-9.1-10.3c-5-1.9-13.2-1.9-18.2,0c-5,1.9-9.1,6.5-9.1,10.3v2.7v4.2v5.2 c0,2.7,1.8,5.4,5.3,7.4c7.1,4.1,18.7,4.1,25.8,0c3.6-2.1,5.3-4.7,5.3-7.4c0,0,0,0,0,0l0,0v-5.2h0 C75.1,231.9,75.1,228.8,75.1,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M68.4,245.2c-11.8,2.4-24.1-2.3-23.8-12.6l0,0c-3.4-2.2-5.1-4.8-5.1-7.6v15.4c0.9,1.5,2.3,3,4.5,4.2 C50.6,248.4,61.2,248.6,68.4,245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M41.8,230.3c-1.5-1.7-2.3-3.4-2.3-5.4v15.4c0.5,1,1.3,1.9,2.3,2.7V230.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M44.2,232.4c7,4.5,18.3,4.5,25.2,0c7-4.5,7-11.8,0-16.3c-7-4.5-18.3-4.5-25.2,0 C37.3,220.6,37.3,227.9,44.2,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M44.2,232.4c7,4.5,18.3,4.5,25.2,0c7-4.5,7-11.8,0-16.3c-7-4.5-18.3-4.5-25.2,0 C37.3,220.6,37.3,227.9,44.2,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M45.1,231.1c6.5,4.2,17.1,4.2,23.6,0c6.5-4.2,6.5-11,0-15.2c-6.5-4.2-17.1-4.2-23.6,0 C38.5,220.1,38.5,226.9,45.1,231.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_00000097482492599931717290000002093189793586737832_",
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.7,239l1.7-1c0,0,0.1-0.1,0.1-0.2v-1c0-0.4-0.1-0.7-0.3-0.8c-0.2-0.2-0.4-0.2-0.6,0 c-0.5,0.3-0.9,1.2-0.9,1.9L68.7,239C68.6,239,68.7,239.1,68.7,239z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.4,238.4l-1.7,1c0,0-0.1,0.1-0.1,0.2c0,0.7,0.4,1,0.9,0.8C70,240,70.4,239.2,70.4,238.4 C70.4,238.4,70.4,238.3,70.4,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.7,240.7c0.8-0.5,1.3-1.4,1.3-2.7c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.1c0,1.1-0.4,2-1.2,2.4 c-0.2,0.1-0.4,0.1-0.6,0.1c-0.3-0.1-0.5-0.5-0.5-1.1c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.1c0,0.6,0.3,1.1,0.6,1.3 c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.2,0v0.8l-0.4,0.2c-0.1,0-0.1,0.1,0,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0l0.8-0.5 c0.1,0,0.1-0.1,0-0.2c0-0.1-0.1-0.1-0.2,0l-0.2,0.1L69.7,240.7C69.7,240.7,69.7,240.7,69.7,240.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Buttons_00000082351079650740500010000008363563692573703812_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M59.5,221.9c1.6,0.9,1.6,2.4,0,3.3s-4.1,0.9-5.7,0c-1.6-0.9-1.6-2.4,0-3.3C55.3,221,57.9,221,59.5,221.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M59.5,221.9c1.6,0.9,1.6,2.4,0,3.3s-4.1,0.9-5.7,0c-1.6-0.9-1.6-2.4,0-3.3C55.3,221,57.9,221,59.5,221.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M60.3,222.9v1.5c-0.2,0.3-0.5,0.5-0.9,0.7c-1.6,0.9-4.1,0.9-5.7,0c-0.4-0.2-0.7-0.5-0.9-0.7v-1.5 c0-0.1,0-0.3,0.1-0.4c0.1-0.4,0.5-0.8,1-1.1c1.4-0.8,3.8-0.8,5.2,0c0.5,0.3,0.9,0.7,1,1.1C60.3,222.6,60.3,222.8,60.3,222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54,221.4c-0.7,0.4-1.1,1-1.1,1.5c0,0.5,0.4,1.1,1.1,1.5c1.4,0.8,3.8,0.8,5.3,0c0.7-0.4,1.1-1,1.1-1.5 c0-0.5-0.4-1.1-1.1-1.5C57.8,220.6,55.4,220.6,54,221.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M54,221.4c-0.7,0.4-1.1,1-1.1,1.5c0,0.5,0.4,1.1,1.1,1.5c1.4,0.8,3.8,0.8,5.3,0c0.7-0.4,1.1-1,1.1-1.5 c0-0.5-0.4-1.1-1.1-1.5C57.8,220.6,55.4,220.6,54,221.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M52.7,225.6c1,0.6,1,1.5,0,2.1c-1,0.6-2.6,0.6-3.6,0c-1-0.6-1-1.5,0-2.1C50.1,225,51.7,225,52.7,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M52.7,225.6c1,0.6,1,1.5,0,2.1c-1,0.6-2.6,0.6-3.6,0c-1-0.6-1-1.5,0-2.1C50.1,225,51.7,225,52.7,225.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M53.3,226.2v1c-0.1,0.2-0.3,0.3-0.5,0.5c-1,0.6-2.6,0.6-3.6,0c-0.2-0.1-0.4-0.3-0.5-0.5v-1 c0-0.1,0-0.2,0-0.3c0.1-0.2,0.3-0.5,0.6-0.7c0.9-0.5,2.4-0.5,3.3,0c0.3,0.2,0.5,0.4,0.6,0.7C53.3,226.1,53.3,226.2,53.3,226.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M49.3,225.3c-0.5,0.3-0.7,0.6-0.7,1c0,0.3,0.2,0.7,0.7,1c0.9,0.5,2.4,0.5,3.3,0c0.5-0.3,0.7-0.6,0.7-1 c0-0.3-0.2-0.7-0.7-1C51.7,224.8,50.2,224.8,49.3,225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M49.3,225.3c-0.5,0.3-0.7,0.6-0.7,1c0,0.3,0.2,0.7,0.7,1c0.9,0.5,2.4,0.5,3.3,0c0.5-0.3,0.7-0.6,0.7-1 c0-0.3-0.2-0.7-0.7-1C51.7,224.8,50.2,224.8,49.3,225.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.2,225.9l-0.3,0.5l-0.3,0.2c0,0,0,0.1,0,0.1l0.5,0.3c0,0,0.1,0,0.1,0l0.3-0.2l0.9-0.1 c0.1,0,0.1-0.1,0-0.1l-1.2-0.7C50.3,225.8,50.3,225.8,50.2,225.9z M51.8,225.7l-0.6,0.3c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0 l0.6-0.3c0,0,0-0.1,0-0.1C51.9,225.7,51.8,225.7,51.8,225.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64,219c1,0.6,1,1.5,0,2.1c-1,0.6-2.6,0.6-3.6,0c-1-0.6-1-1.5,0-2.1C61.4,218.5,63,218.5,64,219z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M64,219c1,0.6,1,1.5,0,2.1c-1,0.6-2.6,0.6-3.6,0c-1-0.6-1-1.5,0-2.1C61.4,218.5,63,218.5,64,219z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.6,219.7v1c-0.1,0.2-0.3,0.3-0.5,0.5c-1,0.6-2.6,0.6-3.6,0c-0.2-0.1-0.4-0.3-0.5-0.5v-1 c0-0.1,0-0.2,0-0.3c0.1-0.2,0.3-0.5,0.6-0.7c0.9-0.5,2.4-0.5,3.3,0c0.3,0.2,0.5,0.4,0.6,0.7C64.5,219.5,64.6,219.6,64.6,219.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M60.6,218.7c-0.5,0.3-0.7,0.6-0.7,1c0,0.3,0.2,0.7,0.7,1c0.9,0.5,2.4,0.5,3.3,0c0.5-0.3,0.7-0.6,0.7-1 c0-0.3-0.2-0.7-0.7-1C63,218.2,61.5,218.2,60.6,218.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M60.6,218.7c-0.5,0.3-0.7,0.6-0.7,1c0,0.3,0.2,0.7,0.7,1c0.9,0.5,2.4,0.5,3.3,0c0.5-0.3,0.7-0.6,0.7-1 c0-0.3-0.2-0.7-0.7-1C63,218.2,61.5,218.2,60.6,218.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.6,219.3l-0.3,0.5l-0.3,0.2c0,0,0,0.1,0,0.1l0.5,0.3c0,0,0.1,0,0.1,0l0.3-0.2l0.9-0.1 c0.1,0,0.1-0.1,0-0.1l-1.2-0.7C61.7,219.2,61.6,219.2,61.6,219.3z M63.1,219.1l-0.2,0.1l-0.2-0.1c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1l0.2,0.1l-0.2,0.1c0,0,0,0.1,0,0.1s0.1,0,0.1,0l0.2-0.1l0.2,0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1l-0.2-0.1 l0.2-0.1c0,0,0-0.1,0-0.1C63.2,219,63.1,219,63.1,219.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M56.8,223.1c-0.2,0.1-0.4,0.1-0.6,0l-1.5-0.8c-0.2-0.1-0.2-0.2,0-0.3s0.4-0.1,0.6,0l1.5,0.8 C57,222.8,57,223,56.8,223.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.2,223.8c-0.9,0.5-2.3,0.5-3.1,0c-0.5-0.3-0.7-0.6-0.6-1c0-0.1,0.2-0.2,0.4-0.2c0.2,0,0.4,0.1,0.4,0.3 c0,0.2,0.1,0.5,0.4,0.6c0.5,0.3,1.4,0.3,2,0c0.5-0.3,0.5-0.8,0-1.1c-0.3-0.2-0.7-0.3-1.1-0.2c-0.2,0-0.4-0.1-0.4-0.2 c0-0.1,0.1-0.2,0.4-0.3c0.7,0,1.3,0.1,1.8,0.4C59,222.5,59,223.3,58.2,223.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Smartwatch",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M245.8,216.9c-0.7,0.4-4.4,2.5-7.4,4.3c-2.4,1.4-2.6,5-2.6,6.7l13.6-11.4 C247.9,215.6,246.6,216.5,245.8,216.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M261.9,244.1c0,1.4-0.1,2.5-0.2,3.4c-0.1,0.3-0.1,0.6-0.2,0.9c-0.4,1.6-1.2,2.4-2.4,3.1 c-3,1.7-7.2,0.4-12.9-4.1c-5.2-4.1-7.3-7.4-7.3-7.4v1.5c1,1.3,3.2,3.8,6.7,6.6c4.2,3.3,7.7,5,10.6,5c1.2,0,2.3-0.3,3.3-0.8l0,0 c1.5-0.9,2.4-2,2.8-3.7c0.1-0.3,0.1-0.6,0.2-0.9c0.2-1,0.2-2.1,0.2-3.5H261.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M253.4,242.9c-5.2-4.1-7.3-7.4-7.3-7.4l-7.2,4.5c0,0,2.1,3.3,7.3,7.4c5.7,4.5,9.8,5.7,12.9,4.1 c1.1-0.7,2-1.5,2.4-3.1c0.1-0.3,0.1-0.6,0.2-0.9C259.3,246.9,256.6,245.4,253.4,242.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M254.1,250.2v1c0,0-4.8-1.7-10.5-7c-5.8-5.2-7.7-11.6-7.7-15.9c0-4.3,1.1-6.3,2.5-6.5l0.1,0.9 c-0.8,0.1-1.7,1.7-1.7,5.6c0,2,0.5,9.1,7.4,15.3C248.9,247.8,253,249.7,254.1,250.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.1,251.1c-1.2-0.5-2.3-1.1-3.5-1.7c-1.1-0.6-2.2-1.4-3.2-2.1c-1-0.7-2-1.6-3-2.4l-0.7-0.6 c-0.2-0.2-0.5-0.4-0.7-0.7c-0.5-0.4-0.9-0.9-1.3-1.4c-0.8-1-1.6-2-2.3-3.1c-0.7-1.1-1.3-2.2-1.8-3.4c-1-2.4-1.6-4.9-1.6-7.5 c0,1.3,0.2,2.6,0.5,3.8c0.3,1.3,0.7,2.5,1.2,3.7c0.5,1.2,1.1,2.3,1.8,3.4c0.7,1.1,1.5,2.1,2.3,3.1c0.4,0.5,0.9,1,1.3,1.4 c0.2,0.2,0.5,0.5,0.7,0.7l0.7,0.6c1,0.8,2,1.7,3,2.4c1,0.8,2.1,1.5,3.2,2.1C251.8,250.1,252.9,250.7,254.1,251.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M251.1,239.5c-6.8-6.2-7.4-13.3-7.4-15.3c0-3,1.4-4.1,2.1-4.8c0.2-0.2,0.4-0.3,0.6-0.4l-0.1-0.9 c-0.4,0.1-0.8,0.3-1.2,0.7c-0.3,0.4-0.7,0.9-0.9,1.5l-5.6,2.2c-0.8,0.1-1.7,1.7-1.7,5.6c0,2,0.5,9.1,7.4,15.3 c4.7,4.3,8.8,6.2,9.9,6.7l5.9-3.4c0.6,0.3,1,0.4,1,0.4v-1C259.8,245.7,255.8,243.8,251.1,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M238.6,222.6c0.7-0.1,0.8,0.5,0.8,0.5l0-1.2c0,0-0.3-0.4-1-0.3L238.6,222.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261,246.2 261,247.2 254.1,251.1 254.1,250.2 260,246.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M241.7,242.5l-0.5-0.5c0,0-0.3,0.7-0.5,1.3c-0.1,0.3-0.1,0.6,0,0.8v0l0,0l0,0l4.3,3.9l0.5-2.1L241.7,242.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.4,247.9l0.2,0.2c-0.2,0.2-0.5,0-0.6-0.1c-0.1-0.1-0.2-0.4,0-0.8c0.2-0.6,0.5-1.3,0.5-1.3l8-4.6 c0.1-0.1,0.3,0,0.3,0.1v0.4l-7.7,4.4L245.4,247.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M249.5,237.4C249.5,237.4,249.4,237.4,249.5,237.4L249.5,237.4L249.5,237.4c-0.1-0.1-0.2-0.1-0.2,0l-8,4.6 l4.3,3.9l8.2-4.6L249.5,237.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M266.9,222.1l-10.9-6.3c-1.8-1-4.7-1-6.5,0l-8.8,5.1c-0.9,0.5-1.3,1.2-1.3,1.9c0,0.5,0,2.4,0,2.9 c0,0.7,0.5,1.4,1.3,1.9l10.9,6.3c1.8,1,4.7,1,6.5,0l8.8-5.1c0.9-0.5,1.3-1.2,1.3-1.8c0-0.5,0-2.4,0-2.9 C268.3,223.3,267.8,222.6,266.9,222.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.4,222.7l0,2.2l0,0.6c0,0.2,0,0.4,0.1,0.5c0.1,0.4,0.3,0.7,0.6,0.9c0.3,0.3,0.6,0.4,0.9,0.6l1,0.6l1.9,1.1 l3.9,2.3l1.9,1.1l1.9,1.1l-1.9-1.1l-1.9-1.1l-3.9-2.2l-1.9-1.1l-1-0.6c-0.3-0.2-0.7-0.4-0.9-0.6c-0.3-0.3-0.5-0.6-0.6-0.9 c-0.1-0.2-0.1-0.4-0.1-0.6l0-0.6L239.4,222.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M254.9,228.9v5.6c1.2,0,2.4-0.3,3.3-0.8l8.8-5.1c0.9-0.5,1.3-1.2,1.3-1.8c0-0.5,0-2.4,0-2.9 c0-0.7-0.4-1.4-1.3-1.9l-2.3-1.3L254.9,228.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M240.7,220.8l8.8-5.1c1.8-1,4.7-1,6.5,0l10.9,6.3c1.8,1,1.8,2.7,0,3.8l-8.8,5.1c-1.8,1-4.7,1-6.5,0 l-10.9-6.3C239,223.6,239,221.9,240.7,220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M254.9,230.8c-1.1,0-2.1-0.2-2.8-0.7l-10.9-6.3c-0.6-0.3-0.9-0.7-0.9-1.1c0-0.4,0.3-0.7,0.9-1.1l8.8-5.1 c0.7-0.4,1.7-0.7,2.8-0.7c1.1,0,2.1,0.2,2.8,0.7l10.9,6.3c0.6,0.3,0.9,0.7,0.9,1.1c0,0.4-0.3,0.7-0.9,1.1l-8.8,5.1 C257,230.5,256,230.8,254.9,230.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M250.4,231.8c-0.1,0-0.1,0-0.2,0l-8.4-4.8c-0.2-0.1-0.2-0.3-0.1-0.4c0.1-0.2,0.3-0.2,0.4-0.1l8.4,4.8 c0.2,0.1,0.2,0.3,0.1,0.4C250.6,231.8,250.5,231.8,250.4,231.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M270,240.1c0,2.3-0.3,4.1-1,5.3c-1.2,2.3-3.2,3.1-5.1,4.2c-2.5,1.5-3.9,2.3-4.3,2.5 c2.1-1.3,3.2-3.1,3.2-8.1c0-5.8-1.2-8-2.2-9.4c-0.9-1.3-2.2-2-3.7-2l11.1-6.4c-0.4,0.4-0.8,1.1-0.2,2.4 C268.2,230.1,270,232.7,270,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M260.6,234.7c-0.7-1-1.7-1.7-2.8-1.9c-0.3-0.1-0.6-0.1-0.9-0.1v0.9c1.2,0,2.2,0.6,2.9,1.6 c0.9,1.3,2,3.4,2,8.9h0.9C262.8,238.6,261.7,236.3,260.6,234.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M255.6,228.9c0.1,0,0.1,0.1,0,0.1l-0.1,0.1c-0.1,0-0.1,0-0.2,0l-2.9-1.7l-0.2,0.9c0,0.1-0.1,0.1-0.2,0.1 l-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1l0.2-1.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0l0.1-0.1c0.1,0,0.1,0,0.2,0L255.6,228.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.9,227.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4-0.1,0.5-0.1c0.2,0,0.3,0,0.5,0.1c0.2,0,0.3,0.1,0.4,0.2 c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.1,0.1,0.3,0.1,0.5l0,1.3l1.6-1c0.1,0,0.2,0,0.2,0l0.1,0c0.1,0,0.1,0.1,0,0.1l-2,1.2 c-0.1,0-0.1,0-0.2,0l-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1v-1.5c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.5-0.2-0.7-0.2c-0.2,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.3,0.3-0.3,0.4 c0,0.1,0.1,0.3,0.3,0.4c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1l-0.1,0.1C254.1,227.1,254,227.1,253.9,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M257.8,225.6C257.9,225.6,257.9,225.6,257.8,225.6c0,0.1,0,0.1,0,0.1l-0.2,0.1c-0.1,0-0.1,0-0.2,0l-0.2-0.1 c0,0,0,0-0.1-0.1c0,0,0,0,0-0.1l0.2-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0L257.8,225.6z M259.6,226.6 C259.6,226.6,259.6,226.6,259.6,226.6c0,0.1,0,0.1,0,0.1l-0.2,0.1c-0.1,0-0.1,0-0.2,0l-0.2-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1 l0.2-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0L259.6,226.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M258.9,223.1c0.1,0,0.2,0,0.2,0l0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0.2,1.3l0.1-0.1c0.2-0.1,0.3-0.2,0.5-0.2 c0.2-0.1,0.4-0.1,0.5-0.1c0.2,0,0.4,0,0.5,0c0.2,0,0.3,0.1,0.5,0.2c0.2,0.1,0.3,0.2,0.3,0.3c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.3,0-0.5,0 c-0.2,0-0.3-0.1-0.4-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1l0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.3,0.1,0.4,0.1 c0.1,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.2 c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.3-0.2c-0.2-0.1-0.5-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.8,0.3l-0.4,0.2c-0.1,0-0.1,0-0.2,0l-0.1,0 c0,0,0,0-0.1,0c0,0,0,0,0,0l-0.2-1.3l-1.5,0.9c-0.1,0-0.1,0-0.2,0l-0.1,0c-0.1,0-0.1-0.1,0-0.1L258.9,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M264.2,223.9c0.1,0,0.1,0.1,0,0.1l-0.1,0.1c-0.1,0-0.1,0-0.2,0l-2.9-1.7l-0.2,0.9c0,0.1-0.1,0.1-0.2,0.1 l-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1l0.2-1.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0l0.1-0.1c0.1,0,0.1,0,0.2,0L264.2,223.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000042015559825770553090000000291827195261093785_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000169527348351665235430000013209408998232707513_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000001631252003689648000000009541854417061297805_",
    className: "st4",
    d: "M245,223c0.2,0.1,0.2,0.3,0,0.4 c-0.2,0.1-0.5,0.1-0.7,0c-0.2-0.1-0.2-0.3,0-0.4C244.5,222.9,244.8,222.9,245,223z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000054955968764431159810000010619763918909573271_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078757587488337685960000007152955196647192237_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000070112146718469341850000002628262318286212253_",
    className: "st4",
    d: "M243.7,222.6c-0.4,0.2-0.5,0.5-0.4,0.8 c0,0.1,0.1,0.1,0.2,0.1l0,0c0.1,0,0.2-0.1,0.2-0.1c-0.1-0.2,0-0.4,0.3-0.6c0.3-0.1,0.6-0.2,0.9-0.1c0.1,0,0.2,0,0.3-0.1l0,0 c0-0.1,0-0.1-0.1-0.1C244.6,222.3,244.1,222.4,243.7,222.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000065034440784212680710000015338929730253987726_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000026144288161533720400000008916771081582527394_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000149342379640552923710000001193667074139478432_",
    className: "st4",
    d: "M243.2,222.2c-0.5,0.3-0.8,0.8-0.6,1.2 c0,0.1,0.1,0.1,0.2,0.1l0,0c0.1,0,0.2-0.1,0.2-0.1c-0.1-0.3,0.1-0.7,0.5-1c0.4-0.3,1-0.3,1.6-0.2c0.1,0,0.2,0,0.2-0.1l0,0 c0-0.1,0-0.1-0.1-0.1C244.5,221.8,243.7,221.9,243.2,222.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168079358850487723440000005461828193692936117_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000103230305979767206360000011130585689823809212_",
    className: "st4",
    d: "M252.8,217.2c-0.2,0-0.3,0-0.4,0.1 l-2.5,1.4c-0.2,0.1-0.1,0.3,0.1,0.4l0.8,0.6c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1l2.5-1.4 c0.2-0.1,0.1-0.3-0.1-0.4l-0.8-0.6C253.1,217.3,253,217.2,252.8,217.2z M251.2,219.7c-0.1,0-0.1,0-0.2-0.1l-0.8-0.6 c-0.1-0.1-0.2-0.2-0.1-0.3l2.5-1.4c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1l0.8,0.6c0.1,0.1,0.2,0.2,0.1,0.3l-2.5,1.4 C251.4,219.7,251.3,219.7,251.2,219.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000161611381603802470550000006617217907590872723_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M250.8,218.6l1,0.7l-0.4,0.2c0,0-0.1,0-0.1,0l-0.7-0.5c-0.1-0.1-0.1-0.2,0-0.2L250.8,218.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "251,218.5 251.4,218.2 252.4,218.9 252,219.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "251.6,218.1 252.1,217.9 253.1,218.5 252.6,218.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M252.8,217.5l0.7,0.5c0.1,0.1,0.1,0.2-0.1,0.3l-0.2,0.1l-1-0.7l0.4-0.2 C252.7,217.5,252.8,217.5,252.8,217.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000140734849229693018400000004634562031252721034_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000136408134997543243760000006380882159760243382_",
    className: "st4",
    d: "M253.3,217.3c0.1,0,0.3,0,0.4,0.1l0.2,0.1 c0.2,0.1,0.3,0.2,0.2,0.3l-0.1,0.1l-0.8-0.5C253.2,217.4,253.3,217.4,253.3,217.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gear_2_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M314.8,213.9l-4-2.3c-0.2-0.1-0.6-0.2-0.9,0l-4.1,1.9c-0.3,0.1-0.7,0.1-0.9,0.1c-1-0.3-2.1-0.6-3.2-0.8 c-0.3,0-0.5-0.3-0.6-0.6l-0.5-2.7c-0.1-0.3-0.3-0.5-0.6-0.5l-5.9,0c-0.3,0-0.5,0.2-0.6,0.5l-0.5,2.7c-0.1,0.3-0.3,0.5-0.6,0.6 c-1.1,0.2-2.1,0.4-3.2,0.8c-0.3,0.1-0.7,0.1-0.9-0.1l-4.1-1.9c-0.3-0.1-0.7-0.1-0.9,0l-4,2.3c-0.1,0.1-0.2,0.2-0.2,0.3l0,0l0,3.5 l0,0c0,0.1,0.1,0.2,0.2,0.3l1.9,1.3c-0.1,0.1-0.3,0.2-0.5,0.2l-5.4,0.3c-0.3,0-0.5,0.3-0.5,0.5l0,2.3c0,0,0,0,0,0l0,4.2 c0,0.3,0.2,0.5,0.5,0.5l5.4,0.3c0.2,0,0.3,0.1,0.5,0.2l-1.8,1.3c-0.1,0.1-0.2,0.2-0.2,0.3l0,0l0,3.5l0,0c0,0.1,0.1,0.2,0.2,0.3 l4,2.3c0.2,0.1,0.6,0.2,0.9,0l4.1-1.9c0.3-0.1,0.7-0.1,0.9-0.1c1,0.3,2.1,0.6,3.2,0.8c0.3,0,0.5,0.3,0.6,0.6l0.5,2.7 c0.1,0.3,0.3,0.5,0.6,0.5h5.9c0.3,0,0.5-0.2,0.6-0.5l0.5-2.7c0.1-0.3,0.3-0.5,0.6-0.6c1.1-0.2,2.2-0.4,3.2-0.8 c0.3-0.1,0.7-0.1,0.9,0.1l4.1,1.9c0.3,0.1,0.7,0.1,0.9,0l4-2.3c0.1-0.1,0.2-0.2,0.2-0.3l0,0l0-3.5l0,0c0-0.1-0.1-0.2-0.2-0.3 l-1.9-1.3c0.1-0.1,0.3-0.2,0.5-0.2l5.4-0.3c0.3,0,0.5-0.3,0.5-0.5l0-3.5c0,0,0,0,0,0l0-3c0-0.3-0.2-0.5-0.5-0.5l-5.4-0.3 c-0.2,0-0.3-0.1-0.5-0.2l1.8-1.3c0.1-0.1,0.2-0.2,0.2-0.3l0,0l0-3.5l0,0C315,214,314.9,213.9,314.8,213.9z M287.6,222.9 c0.3-1,1.1-1.9,2.6-2.8c3.8-2.2,9.8-2.2,13.6,0c1.4,0.8,2.3,1.7,2.7,2.6c-0.3,1.1-1.2,2.2-2.7,3c-3.8,2.2-9.8,2.2-13.6,0 C288.9,224.9,288,223.9,287.6,222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M314.8,213.9l-4-2.3c-0.2-0.1-0.6-0.2-0.9,0l-4.1,1.9c-0.3,0.1-0.7,0.1-0.9,0.1c-1-0.3-2.1-0.6-3.2-0.8 c-0.3,0-0.5-0.3-0.6-0.6l-0.5-2.7c-0.1-0.3-0.3-0.5-0.6-0.5l-5.9,0c-0.3,0-0.5,0.2-0.6,0.5l-0.5,2.7c-0.1,0.3-0.3,0.5-0.6,0.6 c-1.1,0.2-2.1,0.4-3.2,0.8c-0.3,0.1-0.7,0.1-0.9-0.1l-4.1-1.9c-0.3-0.1-0.7-0.1-0.9,0l-4,2.3c-0.1,0.1-0.2,0.2-0.2,0.3l0,0l0,3.5 l0,0c0,0.1,0.1,0.2,0.2,0.3l1.9,1.3c-0.1,0.1-0.3,0.2-0.5,0.2l-5.4,0.3c-0.3,0-0.5,0.3-0.5,0.5l0,2.3c0,0,0,0,0,0l0,4.2 c0,0.3,0.2,0.5,0.5,0.5l5.4,0.3c0.2,0,0.3,0.1,0.5,0.2l-1.8,1.3c-0.1,0.1-0.2,0.2-0.2,0.3l0,0l0,3.5l0,0c0,0.1,0.1,0.2,0.2,0.3 l4,2.3c0.2,0.1,0.6,0.2,0.9,0l4.1-1.9c0.3-0.1,0.7-0.1,0.9-0.1c1,0.3,2.1,0.6,3.2,0.8c0.3,0,0.5,0.3,0.6,0.6l0.5,2.7 c0.1,0.3,0.3,0.5,0.6,0.5h5.9c0.3,0,0.5-0.2,0.6-0.5l0.5-2.7c0.1-0.3,0.3-0.5,0.6-0.6c1.1-0.2,2.2-0.4,3.2-0.8 c0.3-0.1,0.7-0.1,0.9,0.1l4.1,1.9c0.3,0.1,0.7,0.1,0.9,0l4-2.3c0.1-0.1,0.2-0.2,0.2-0.3l0,0l0-3.5l0,0c0-0.1-0.1-0.2-0.2-0.3 l-1.9-1.3c0.1-0.1,0.3-0.2,0.5-0.2l5.4-0.3c0.3,0,0.5-0.3,0.5-0.5l0-3.5c0,0,0,0,0,0l0-3c0-0.3-0.2-0.5-0.5-0.5l-5.4-0.3 c-0.2,0-0.3-0.1-0.5-0.2l1.8-1.3c0.1-0.1,0.2-0.2,0.2-0.3l0,0l0-3.5l0,0C315,214,314.9,213.9,314.8,213.9z M287.6,222.9 c0.3-1,1.1-1.9,2.6-2.8c3.8-2.2,9.8-2.2,13.6,0c1.4,0.8,2.3,1.7,2.7,2.6c-0.3,1.1-1.2,2.2-2.7,3c-3.8,2.2-9.8,2.2-13.6,0 C288.9,224.9,288,223.9,287.6,222.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M281.4,224.6c-0.1-0.2-0.4-0.5-0.7-0.5l-5.4-0.3c-0.3,0-0.5-0.3-0.5-0.5l0-0.7l0,4.2c0,0.3,0.2,0.5,0.5,0.5 l5.4,0.3c0.2,0,0.3,0.1,0.5,0.2l1.3-1c0.2-0.2,0.2-0.5,0.1-0.7C282.1,225.7,281.7,225.2,281.4,224.6z M279.1,217.6L279.1,217.6 c0,0.1,0.1,0.2,0.2,0.3l1.9,1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.5,0.7-1.1,1.1-1.6c0.2-0.2,0.2-0.5-0.1-0.7l-3.2-2.3 c-0.1-0.1-0.1-0.2-0.2-0.2L279.1,217.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M303.8,217.9c-3.8-2.2-9.8-2.2-13.6,0c-2.4,1.4-3.2,3.3-2.6,5c0.3-1,1.1-1.9,2.6-2.8c3.8-2.2,9.8-2.2,13.6,0 c1.4,0.8,2.3,1.7,2.7,2.6C307,221,306.1,219.2,303.8,217.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M319.3,223.3c0,0.2-0.2,0.4-0.5,0.5l-5.4,0.3c-0.1,0-0.2,0-0.3,0.1l0,3.5c0.1,0,0.2-0.1,0.3-0.1l5.4-0.3 c0.3,0,0.5-0.3,0.5-0.5L319.3,223.3z M315,214.1L315,214.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0.1l-3.2,2.3 c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0.1 c0.4,0.5,0.8,1,1.1,1.5c0.1,0.1,0.1,0.2,0.3,0.3l1.8-1.3c0.1-0.1,0.2-0.2,0.2-0.3l0,0L315,214.1z M315,229.5 c0,0.1-0.1,0.2-0.2,0.2l-4,2.3c-0.2,0.1-0.4,0.1-0.6,0.1l0,3.5c0.2,0,0.5,0,0.6-0.1l4-2.3c0.1-0.1,0.2-0.2,0.2-0.3L315,229.5z  M288.7,230.1c-0.1,0-0.3,0-0.4,0.1l-4.1,1.9c-0.1,0.1-0.2,0.1-0.4,0.1l0,3.5c0.1,0,0.3,0,0.4-0.1l4.1-1.9c0.1,0,0.3-0.1,0.4-0.1 L288.7,230.1z M300.5,234.4c-0.1,0.2-0.3,0.3-0.5,0.3l-5.9,0c-0.1,0-0.3,0-0.4-0.1l0,3.5c0.1,0.1,0.2,0.1,0.4,0.1l5.9,0 c0.2,0,0.4-0.1,0.5-0.3L300.5,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M319.3,223.3c0,0.2-0.2,0.4-0.5,0.5l-5.4,0.3c-0.1,0-0.2,0-0.3,0.1l0,3.5c0.1,0,0.2-0.1,0.3-0.1l5.4-0.3 c0.3,0,0.5-0.3,0.5-0.5L319.3,223.3z M315,214.1L315,214.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0.1l-3.2,2.3 c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0.1 c0.4,0.5,0.8,1,1.1,1.5c0.1,0.1,0.1,0.2,0.3,0.3l1.8-1.3c0.1-0.1,0.2-0.2,0.2-0.3l0,0L315,214.1z M315,229.5 c0,0.1-0.1,0.2-0.2,0.2l-4,2.3c-0.2,0.1-0.4,0.1-0.6,0.1l0,3.5c0.2,0,0.5,0,0.6-0.1l4-2.3c0.1-0.1,0.2-0.2,0.2-0.3L315,229.5z  M288.7,230.1c-0.1,0-0.3,0-0.4,0.1l-4.1,1.9c-0.1,0.1-0.2,0.1-0.4,0.1l0,3.5c0.1,0,0.3,0,0.4-0.1l4.1-1.9c0.1,0,0.3-0.1,0.4-0.1 L288.7,230.1z M300.5,234.4c-0.1,0.2-0.3,0.3-0.5,0.3l-5.9,0c-0.1,0-0.3,0-0.4-0.1l0,3.5c0.1,0.1,0.2,0.1,0.4,0.1l5.9,0 c0.2,0,0.4-0.1,0.5-0.3L300.5,234.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000078002853139739128960000012700428395870600356_",
    className: "st10",
    d: "M309.9,211.5l-4.1,1.9 c-0.3,0.1-0.7,0.1-0.9,0.1c-1-0.3-2.1-0.6-3.2-0.8c-0.3,0-0.5-0.3-0.6-0.6l-0.5-2.7c-0.1-0.3-0.3-0.5-0.6-0.5l-5.9,0 c-0.3,0-0.5,0.2-0.6,0.5l-0.5,2.7c-0.1,0.3-0.3,0.5-0.6,0.6c-1.1,0.2-2.1,0.4-3.2,0.8c-0.3,0.1-0.7,0.1-0.9-0.1l-4.1-1.9 c-0.3-0.1-0.7-0.1-0.9,0l-4,2.3c-0.2,0.1-0.3,0.4,0,0.5l3.2,2.3c0.2,0.2,0.2,0.4,0.1,0.7c-0.5,0.5-0.8,1-1.1,1.6 c-0.1,0.2-0.4,0.5-0.7,0.5l-5.4,0.3c-0.3,0-0.5,0.3-0.5,0.5l0,3c0,0.3,0.2,0.5,0.5,0.5l5.4,0.3c0.3,0,0.6,0.2,0.7,0.5 c0.3,0.5,0.7,1.1,1.1,1.6c0.2,0.2,0.2,0.5-0.1,0.7l-3.2,2.3c-0.2,0.2-0.2,0.4,0,0.5l4,2.3c0.2,0.1,0.6,0.2,0.9,0l4.1-1.9 c0.3-0.1,0.7-0.1,0.9-0.1c1,0.3,2.1,0.6,3.2,0.8c0.3,0,0.5,0.3,0.6,0.6l0.5,2.7c0.1,0.3,0.3,0.5,0.6,0.5l5.9,0 c0.3,0,0.5-0.2,0.6-0.5l0.5-2.7c0.1-0.3,0.3-0.5,0.6-0.6c1.1-0.2,2.1-0.4,3.2-0.8c0.3-0.1,0.7-0.1,0.9,0.1l4.1,1.9 c0.3,0.1,0.7,0.1,0.9,0l4-2.3c0.2-0.1,0.3-0.4,0-0.5l-3.2-2.3c-0.2-0.2-0.2-0.4-0.1-0.7c0.5-0.5,0.8-1,1.1-1.6 c0.1-0.2,0.4-0.5,0.7-0.5l5.4-0.3c0.3,0,0.5-0.3,0.5-0.5l0-3c0-0.3-0.2-0.5-0.5-0.5l-5.4-0.3c-0.3,0-0.6-0.2-0.7-0.5 c-0.3-0.5-0.7-1.1-1.1-1.6c-0.2-0.2-0.2-0.5,0.1-0.7l3.2-2.3c0.2-0.2,0.2-0.4,0-0.5l-4-2.3C310.5,211.4,310.1,211.4,309.9,211.5z  M303.9,217.9c3.8,2.2,3.8,5.7,0,7.8c-3.8,2.2-9.8,2.2-13.6,0c-3.8-2.2-3.8-5.7,0-7.8C294,215.7,300.1,215.7,303.9,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000153704010743088296640000012095038375428263072_",
    className: "st32",
    d: "M309.9,211.5l-4.1,1.9 c-0.3,0.1-0.7,0.1-0.9,0.1c-1-0.3-2.1-0.6-3.2-0.8c-0.3,0-0.5-0.3-0.6-0.6l-0.5-2.7c-0.1-0.3-0.3-0.5-0.6-0.5l-5.9,0 c-0.3,0-0.5,0.2-0.6,0.5l-0.5,2.7c-0.1,0.3-0.3,0.5-0.6,0.6c-1.1,0.2-2.1,0.4-3.2,0.8c-0.3,0.1-0.7,0.1-0.9-0.1l-4.1-1.9 c-0.3-0.1-0.7-0.1-0.9,0l-4,2.3c-0.2,0.1-0.3,0.4,0,0.5l3.2,2.3c0.2,0.2,0.2,0.4,0.1,0.7c-0.5,0.5-0.8,1-1.1,1.6 c-0.1,0.2-0.4,0.5-0.7,0.5l-5.4,0.3c-0.3,0-0.5,0.3-0.5,0.5l0,3c0,0.3,0.2,0.5,0.5,0.5l5.4,0.3c0.3,0,0.6,0.2,0.7,0.5 c0.3,0.5,0.7,1.1,1.1,1.6c0.2,0.2,0.2,0.5-0.1,0.7l-3.2,2.3c-0.2,0.2-0.2,0.4,0,0.5l4,2.3c0.2,0.1,0.6,0.2,0.9,0l4.1-1.9 c0.3-0.1,0.7-0.1,0.9-0.1c1,0.3,2.1,0.6,3.2,0.8c0.3,0,0.5,0.3,0.6,0.6l0.5,2.7c0.1,0.3,0.3,0.5,0.6,0.5l5.9,0 c0.3,0,0.5-0.2,0.6-0.5l0.5-2.7c0.1-0.3,0.3-0.5,0.6-0.6c1.1-0.2,2.1-0.4,3.2-0.8c0.3-0.1,0.7-0.1,0.9,0.1l4.1,1.9 c0.3,0.1,0.7,0.1,0.9,0l4-2.3c0.2-0.1,0.3-0.4,0-0.5l-3.2-2.3c-0.2-0.2-0.2-0.4-0.1-0.7c0.5-0.5,0.8-1,1.1-1.6 c0.1-0.2,0.4-0.5,0.7-0.5l5.4-0.3c0.3,0,0.5-0.3,0.5-0.5l0-3c0-0.3-0.2-0.5-0.5-0.5l-5.4-0.3c-0.3,0-0.6-0.2-0.7-0.5 c-0.3-0.5-0.7-1.1-1.1-1.6c-0.2-0.2-0.2-0.5,0.1-0.7l3.2-2.3c0.2-0.2,0.2-0.4,0-0.5l-4-2.3C310.5,211.4,310.1,211.4,309.9,211.5z  M303.9,217.9c3.8,2.2,3.8,5.7,0,7.8c-3.8,2.2-9.8,2.2-13.6,0c-3.8-2.2-3.8-5.7,0-7.8C294,215.7,300.1,215.7,303.9,217.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000047049399407153630750000016732911107258497416_",
    className: "st33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M318.9,223.4L318.9,223.4c0,0.1-0.1,0.1-0.2,0.1l-5.4,0.3c-0.4,0-0.8,0.3-1,0.6l0,0c0,0.1-0.1,0.1-0.1,0.2 c-0.3,0.5-0.6,0.9-1,1.4c0,0-0.1,0.1-0.1,0.1c-0.2,0.3-0.1,0.8,0.2,1l3.2,2.3l-4,2.3c-0.1,0.1-0.4,0.1-0.6,0l-4.1-1.9 c-0.3-0.1-0.8-0.2-1.2-0.1c-1,0.3-2,0.6-3.1,0.7c-0.3,0.1-0.6,0.3-0.8,0.5c-0.1,0.1-0.1,0.2-0.1,0.3l-0.5,2.7c0,0,0,0,0,0.1 c0,0.1-0.1,0.1-0.2,0.1l-5.9,0c-0.1,0-0.2-0.1-0.3-0.2l-0.5-2.7c-0.1-0.4-0.5-0.8-0.9-0.8c-1.1-0.2-2.1-0.4-3.1-0.7 c-0.3-0.1-0.9-0.1-1.2,0.1l-4.1,1.9c-0.2,0.1-0.4,0.1-0.6,0l-4-2.3l3.2-2.3c0.1-0.1,0.2-0.2,0.2-0.2c0.2-0.3,0.1-0.7-0.1-0.9 c-0.4-0.5-0.8-1-1.1-1.5c-0.2-0.4-0.6-0.6-1-0.7l-5.4-0.3c-0.1,0-0.2-0.1-0.2-0.2l0-3c0,0,0-0.1,0-0.1c0-0.1,0.1-0.1,0.2-0.1 l5.4-0.3c0.4,0,0.8-0.3,1-0.6l0,0c0-0.1,0.1-0.1,0.1-0.2c0.3-0.5,0.6-0.9,1-1.4c0,0,0.1-0.1,0.1-0.1c0.2-0.3,0.1-0.8-0.2-1 l-3.2-2.3l4-2.3c0.1-0.1,0.4-0.1,0.6,0l4.1,1.9c0.3,0.1,0.8,0.2,1.2,0.1c1-0.3,2-0.6,3.1-0.7c0.3-0.1,0.6-0.3,0.8-0.5 c0.1-0.1,0.1-0.2,0.1-0.3l0.5-2.7c0,0,0,0,0-0.1c0-0.1,0.1-0.1,0.2-0.1l5.9,0c0.1,0,0.2,0.1,0.3,0.2l0.5,2.7 c0.1,0.4,0.5,0.8,0.9,0.8c1.1,0.2,2.1,0.4,3.1,0.7c0.3,0.1,0.9,0.1,1.2-0.1l4.1-1.9c0.2-0.1,0.4-0.1,0.6,0l4,2.3l-3.2,2.3 c-0.1,0.1-0.2,0.2-0.2,0.2c-0.2,0.3-0.1,0.7,0.1,0.9c0.4,0.5,0.8,1,1.1,1.5c0.2,0.4,0.6,0.6,1,0.7l5.4,0.3 c0.1,0,0.2,0.1,0.2,0.2L318.9,223.4C319,223.3,319,223.3,318.9,223.4 M287.6,219.9c-1.2,2.2-0.3,4.6,2.4,6.1 c3.8,2.2,10.1,2.2,13.9,0c1.1-0.6,1.9-1.4,2.4-2.3c0.6-1.1,0.7-2.2,0.3-3.3c-0.4-1.1-1.4-2.1-2.7-2.9c-3.8-2.2-10.1-2.2-13.9,0 C289,218.2,288.1,219,287.6,219.9 M319.2,223.5c0-0.1,0.1-0.2,0.1-0.3l0-3c0-0.3-0.2-0.5-0.5-0.5l-5.4-0.3 c-0.3,0-0.6-0.2-0.7-0.5c-0.3-0.5-0.7-1.1-1.1-1.6c-0.1-0.2-0.2-0.4-0.1-0.5c0-0.1,0.1-0.1,0.1-0.1l3.2-2.3 c0.1,0,0.1-0.1,0.1-0.1c0.1-0.1,0-0.3-0.1-0.4l-4-2.3c-0.2-0.1-0.6-0.2-0.9,0l-4.1,1.9c-0.3,0.1-0.7,0.1-0.9,0.1 c-1-0.3-2.1-0.6-3.2-0.8c-0.3,0-0.5-0.3-0.6-0.6l-0.5-2.7c-0.1-0.3-0.3-0.5-0.6-0.5l-5.9,0c-0.2,0-0.4,0.1-0.5,0.3 c0,0.1-0.1,0.1-0.1,0.2l-0.5,2.7c0,0.1,0,0.1-0.1,0.2c-0.1,0.2-0.3,0.3-0.5,0.4c-1.1,0.2-2.1,0.4-3.2,0.8 c-0.3,0.1-0.7,0.1-0.9-0.1l-4.1-1.9c-0.3-0.1-0.7-0.1-0.9,0l-4,2.3c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1,0,0.3,0.1,0.4l3.2,2.3 c0.2,0.1,0.2,0.4,0.1,0.6c0,0,0,0.1-0.1,0.1c-0.4,0.5-0.8,0.9-1,1.4c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0 c-0.1,0.2-0.4,0.4-0.7,0.5l-5.4,0.3c-0.2,0-0.3,0.1-0.4,0.3c0,0.1-0.1,0.2-0.1,0.3l0,3c0,0.3,0.2,0.5,0.5,0.5l5.4,0.3 c0.3,0,0.6,0.2,0.7,0.5c0.3,0.5,0.7,1.1,1.1,1.6c0.1,0.2,0.2,0.4,0.1,0.5c0,0.1-0.1,0.1-0.1,0.1l-3.2,2.3 c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0.1,0,0.3,0.1,0.4l4,2.3c0.2,0.1,0.6,0.2,0.9,0l4.1-1.9c0.3-0.1,0.7-0.1,0.9-0.1 c1,0.3,2.1,0.6,3.2,0.8c0.3,0,0.5,0.3,0.6,0.6l0.5,2.7c0.1,0.3,0.3,0.5,0.6,0.5l5.9,0c0.2,0,0.4-0.1,0.5-0.3 c0-0.1,0.1-0.1,0.1-0.2l0.5-2.7c0-0.1,0-0.1,0.1-0.2c0.1-0.2,0.3-0.3,0.5-0.4c1.1-0.2,2.1-0.4,3.2-0.8c0.3-0.1,0.7-0.1,0.9,0.1 l4.1,1.9c0.3,0.1,0.7,0.1,0.9,0l4-2.3c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0-0.3-0.1-0.4l-3.2-2.3c-0.2-0.1-0.2-0.4-0.1-0.6 c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-0.9,1-1.4c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0c0.1-0.2,0.4-0.4,0.7-0.5l5.4-0.3 C319,223.8,319.1,223.7,319.2,223.5L319.2,223.5z M287.9,220c0.5-0.8,1.2-1.5,2.3-2.2c3.8-2.2,9.8-2.2,13.6,0 c2.7,1.5,3.4,3.8,2.3,5.7c-0.5,0.8-1.2,1.5-2.3,2.2c-3.8,2.2-9.8,2.2-13.6,0C287.6,224.2,286.8,222,287.9,220L287.9,220z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_00000121238495498801299010000011457758138691474621_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud_00000141430670715220781180000012735856742570383795_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000160882334740807729340000000432546399473429429_",
    className: "st34",
    d: "M140.7,42.4L140.7,42.4l-0.2-0.1 c0,0-0.1,0-0.1-0.1l-4-2.3c0-0.1,0-0.2,0-0.3c0-4.9-1.7-8.4-4.3-9.8l0,0l-7.7-4.5l0,0c-2.1-1.2-4.9-1.1-7.9,0.6 c-1.3,0.8-2.6,1.8-3.8,3c-0.5-0.5-1.1-1-1.7-1.3l0,0l-7.5-4.3l0,0c-2.7-1.8-6.4-1.8-10.4,0.5c-8.5,4.9-15.3,18-15.3,29.2 c0,1.3,0.1,2.6,0.3,3.7l-1.1,0.6c-5.4,3.1-9.7,11.4-9.7,18.6l0,0c0,4,1.3,6.8,3.4,8l0,0l7.8,4.5l0,0c1.7,1,3.9,0.9,6.3-0.5L99,80 l37.7-21.8c3.2-1.9,5.8-6.9,5.8-11.2v0C142.6,44.8,141.9,43.2,140.7,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142173816566930715190000006129646074078058156_",
    className: "st18",
    d: "M140.7,42.4L140.7,42.4l-0.2-0.1 c0,0-0.1,0-0.1-0.1l-4-2.3c0-0.1,0-0.2,0-0.3c0-4.9-1.7-8.4-4.3-9.8l0,0l-7.7-4.5l0,0c-2.1-1.2-4.9-1.1-7.9,0.6 c-1.3,0.8-2.6,1.8-3.8,3c-0.5-0.5-1.1-1-1.7-1.3l0,0l-7.5-4.3l0,0c-2.7-1.8-6.4-1.8-10.4,0.5c-8.5,4.9-15.3,18-15.3,29.2 c0,1.3,0.1,2.6,0.3,3.7l-1.1,0.6c-5.4,3.1-9.7,11.4-9.7,18.6l0,0c0,4,1.3,6.8,3.4,8l0,0l7.8,4.5l0,0c1.7,1,3.9,0.9,6.3-0.5L99,80 l37.7-21.8c3.2-1.9,5.8-6.9,5.8-11.2v0C142.6,44.8,141.9,43.2,140.7,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000016054471259654403770000007930981104570256795_",
    className: "st35",
    d: "M132.2,29.8L132.2,29.8 c-2.1-1.2-4.9-1-7.8,0.7c-1.4,0.8-2.8,1.9-4,3.2l-7.1-4.1l-0.7-0.4c0.1-0.1,0.1-0.1,0.2-0.2c1.2-1.2,2.5-2.3,3.8-3 c3-1.7,5.8-1.9,7.9-0.6l0,0L132.2,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000139278271467956877500000000325325690641404590_",
    className: "st36",
    d: "M112.7,29c0.2,0.2,0.4,0.4,0.5,0.6 l-0.7-0.4C112.6,29.1,112.7,29.1,112.7,29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000066489932506096591330000012076082617895762839_",
    className: "st35",
    d: "M110.9,27.6L110.9,27.6 c-2.7-1.5-6.1-1.3-9.9,0.9c-3.8,2.2-7.3,6.1-10,10.8l-7.8-4.5c2.7-4.7,6.2-8.6,10-10.8c4-2.3,7.7-2.4,10.4-0.5l0,0L110.9,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000090998779462288129510000009648837044541591997_",
    className: "st35",
    d: "M85.9,61.4L84.9,62 c-3.6,2.1-6.8,6.6-8.5,11.5L68.6,69c1.3-3.9,3.6-7.6,6.3-10l3.2-2.2L85.9,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000065791870254853740110000001661549294851583142_",
    className: "st34",
    d: "M136.8,42.6l-0.6,0.3 c0.2-1.1,0.2-2.2,0.2-3.3c0-8.9-5.4-13-12.1-9.2c-3.1,1.8-5.9,5-8.1,8.8c-0.3-10.7-7-15.6-15.3-10.8c-8.5,4.9-15.3,18-15.3,29.2 c0,1.3,0.1,2.6,0.3,3.7L84.9,62c-5.4,3.1-9.7,11.4-9.7,18.6l0,0c0,7.2,4.4,10.6,9.7,7.5L99,80l0,0l37.7-21.8 c3.2-1.9,5.8-6.9,5.8-11.2v0C142.6,42.7,140,40.7,136.8,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000083787959500848643470000007786877892365134985_",
    className: "st31",
    d: "M136.8,42.6l-0.6,0.3 c0.2-1.1,0.2-2.2,0.2-3.3c0-8.9-5.4-13-12.1-9.2c-3.1,1.8-5.9,5-8.1,8.8c-0.3-10.7-7-15.6-15.3-10.8c-8.5,4.9-15.3,18-15.3,29.2 c0,1.3,0.1,2.6,0.3,3.7L84.9,62c-5.4,3.1-9.7,11.4-9.7,18.6l0,0c0,7.2,4.4,10.6,9.7,7.5L99,80l0,0l37.7-21.8 c3.2-1.9,5.8-6.9,5.8-11.2v0C142.6,42.7,140,40.7,136.8,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000068651442974769612270000009800250988301534382_",
    className: "st31",
    d: "M81.1,87.3c-2.4,0-3.9-2.6-3.9-6.7 c0-6.4,4-14.1,8.7-16.9l1.1-0.6c0.7-0.4,1.1-1.2,1-2l0,0c-0.2-1.1-0.3-2.2-0.3-3.4c0-10.6,6.4-23,14.3-27.5 c1.8-1,3.5-1.6,5.1-1.6c4.3,0,7,4.1,7.2,10.7v0c0.1,2,2.7,2.7,3.7,0.9l0,0c2.1-3.6,4.7-6.5,7.3-8c1.4-0.8,2.6-1.2,3.8-1.2 c3.2,0,5.3,3.4,5.3,8.6c0,1-0.1,2-0.2,3l0,0c-0.2,1.6,1.5,2.8,3,2l0.6-0.3c0.5-0.3,0.9-0.4,1.3-0.4c1.1,0,1.5,1.6,1.5,3.1 c0,3.6-2.2,7.9-4.8,9.4l-51.9,30C82.9,87,81.9,87.3,81.1,87.3C81.1,87.3,81.1,87.3,81.1,87.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M103.2,117.1c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C103.6,116.9,103.4,117.1,103.2,117.1z M103.2,111.9c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C103.6,111.7,103.4,111.9,103.2,111.9z M103.2,106.7c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C103.6,106.5,103.4,106.7,103.2,106.7z M103.2,101.6c-0.2,0-0.4-0.2-0.4-0.4l0-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4l0,2.6 C103.6,101.4,103.4,101.6,103.2,101.6z M103.2,96.4c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C103.6,96.2,103.4,96.4,103.2,96.4z M103.2,91.2c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C103.6,91,103.4,91.2,103.2,91.2z M103.2,86c-0.2,0-0.4-0.2-0.4-0.4v-1.5c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v1.5 C103.6,85.8,103.4,86,103.2,86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M103.2,121c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v1.3 C103.6,120.8,103.4,121,103.2,121z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M110.4,112.9c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v2.6 C110.8,112.7,110.6,112.9,110.4,112.9z M110.4,107.8c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 v2.6C110.8,107.6,110.6,107.8,110.4,107.8z M110.4,102.6c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4 c0.2,0,0.4,0.2,0.4,0.4v2.6C110.8,102.4,110.6,102.6,110.4,102.6z M110.4,97.4c-0.2,0-0.4-0.2-0.4-0.4l0-2.6 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4l0,2.6C110.8,97.2,110.6,97.4,110.4,97.4z M110.4,92.2c-0.2,0-0.4-0.2-0.4-0.4 v-2.6c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v2.6C110.8,92,110.6,92.2,110.4,92.2z M110.4,87.1c-0.2,0-0.4-0.2-0.4-0.4V84 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v2.6C110.8,86.9,110.6,87.1,110.4,87.1z M110.4,81.9c-0.2,0-0.4-0.2-0.4-0.4V80 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v1.5C110.8,81.7,110.6,81.9,110.4,81.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M110.4,116.9c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v1.3 C110.8,116.7,110.6,116.9,110.4,116.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M117.6,108.8c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C118,108.6,117.8,108.8,117.6,108.8z M117.6,103.6c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C118,103.4,117.8,103.6,117.6,103.6z M117.6,98.4c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V98 C118,98.2,117.8,98.4,117.6,98.4z M117.6,93.3c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C118,93.1,117.8,93.3,117.6,93.3z M117.6,88.1c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C118,87.9,117.8,88.1,117.6,88.1z M117.6,82.9c-0.2,0-0.4-0.2-0.4-0.4v-2.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.6 C118,82.7,117.8,82.9,117.6,82.9z M117.6,77.7c-0.2,0-0.4-0.2-0.4-0.4v-1.5c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v1.5 C118,77.5,117.8,77.7,117.6,77.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M117.6,112.7c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v1.3 C118,112.5,117.8,112.7,117.6,112.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M94.9,90.7c-0.3,0-0.5-0.2-0.5-0.5V89c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.2 C95.4,90.5,95.2,90.7,94.9,90.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M94.9,103c-0.3,0-0.5-0.2-0.5-0.5v-2.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2.7 C95.4,102.8,95.2,103,94.9,103z M94.9,96.9c-0.3,0-0.5-0.2-0.5-0.5v-2.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2.7 C95.4,96.6,95.2,96.9,94.9,96.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M93.8,108.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.6l0.8-0.5v-1c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5v1.5l-1.3,0.7C94,108.2,93.9,108.3,93.8,108.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M56.5,129.8c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5-0.1,0.6,0.2 c0.1,0.2,0.1,0.5-0.2,0.6l-2.1,1.2C56.7,129.7,56.6,129.8,56.5,129.8z M61.2,127.1c-0.2,0-0.3-0.1-0.4-0.2 c-0.1-0.2-0.1-0.5,0.2-0.6L63,125c0.2-0.1,0.5-0.1,0.6,0.2c0.1,0.2,0.1,0.5-0.2,0.6l-2.1,1.2C61.3,127.1,61.3,127.1,61.2,127.1z  M65.8,124.4c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5-0.1,0.6,0.2c0.1,0.2,0.1,0.5-0.2,0.6 l-2.1,1.2C66,124.4,65.9,124.4,65.8,124.4z M70.5,121.7c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.6l2.1-1.2 c0.2-0.1,0.5-0.1,0.6,0.2c0.1,0.2,0.1,0.5-0.2,0.6l-2.1,1.2C70.7,121.7,70.6,121.7,70.5,121.7z M75.2,119 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.6L77,117c0.2-0.1,0.5-0.1,0.6,0.2c0.1,0.2,0.1,0.5-0.2,0.6l-2.1,1.2 C75.3,119,75.3,119,75.2,119z M79.8,116.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5-0.1,0.6,0.2 c0.1,0.2,0.1,0.5-0.2,0.6l-2.1,1.2C80,116.3,79.9,116.3,79.8,116.3z M84.5,113.6c-0.2,0-0.3-0.1-0.4-0.2 c-0.1-0.2-0.1-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5-0.1,0.6,0.2c0.1,0.2,0.1,0.5-0.2,0.6l-2.1,1.2C84.7,113.6,84.6,113.6,84.5,113.6 z M89.2,110.9c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5-0.1,0.6,0.2c0.1,0.2,0.1,0.5-0.2,0.6 l-2.1,1.2C89.3,110.9,89.3,110.9,89.2,110.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M52.8,133.1c-0.3,0-0.5-0.2-0.5-0.5v-1.5l1.3-0.7c0.2-0.1,0.5-0.1,0.6,0.2c0.1,0.2,0.1,0.5-0.2,0.6 l-0.8,0.5v1C53.3,132.9,53.1,133.1,52.8,133.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M52.8,205.5c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,205.3,53.1,205.5,52.8,205.5z M52.8,200c-0.3,0-0.5-0.2-0.5-0.5V197c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,199.7,53.1,200,52.8,200z M52.8,194.4c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,194.2,53.1,194.4,52.8,194.4z M52.8,188.8c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,188.6,53.1,188.8,52.8,188.8z M52.8,183.2c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,183,53.1,183.2,52.8,183.2z M52.8,177.7c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,177.5,53.1,177.7,52.8,177.7z M52.8,172.1c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,171.9,53.1,172.1,52.8,172.1z M52.8,166.5c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,166.3,53.1,166.5,52.8,166.5z M52.8,161c-0.3,0-0.5-0.2-0.5-0.5V158c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,160.7,53.1,161,52.8,161z M52.8,155.4c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,155.2,53.1,155.4,52.8,155.4z M52.8,149.8c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,149.6,53.1,149.8,52.8,149.8z M52.8,144.2c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,144,53.1,144.2,52.8,144.2z M52.8,138.7c-0.3,0-0.5-0.2-0.5-0.5v-2.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.5 C53.3,138.5,53.1,138.7,52.8,138.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M52.8,209.9c-0.3,0-0.5-0.2-0.5-0.5v-1.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v1.2 C53.3,209.6,53.1,209.9,52.8,209.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M201.6,101.3c-0.3,0-0.5-0.2-0.5-0.5v-1.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v1.2 C202,101.1,201.8,101.3,201.6,101.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M201.6,97.2c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,97,201.8,97.2,201.6,97.2z M201.6,91.9c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,91.7,201.8,91.9,201.6,91.9z M201.6,86.7c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,86.4,201.8,86.7,201.6,86.7z M201.6,81.4c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,81.2,201.8,81.4,201.6,81.4z M201.6,76.1c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,75.9,201.8,76.1,201.6,76.1z M201.6,70.9c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,70.7,201.8,70.9,201.6,70.9z M201.6,65.6c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,65.4,201.8,65.6,201.6,65.6z M201.6,60.4c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,60.2,201.8,60.4,201.6,60.4z M201.6,55.1c-0.3,0-0.5-0.2-0.5-0.5v-2.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.3 C202,54.9,201.8,55.1,201.6,55.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M201.6,49.9c-0.3,0-0.5-0.2-0.5-0.5V49l-0.4,0.2c-0.2,0.1-0.5,0-0.6-0.2c-0.1-0.2,0-0.5,0.2-0.6l1.8-1v2 C202,49.6,201.8,49.9,201.6,49.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M129.6,89.7c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2 c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C129.7,89.7,129.7,89.7,129.6,89.7z M134.3,87c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6 l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C134.5,87,134.4,87,134.3,87z M139,84.3c-0.2,0-0.3-0.1-0.4-0.2 c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C139.2,84.3,139.1,84.3,139,84.3z  M143.8,81.6c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2 C143.9,81.6,143.8,81.6,143.8,81.6z M148.5,78.9c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2 c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C148.7,78.9,148.6,78.9,148.5,78.9z M153.2,76.2c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6 l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C153.4,76.2,153.3,76.2,153.2,76.2z M158,73.5 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2 C158.1,73.5,158,73.5,158,73.5z M162.7,70.8c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2 c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C162.8,70.8,162.8,70.8,162.7,70.8z M167.4,68.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6 l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C167.6,68.1,167.5,68.1,167.4,68.1z M172.1,65.4 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2 C172.3,65.4,172.2,65.4,172.1,65.4z M176.9,62.7c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2 c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C177,62.7,176.9,62.7,176.9,62.7z M181.6,60c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6 l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C181.8,60,181.7,60,181.6,60z M186.3,57.3 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2 C186.5,57.3,186.4,57.3,186.3,57.3z M191.1,54.6c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2 c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C191.2,54.6,191.1,54.6,191.1,54.6z M195.8,51.9c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.5,0.2-0.6 l2.1-1.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0,0.5-0.2,0.6l-2.1,1.2C195.9,51.9,195.9,51.9,195.8,51.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M125.4,92.2v-2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v0.4l0.4-0.2c0.2-0.1,0.5,0,0.6,0.2 c0.1,0.2,0,0.5-0.2,0.6L125.4,92.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M125.9,87.8c-0.3,0-0.5-0.2-0.5-0.5v-2.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.2 C126.3,87.6,126.1,87.8,125.9,87.8z M125.9,82.9c-0.3,0-0.5-0.2-0.5-0.5v-2.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.2 C126.3,82.6,126.1,82.9,125.9,82.9z M125.9,77.9c-0.3,0-0.5-0.2-0.5-0.5v-2.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.2 C126.3,77.7,126.1,77.9,125.9,77.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M125.9,72.9c-0.3,0-0.5-0.2-0.5-0.5v-1.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v1.2 C126.3,72.7,126.1,72.9,125.9,72.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Conection"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box_12_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000132784167638292108130000016579618445921360826_",
    className: "st26",
    d: "M120.6,280.7l-19.1,11 c-0.4,0.2-1.1,0.2-1.5,0l-12.7-7.3l-7.3-4.2c-0.4-0.2-0.4-0.6,0-0.9l19.1-11c0.4-0.2,1.1-0.2,1.5,0l19.9,11.5 C121,280,121,280.4,120.6,280.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Box_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5366_",
    className: "st38",
    d: "M121.2,277.7l-19.1,11c-0.4,0.2-1.1,0.2-1.5,0l-19.9-11.5c-0.4-0.2-0.8-0.8-0.8-1.3 l0-1.7c0-0.5,0.4-1.1,0.8-1.3l19.1-11c0.4-0.2,1.1-0.2,1.5,0l19.9,11.5c0.4,0.2,0.8,0.8,0.8,1.3l0,1.7 C122,276.9,121.7,277.4,121.2,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5365_",
    className: "st28",
    d: "M80.7,272.9c-0.4,0.2-0.8,0.9-0.8,1.3l0,1.7c0,0.5,0.3,1.1,0.8,1.3l19.9,11.5 c0.2,0.1,0.5,0.2,0.8,0.2l0-3.4c-0.3,0-0.6-0.1-0.8-0.2l-19.9-11.5C80.4,273.6,80.3,273.2,80.7,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4746_",
    className: "st39",
    d: "M121.4,273.5c0.3,0.2,0.3,0.6-0.1,0.8l-19.1,11c-0.2,0.1-0.5,0.2-0.8,0.2l0,3.4 c0.3,0,0.5-0.1,0.7-0.2l19.1-11c0.4-0.2,0.8-0.8,0.8-1.3l0-1.7C122,274.3,121.8,273.7,121.4,273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M121.3,274.3l-19.1,11c-0.4,0.2-1.1,0.2-1.5,0L88,278l-7.3-4.2c-0.4-0.2-0.4-0.6,0-0.9l19.1-11 c0.4-0.2,1.1-0.2,1.5,0l19.9,11.5C121.7,273.6,121.7,274,121.3,274.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "World_00000173862613377459530670000018261973381805279164_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.3,269.3c-4.6-2.7-11.6-2.9-15.6-0.6c-1,0.6-1.8,1.3-2.2,2.1c-0.4,0.6-0.5,1.3-0.5,2 c0,1.9,1.4,3.8,3.9,5.2c4.6,2.7,11.6,2.9,15.6,0.6c1.8-1,2.8-2.5,2.8-4.1C112.1,272.6,110.7,270.7,108.3,269.3z M96.5,276.5 c1.8,1,3.9,1.7,6.1,2.1c-0.1,0.3-0.2,0.7-0.2,1c-2.8,0-5.6-0.7-7.9-1.9L96.5,276.5z M97.2,271.1c0.9-0.6,1.5-1.3,1.9-2 c2.1,0.3,4.1,1,5.8,1.9l-4,2.3L97.2,271.1z M105.5,271.3c1.6,0.9,2.7,2.1,3.4,3.2c-1.4,0.2-2.6,0.7-3.6,1.2l-3.7-2.2 L105.5,271.3z M109.1,275c0.4,1,0.4,2,0,3l-3.3-1.9C106.8,275.6,107.9,275.2,109.1,275z M108.5,278.2c-1.6,0.2-3.4,0.2-5.1,0 c0.4-0.7,1-1.3,1.9-1.8L108.5,278.2z M97,276.2l4-2.3l3.8,2.2c-0.8,0.5-1.5,1.2-1.9,1.9c0,0,0,0.1-0.1,0.1 C100.7,277.7,98.7,277.1,97,276.2z M96.5,275.9c-1.6-0.9-2.7-2.1-3.4-3.2c1.4-0.2,2.6-0.7,3.6-1.2l3.7,2.2L96.5,275.9z  M92.9,272.2c-0.4-1-0.4-2,0-3l3.3,1.9C95.3,271.6,94.1,271.9,92.9,272.2z M93.6,269c1.6-0.2,3.4-0.2,5.1,0 c-0.4,0.7-1,1.3-1.9,1.8L93.6,269z M99.4,268.6c0.1-0.3,0.2-0.7,0.2-1c2.8,0,5.6,0.7,7.9,1.9l-2.1,1.2 C103.7,269.7,101.6,269,99.4,268.6z M111.6,274.3c-0.8,0-1.5,0.1-2.2,0.2c-0.6-1.2-1.8-2.4-3.4-3.4l2.1-1.2 C110.2,271,111.5,272.7,111.6,274.3z M111.2,276.2c-0.3,0.5-0.8,1-1.4,1.5c0.3-0.9,0.2-1.8-0.1-2.7c0.6-0.1,1.3-0.1,2-0.2 C111.6,275.3,111.4,275.7,111.2,276.2z M102.9,279.6c0-0.3,0.1-0.7,0.2-1c1.5,0.2,3,0.3,4.5,0.2 C106.2,279.3,104.6,279.6,102.9,279.6z M90.4,272.9c0.7,0,1.5-0.1,2.2-0.2c0.6,1.2,1.8,2.4,3.4,3.5l-2.1,1.2 C91.8,276.1,90.5,274.5,90.4,272.9z M92.2,269.5c-0.3,0.9-0.2,1.8,0.1,2.7c-0.6,0.1-1.3,0.1-2,0.1 C90.5,271.3,91.2,270.3,92.2,269.5z M99.1,267.6c0,0.3-0.1,0.7-0.2,1c-1.5-0.2-3-0.3-4.5-0.2C95.8,267.9,97.4,267.6,99.1,267.6z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M91.4,264.3c0,0-0.1,0-0.1,0l-11.9-6.9c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1l11.9,6.9 c0.1,0.1,0.1,0.2,0.1,0.3C91.5,264.3,91.5,264.3,91.4,264.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M88,266.3c0,0-0.1,0-0.1,0l-11.9-6.9c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1l11.9,6.9 c0.1,0.1,0.1,0.2,0.1,0.3C88.1,266.3,88,266.3,88,266.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M84.5,268.3c0,0-0.1,0-0.1,0l-11.9-6.9c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1l11.9,6.9 c0.1,0.1,0.1,0.2,0.1,0.3C84.7,268.3,84.6,268.3,84.5,268.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M148,296.5c-0.6,0-1.1-0.1-1.6-0.4l-25.4-14.7c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1 l25.4,14.7c0.9,0.5,2,0.5,2.9,0l12.2-7c0.1-0.1,0.2,0,0.3,0.1c0.1,0.1,0,0.2-0.1,0.3l-12.2,7 C149.1,296.4,148.6,296.5,148,296.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M148,300.5c-0.6,0-1.1-0.1-1.6-0.4l-28.8-16.6c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1 l28.8,16.6c0.9,0.5,2,0.5,2.9,0l15.6-9c0.1-0.1,0.2,0,0.3,0.1c0.1,0.1,0,0.2-0.1,0.3l-15.6,9 C149.1,300.3,148.6,300.5,148,300.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M148,304.4c-0.6,0-1.1-0.1-1.6-0.4l-32.3-18.6c-0.1-0.1-0.1-0.2-0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1 l32.3,18.6c0.9,0.5,2,0.5,2.9,0l19-11c0.1-0.1,0.2,0,0.3,0.1c0.1,0.1,0,0.2-0.1,0.3l-19,11C149.1,304.3,148.6,304.4,148,304.4z "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "WiFi_00000042730693965412053750000011146344139222566334_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103251616544259819220000011149868008887218319_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060739867566446102310000009546781538413417386_",
    className: "st10",
    d: "M132.9,166.8c0.9-0.6,2-0.7,3.3-0.1 c3.2,1.4,6.1,6.4,6.6,11c0.3,2.8-0.4,4.8-1.7,5.7c-0.5,0.4-2.7,1.9-3.3,2.3c-0.9,0.6-2,0.7-3.3,0.1c-3.2-1.4-6.1-6.4-6.6-11 c-0.3-2.7,0.4-4.8,1.6-5.6C130.2,168.7,132.4,167.2,132.9,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000117641099471202602760000014038800067776994446_",
    className: "st24",
    d: "M132.9,166.8c0.9-0.6,2-0.7,3.3-0.1 c3.2,1.4,6.1,6.4,6.6,11c0.3,2.8-0.4,4.8-1.7,5.7c-0.5,0.4-2.7,1.9-3.3,2.3c-0.9,0.6-2,0.7-3.3,0.1c-3.2-1.4-6.1-6.4-6.6-11 c-0.3-2.7,0.4-4.8,1.6-5.6C130.2,168.7,132.4,167.2,132.9,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000079450490749211740730000007579886130513408660_",
    className: "st10",
    d: "M122.1,153.6c-1.9,1.3-3.4,3.5-4.3,6.4 c-0.5,1.4,0.1,3.6,1.2,5.3l0,0c1.1,1.6,2.4,2.1,3.3,1.6c0.3-0.2,3.3-2.3,3.9-2.8c0.3-0.2,0.5-0.5,0.6-0.9c0.3-1.1,0.8-2,1.3-2.8 c1.5-0.3,3.2-0.1,5.1,0.7c4.9,2.2,8.3,6.9,11,13.7c1,2.5,2.9,3.9,4.1,3l0,0c0.9-0.7,2.8-1.9,3.9-2.7l0,0c0.9-0.7,1-2.7,0.3-4.6 c-3.8-9.7-9.2-16.8-16.1-19.9c-4-1.8-7.6-1.6-10.3,0.3C125.4,151.2,122.7,153.1,122.1,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142146499765708666530000002728622521150926521_",
    className: "st24",
    d: "M122.1,153.6c-1.9,1.3-3.4,3.5-4.3,6.4 c-0.5,1.4,0.1,3.6,1.2,5.3l0,0c1.1,1.6,2.4,2.1,3.3,1.6c0.3-0.2,3.3-2.3,3.9-2.8c0.3-0.2,0.5-0.5,0.6-0.9c0.3-1.1,0.8-2,1.3-2.8 c1.5-0.3,3.2-0.1,5.1,0.7c4.9,2.2,8.3,6.9,11,13.7c1,2.5,2.9,3.9,4.1,3l0,0c0.9-0.7,2.8-1.9,3.9-2.7l0,0c0.9-0.7,1-2.7,0.3-4.6 c-3.8-9.7-9.2-16.8-16.1-19.9c-4-1.8-7.6-1.6-10.3,0.3C125.4,151.2,122.7,153.1,122.1,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062897566390872361970000013844608677257269397_",
    className: "st10",
    d: "M110.8,145.7c1.5-3.5,3.5-6,6-7.7 c0.7-0.5,3.5-2.4,4.2-2.8c4.3-2.7,12.7-3.8,19.1-0.6c10.4,5.2,17.5,12.6,22.6,26.7c1.2,3.4,0.3,5.2-0.7,6l0,0 c-1.1,0.9-2.9,2-3.9,2.7l0,0c-1.1,0.9-3-0.4-4-2.8c-5.1-11.6-11.5-18.3-19.9-22.1c-4.3-2-8.2-2.1-11.4-0.7 c-1.2,1.3-2.3,3-3.1,4.9c-0.1,0.3-0.3,0.6-0.6,0.8c-0.6,0.4-3.6,2.6-3.9,2.7c-0.8,0.6-2.2,0-3.3-1.5 C110.6,149.5,110.2,147.1,110.8,145.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000178900836448813010030000008321647813215960486_",
    className: "st24",
    d: "M110.8,145.7c1.5-3.5,3.5-6,6-7.7 c0.7-0.5,3.5-2.4,4.2-2.8c4.3-2.7,12.7-3.8,19.1-0.6c10.4,5.2,17.5,12.6,22.6,26.7c1.2,3.4,0.3,5.2-0.7,6l0,0 c-1.1,0.9-2.9,2-3.9,2.7l0,0c-1.1,0.9-3-0.4-4-2.8c-5.1-11.6-11.5-18.3-19.9-22.1c-4.3-2-8.2-2.1-11.4-0.7 c-1.2,1.3-2.3,3-3.1,4.9c-0.1,0.3-0.3,0.6-0.6,0.8c-0.6,0.4-3.6,2.6-3.9,2.7c-0.8,0.6-2.2,0-3.3-1.5 C110.6,149.5,110.2,147.1,110.8,145.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000173858859221305062410000018114082376545374879_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000005955863273212506870000005124652863872687774_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000158738496743902087280000010438466578041538184_",
    className: "st10",
    d: "M128,174.8c0.4,4.6,3.4,9.6,6.6,11 c3.2,1.4,5.4-1.1,4.9-5.8c-0.4-4.6-3.4-9.6-6.6-11C129.8,167.5,127.6,170.1,128,174.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000033343615005427407860000006336413507478455192_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000054954800098146709660000001916035333441436063_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000126325873474078642430000009837854141883696045_",
    className: "st10",
    d: "M117.8,159.9c-0.5,1.4,0.1,3.6,1.2,5.3 l0,0c1.4,2.1,3.3,2.4,3.9,0.6c1.6-4.9,5.4-7,10.3-4.8c4.9,2.2,8.3,6.9,11,13.7c1,2.5,2.3,4.1,4.1,3l0,0c1.5-1.1,1.5-3,0.8-5 c-3-9.2-7.3-15.9-16.7-19.6C125.3,150.5,120,153,117.8,159.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000018935840770466226970000009572176810652746640_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000124153189376403489220000002928794008673156262_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000135656495545400960970000009881749343787799984_",
    className: "st10",
    d: "M110.8,145.7c-0.6,1.4-0.1,3.8,1.1,5.5 l0,0c1.4,2,3.2,2.4,3.8,0.8c3.3-7.7,10.1-10.8,18.4-7c8.4,3.8,14.8,10.6,19.9,22.1c1,2.4,2.6,3.7,4,2.8l0,0 c2-1.4,1.3-4.2,0.5-6.3c-6.5-16.6-16.7-23.8-25.2-26.4C122.6,133.8,114.8,136.2,110.8,145.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M7.4,239.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C7.1,239.5,7.3,239.6,7.4,239.8z M6.8,240.6c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C6.6,240.6,6.7,240.6,6.8,240.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M5.5,236.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C5.2,235.8,5.4,235.8,5.5,236.1z M5,236.8c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C4.8,236.8,4.9,236.9,5,236.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,222.3 29.3,222.8 23.1,226.4 23.1,225.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "21.5,225.9 21.5,226.4 13.2,231.2 13.2,230.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M29.3,224.3l0,0.5l-10.1,5.8l-2.5,4.3l-9.3,5.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2l9.2-5.3l2.5-4.3 L29.3,224.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "18.4,230.6 16.3,234.2 8.9,238.5 8.9,238 16.1,233.8 17.4,231.7 8.9,236.6 8.9,236.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,221.2 29.3,221.7 23,225.3 21.9,227.2 12.5,232.6 11.4,232 10,232.8 10,232.3 11.6,231.4  12.7,232 21.7,226.8 22.8,224.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,223.4 29.3,223.9 7.2,236.7 7.2,236.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M11.1,232.8l0,0.5l-5.6,3.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2L11.1,232.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "18,226.7 18,227.2 7.3,233.4 7.3,232.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M18.3,225.4l1,0.6l9.9-5.7l0,0.5l-10.1,5.8l-1-0.6l-10.8,6.2c0-0.1,0-0.2,0-0.3s0-0.2,0-0.2L18.3,225.4z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,225.2 29.3,225.7 19.6,231.3 17.1,235.5 8.9,240.3 8.9,239.8 17,235.2 19.4,230.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M7.3,231.8c0,0.1,0,0.1,0,0.2s0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C7,231.5,7.3,231.6,7.3,231.8z M6.8,232.5c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C6.6,232.6,6.7,232.6,6.8,232.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M7.4,228.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C7.1,228.5,7.3,228.6,7.4,228.8z M6.8,229.6c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C6.6,229.6,6.7,229.6,6.8,229.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M5.5,225.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C5.2,224.8,5.4,224.9,5.5,225.1z M5,225.9c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C4.8,225.9,4.9,225.9,5,225.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,211.4 29.3,211.9 23.1,215.4 23.1,214.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "21.5,214.9 21.5,215.4 13.2,220.2 13.2,219.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M29.3,213.3l0,0.5l-10.1,5.8l-2.5,4.3l-9.3,5.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2l9.2-5.3l2.5-4.3 L29.3,213.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "18.4,219.6 16.3,223.3 8.9,227.5 8.9,227 16.1,222.9 17.4,220.7 8.9,225.6 8.9,225.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,210.2 29.3,210.7 23,214.3 21.9,216.2 12.5,221.7 11.4,221 10,221.8 10,221.3 11.6,220.4  12.7,221.1 21.7,215.9 22.8,213.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,212.5 29.3,213 7.2,225.7 7.2,225.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M11.1,221.8l0,0.5l-5.6,3.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2L11.1,221.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "18,215.8 18,216.3 7.3,222.5 7.3,222  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M18.3,214.5l1,0.6l9.9-5.7l0,0.5l-10.1,5.8l-1-0.6l-10.8,6.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2 L18.3,214.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.3,214.2 29.3,214.7 19.6,220.3 17.1,224.6 8.9,229.3 8.9,228.8 17,224.2 19.4,219.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M7.3,220.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C7,220.5,7.3,220.6,7.3,220.8z M6.8,221.6c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C6.6,221.6,6.7,221.6,6.8,221.6"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M76.2,226.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C75.9,226.3,76.1,226.4,76.2,226.6z M75.6,227.4c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C75.5,227.4,75.5,227.4,75.6,227.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M74.4,222.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C74.1,222.6,74.3,222.7,74.4,222.9z M73.8,223.7c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C73.6,223.7,73.7,223.7,73.8,223.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "98.1,209.2 98.1,209.7 92,213.2 92,212.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "90.3,212.7 90.3,213.2 82,218 82,217.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M98.1,211.1l0,0.5L88,217.5l-2.5,4.3l-9.3,5.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2l9.2-5.3l2.5-4.3 L98.1,211.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "87.2,217.4 85.1,221.1 77.7,225.3 77.7,224.8 84.9,220.7 86.2,218.5 77.7,223.4 77.7,222.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "98.1,208 98.1,208.5 91.8,212.1 90.7,214 81.3,219.5 80.2,218.8 78.8,219.6 78.8,219.1  80.4,218.2 81.5,218.9 90.5,213.6 91.7,211.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "98.1,210.3 98.1,210.8 76,223.5 76,223  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M80,219.6l0,0.5l-5.6,3.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2L80,219.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "86.9,213.6 86.9,214.1 76.1,220.3 76.1,219.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M87.2,212.2l1,0.6l9.9-5.7l0,0.5L88,213.4l-1-0.6l-10.8,6.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2 L87.2,212.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "98.1,212 98.1,212.5 88.4,218.1 86,222.4 77.7,227.1 77.7,226.6 85.8,222 88.3,217.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M76.2,218.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C75.9,218.3,76.1,218.4,76.2,218.6z M75.6,219.4c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C75.4,219.4,75.5,219.4,75.6,219.4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M84,213.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C83.7,212.8,84,212.9,84,213.1z M83.5,213.9c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C83.3,213.9,83.4,213.9,83.5,213.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M82.2,209.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C81.9,209.1,82.1,209.1,82.2,209.4z M81.6,210.1c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C81.5,210.2,81.5,210.2,81.6,210.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "105.9,195.7 105.9,196.2 99.8,199.7 99.8,199.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "98.1,199.2 98.1,199.7 89.8,204.5 89.8,204  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M105.9,197.6l0,0.5l-10.1,5.8l-2.5,4.3l-9.3,5.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2l9.2-5.3l2.5-4.3 L105.9,197.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "95.1,203.9 93,207.5 85.6,211.8 85.6,211.3 92.8,207.1 94,205 85.6,209.9 85.6,209.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "105.9,194.5 105.9,195 99.7,198.6 98.6,200.5 89.2,205.9 88.1,205.3 86.7,206.1 86.7,205.6  88.2,204.7 89.4,205.3 98.4,200.1 99.5,198.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "105.9,196.7 105.9,197.2 83.9,210 83.9,209.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M87.8,206.1l0,0.5l-5.6,3.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2L87.8,206.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "94.7,200 94.7,200.5 84,206.7 84,206.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M95,198.7l1,0.6l9.9-5.7l0,0.5l-10.1,5.8l-1-0.6L84,205.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2L95,198.7 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "105.9,198.5 106,199 96.3,204.6 93.8,208.9 85.6,213.6 85.6,213.1 93.6,208.5 96.1,204.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M84,205.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0-0.6-0.3 c0-0.4,0.3-0.9,0.6-1.1C83.7,204.8,83.9,204.9,84,205.1z M83.5,205.9c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.2-0.2-0.1 c-0.1,0.1-0.2,0.2-0.2,0.3C83.3,205.9,83.4,205.9,83.5,205.9"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M107.3,173.9c0.5-0.3,0.9,0,0.9,0.5c0,0.5-0.4,1.2-0.9,1.5c-0.4,0.2-0.7,0.1-0.8-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0.1-0.4C106.6,174.5,106.9,174.1,107.3,173.9z M107.3,175.1c0.1-0.1,0.2-0.3,0.2-0.4 c0-0.2-0.1-0.2-0.2-0.1c-0.1,0.1-0.2,0.3-0.2,0.4C107,175.2,107.2,175.2,107.3,175.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M107.3,185.2c0.5-0.3,0.9-0.1,0.9,0.5c0,0.5-0.4,1.2-0.9,1.5c-0.4,0.2-0.7,0.1-0.8-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0.1-0.4C106.6,185.8,107,185.4,107.3,185.2z M107.3,186.4c0.1-0.1,0.2-0.3,0.2-0.4 c0-0.2-0.1-0.2-0.2-0.1c-0.1,0.1-0.2,0.3-0.2,0.4C107.1,186.5,107.2,186.5,107.3,186.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109.1,180.2c0,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.2,0.1,0.3l-7.9,4.6l0-0.7L109.1,180.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "106.6,184.6 106.6,185.3 91.5,194 91.5,193.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "104.3,177.5 104.3,178.2 94.2,184 92.4,187.1 104.4,180.2 104.4,180.9 91,188.7 93.9,183.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "98.3,187.8 98.3,188.5 86.7,195.2 86.7,194.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.9,194.3l1.4,0.8l15.2-8.8c0,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.2,0.1,0.3l-15.5,8.9l-1.4-0.8l-14,8.1 l0-0.7L89.9,194.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "99.3,185.8 100.8,186.7 102.8,185.5 102.8,186.2 100.6,187.5 99,186.6 86.3,193.9 84.7,196.7  75.7,201.9 75.7,201.2 84.5,196.1 86.1,193.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "84.3,194.5 84.3,195.2 75.7,200.2 75.7,199.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "106.7,180 106.8,180.7 75.7,198.7 75.7,198  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M106.5,175c0,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.2,0.1,0.3l-12.9,7.4l-3.5,6l-14.5,8.4l0-0.7l14.2-8.2l3.5-6 L106.5,175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "104.3,174.9 104.3,175.6 93,182.2 89.5,188.2 75.6,196.2 75.6,195.5 89.3,187.7 92.7,181.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109.9,179.1c0.5-0.3,0.9-0.1,0.9,0.5c0,0.5-0.4,1.2-0.9,1.5c-0.4,0.2-0.7,0.1-0.8-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0.1-0.4C109.2,179.8,109.5,179.3,109.9,179.1z M109.9,180.4c0.1-0.1,0.2-0.3,0.2-0.4 c0-0.2-0.1-0.2-0.2-0.1c-0.1,0.1-0.2,0.3-0.2,0.4C109.6,180.4,109.7,180.5,109.9,180.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "48.6,173.6 48.6,197.4 48.1,197.7 48,173.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "49.6,171.7 49.7,196.8 49.1,197.1 49.1,172  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "49.6,164.7 49.6,170.2 47.5,173.8 47.6,198 47.1,198.3 47,173.8 49.1,170.3 49.1,165  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "50.6,164.1 50.7,196.2 50.2,196.5 50.1,164.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "52.7,169.8 52.8,195 52.3,195.3 52.2,170.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "54.8,168.6 54.9,193.8 54.4,194.1 54.3,168.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "55.9,166.2 56,193.2 55.4,193.5 55.4,166.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "55.5,158.7 55.5,165.6 53.8,168.5 53.9,194.4 53.3,194.7 53.3,168.5 54.9,165.6 54.9,159  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "54.3,159.4 54.3,166 51.7,170.6 51.8,195.6 51.2,195.9 51.2,170.6 53.8,166.1 53.8,159.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "56.9,159.8 57,192.6 56.5,192.9 56.4,160.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M22,170.1c0.4-0.2,0.7,0,0.7,0.4c0,0.4-0.2,0.8-0.5,1.1l0,37.6l-0.4,0.2l0-37.6c-0.3,0.1-0.5-0.1-0.5-0.5 C21.4,170.9,21.7,170.3,22,170.1z M22.1,171.3c0.2-0.1,0.3-0.4,0.3-0.6c0-0.2-0.1-0.3-0.3-0.2c-0.2,0.1-0.3,0.4-0.3,0.6 C21.7,171.3,21.9,171.4,22.1,171.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.7,169.2c0.4-0.2,0.7,0,0.7,0.4c0,0.4-0.2,0.8-0.5,1.1l0,37.6l-0.4,0.2l0-37.6 c-0.3,0.1-0.5-0.1-0.5-0.5C23,169.9,23.3,169.4,23.7,169.2z M23.7,170.3c0.2-0.1,0.3-0.4,0.3-0.6c0-0.2-0.1-0.3-0.3-0.2 s-0.3,0.4-0.3,0.6C23.3,170.4,23.5,170.5,23.7,170.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M25.3,168.2c0.4-0.2,0.7,0,0.7,0.4c0,0.4-0.2,0.8-0.5,1.1l0,37.6l-0.4,0.2l0-37.6 c-0.3,0.1-0.5-0.1-0.5-0.5C24.6,169,24.9,168.5,25.3,168.2z M25.3,169.4c0.2-0.1,0.3-0.4,0.3-0.6c0-0.2-0.1-0.3-0.3-0.2 c-0.2,0.1-0.3,0.4-0.3,0.6C25,169.4,25.1,169.5,25.3,169.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M26.9,167.3c0.4-0.2,0.7,0,0.7,0.4c0,0.4-0.2,0.8-0.5,1.1l0,37.6l-0.4,0.2l0-37.6 c-0.3,0.1-0.5-0.1-0.5-0.5C26.2,168.1,26.5,167.5,26.9,167.3z M26.9,168.5c0.2-0.1,0.3-0.4,0.3-0.6s-0.1-0.3-0.3-0.2 c-0.2,0.1-0.3,0.4-0.3,0.6C26.6,168.5,26.7,168.6,26.9,168.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M28.5,166.4c0.4-0.2,0.7,0,0.7,0.4c0,0.4-0.2,0.8-0.5,1.1l0,37.6l-0.4,0.2l0-37.6 c-0.3,0.1-0.5-0.1-0.5-0.5C27.8,167.1,28.2,166.6,28.5,166.4z M28.5,167.5c0.2-0.1,0.3-0.4,0.3-0.6c0-0.2-0.1-0.3-0.3-0.2 c-0.2,0.1-0.3,0.4-0.3,0.6C28.2,167.6,28.4,167.6,28.5,167.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M30.2,165.4c0.4-0.2,0.7,0,0.7,0.4c0,0.4-0.2,0.8-0.5,1.1l0,37.6l-0.4,0.2l0-37.6 c-0.3,0.1-0.5-0.1-0.5-0.5C29.5,166.2,29.8,165.7,30.2,165.4z M30.2,166.6c0.2-0.1,0.3-0.4,0.3-0.6c0-0.2-0.1-0.3-0.3-0.2 c-0.2,0.1-0.3,0.4-0.3,0.6C29.8,166.6,30,166.7,30.2,166.6"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M90.8,236.2l-30.1,17.4l-1.7-0.9l0-1.7l-28.5,16.4l0,3.6l-8.6,5l-1.7-0.9l-0.2-63.9 c5.4-9.4,8.4-14.6,13.8-24l8-4.6l1.7,0.9l0,5l9.9-5.7l0-6.9l11-6.4l1.7,0.9l0,5l9.9-5.7l0-6.9l12.9-7.5l1.7,0.9L90.8,236.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M90.8,236.2l-30.1,17.4l-1.7-0.9l0-1.7l-28.5,16.4l0,3.6l-8.6,5l-1.7-0.9l-0.2-63.9 c5.4-9.4,8.4-14.6,13.8-24l8-4.6l1.7,0.9l0,5l9.9-5.7l0-6.9l11-6.4l1.7,0.9l0,5l9.9-5.7l0-6.9l12.9-7.5l1.7,0.9L90.8,236.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "60.6,253.6 59,252.6 59,250.9 60.6,250  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "77.6,163.7 76,162.8 88.9,155.3 90.5,156.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "77.7,170.7 76,169.7 76,162.8 77.6,163.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "66.1,177.3 66.1,175.4 76,169.7 77.7,170.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "55.1,183.7 53.4,182.7 53.4,175.8 55.1,176.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "53.4,175.8 64.4,169.5 66.1,170.4 55.1,176.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "43.5,190.3 43.5,188.4 53.4,182.7 55.1,183.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "33.8,187.1 41.9,182.5 43.5,183.4 35.5,188.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M21.7,212l-1.7-0.9c5.4-9.4,8.4-14.6,13.8-24l1.7,0.9C30.1,197.4,27.1,202.7,21.7,212z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "21.9,275.9 20.3,275 20.1,211.1 21.7,212  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "57.5,211.1 57.6,231.7 63.2,235 81,224.7 84.8,218 84.8,197.4 79.2,194.1 61.4,204.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.6,217.6 78,220.4 64.4,228.3 64,228 63.9,212.2 65.5,209.4 79.2,201.5 79.6,201.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "79.6,217.6 78,220.4 64.4,228.3 64,228 63.9,212.2 65.5,209.4 79.2,201.5 79.6,201.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.6,217.6 80.8,218.3 79.2,221.1 78,220.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.6,201.7 80.8,202.4 80.8,218.3 79.6,217.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.2,221.1 65.6,229 64.4,228.3 78,220.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.6,201.7 79.2,201.5 79.2,201.5 80.8,202.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.1,206.1 79.1,196.8 80.4,197.5 64.3,206.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M83.6,199.4c-1.3-0.7-2-1.2-3.3-1.9l-16,9.3c-1.3,2.2-2,3.5-3.2,5.7l0.1,18.6c1.3,0.7,2,1.2,3.3,1.9 l16-9.3c1.3-2.2,2-3.5,3.3-5.7L83.6,199.4z M79.2,201.5l1.6,0.9l0,15.9l-1.6,2.8L65.6,229l-1.2-0.7L64,228l0-15.9l1.6-2.8 L79.2,201.5L79.2,201.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,231 59.9,230.3 59.8,211.7 61.1,212.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M61.1,212.4l-1.2-0.7c0.8-1.4,1.4-2.4,2-3.5c0.4-0.7,0.8-1.4,1.3-2.2l1.2,0.7 C63.1,209,62.3,210.2,61.1,212.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "79.6,217.6 80.8,218.3 79.2,221.1 78,220.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "79.6,201.7 80.8,202.4 80.8,218.3 79.6,217.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "79.2,221.1 65.6,229 64.4,228.3 78,220.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "63.1,206.1 79.1,196.8 80.4,197.5 64.3,206.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "61.1,231 59.9,230.3 59.8,211.7 61.1,212.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M61.1,212.4l-1.2-0.7c0.8-1.4,1.4-2.4,2-3.5c0.4-0.7,0.8-1.4,1.3-2.2l1.2,0.7 C63.1,209,62.3,210.2,61.1,212.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "85.2,238 85.2,230.9 86.9,230 86.9,237  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.4,239.7 82.3,232.6 84,231.6 84,238.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "79.5,241.4 79.5,234.3 81.1,233.3 81.1,240.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.6,243 76.6,235.9 78.2,235 78.3,242.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "73.7,244.7 73.7,237.6 75.3,236.6 75.4,243.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "70.9,246.4 70.8,239.3 72.5,238.3 72.5,245.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "68,248 67.9,241 69.6,240 69.6,247.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "65.1,249.7 65.1,242.6 66.7,241.7 66.7,248.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "62.2,251.4 62.2,244.3 63.8,243.3 63.9,250.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "88.1,236.3 88.1,229.2 89.7,228.3 89.8,235.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "62.8,180.7 62.7,173.7 64.4,172.7 64.4,179.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "59.9,182.4 59.8,175.3 61.5,174.4 61.5,181.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "57,184.1 57,177 58.6,176 58.6,183.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "41.4,191.3 41.4,186 42.6,185.2 42.7,190.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "39.3,192.5 39.2,187.2 40.5,186.5 40.5,191.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "37.1,193.8 37.1,188.5 38.3,187.8 38.3,193.1  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "90.6,172.9 46.9,198 35.9,217.3 36,264.2 39.7,262.1 39.5,216.9 48.4,201.4 90.6,177.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "26.3,230.7 26.3,229.2 27,228.2 27.7,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.7,228.6 27,228.2 27.6,227.9 28.3,228.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "28.3,228.3 26.8,230.4 26.3,230.7 27.7,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "26.3,230.7 26.3,229.2 27,228.2 27.7,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "28.3,228.3 26.8,230.4 26.3,230.7 27.7,228.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "28.2,229.8 28.2,228.3 28.9,227.3 29.6,227.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "29.6,227.7 28.9,227.3 29.4,227 30.2,227.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "30.2,227.4 28.7,229.5 28.2,229.8 29.6,227.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "28.2,229.8 28.2,228.3 28.9,227.3 29.6,227.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "30.2,227.4 28.7,229.5 28.2,229.8 29.6,227.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "30.1,228.9 30.1,227.4 30.8,226.4 31.5,226.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "31.5,226.8 30.8,226.4 31.3,226 32.1,226.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.1,226.5 30.6,228.5 30.1,228.9 31.5,226.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "30.1,228.9 30.1,227.4 30.8,226.4 31.5,226.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "32.1,226.5 30.6,228.5 30.1,228.9 31.5,226.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "31.9,228 31.9,226.5 32.7,225.5 33.4,225.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "33.4,225.9 32.7,225.5 33.2,225.1 33.9,225.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "33.9,225.5 32.5,227.6 31.9,228 33.4,225.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "31.9,228 31.9,226.5 32.7,225.5 33.4,225.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "33.9,225.5 32.5,227.6 31.9,228 33.4,225.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "33.8,227 33.8,225.6 34.5,224.5 35.3,225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "35.3,225 34.5,224.5 35.1,224.2 35.8,224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "35.8,224.6 34.4,226.7 33.8,227 35.3,225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "33.8,227 33.8,225.6 34.5,224.5 35.3,225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "35.8,224.6 34.4,226.7 33.8,227 35.3,225  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "36.6,220.1 36.6,224.4 27.9,229.4 27.9,225.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.9,225.1 25.4,223.7 34.1,218.7 36.6,220.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.9,229.4 25.4,228 25.4,223.7 27.9,225.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "27.9,225.1 25.4,223.7 34.1,218.7 36.6,220.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "27.9,229.4 25.4,228 25.4,223.7 27.9,225.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.6,224.3 26.2,220.5 26.2,222 26.9,223.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.6,224.3 28.2,223.9 26.7,220.2 26.2,220.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.6,224.3 26.2,220.5 26.2,222 26.9,223.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.6,224.3 28.2,223.9 26.7,220.2 26.2,220.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "29.3,223.3 27.8,219.6 27.8,221 28.6,222.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "29.3,223.3 29.9,223 28.4,219.2 27.8,219.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.3,223.3 27.8,219.6 27.8,221 28.6,222.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.3,223.3 29.9,223 28.4,219.2 27.8,219.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "31,222.3 29.5,218.6 29.5,220.1 30.2,221.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "31,222.3 31.5,222 30.1,218.3 29.5,218.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31,222.3 29.5,218.6 29.5,220.1 30.2,221.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31,222.3 31.5,222 30.1,218.3 29.5,218.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.6,221.4 31.2,217.6 31.2,219.1 31.9,221  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.6,221.4 33.2,221.1 31.7,217.3 31.2,217.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.6,221.4 31.2,217.6 31.2,219.1 31.9,221  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.6,221.4 33.2,221.1 31.7,217.3 31.2,217.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.3,220.4 32.9,216.7 32.9,218.1 33.6,220  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.3,220.4 34.9,220.1 33.4,216.4 32.9,216.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "34.3,220.4 32.9,216.7 32.9,218.1 33.6,220  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "34.3,220.4 34.9,220.1 33.4,216.4 32.9,216.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "26.2,218 26.2,216.6 27,215.5 27.7,215.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.7,215.9 27,215.5 27.5,215.2 28.2,215.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "28.2,215.6 26.8,217.7 26.2,218 27.7,215.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "26.2,218 26.2,216.6 27,215.5 27.7,215.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "28.2,215.6 26.8,217.7 26.2,218 27.7,215.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "28.1,217.1 28.1,215.6 28.8,214.6 29.6,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "29.6,215 28.8,214.6 29.4,214.3 30.1,214.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "30.1,214.7 28.7,216.8 28.1,217.1 29.6,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "28.1,217.1 28.1,215.6 28.8,214.6 29.6,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "30.1,214.7 28.7,216.8 28.1,217.1 29.6,215  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "30,216.2 30,214.7 30.7,213.7 31.4,214.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "31.4,214.1 30.7,213.7 31.3,213.4 32,213.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32,213.8 30.6,215.9 30,216.2 31.4,214.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "30,216.2 30,214.7 30.7,213.7 31.4,214.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "32,213.8 30.6,215.9 30,216.2 31.4,214.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "31.9,215.3 31.9,213.8 32.6,212.8 33.3,213.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "33.3,213.2 32.6,212.8 33.2,212.5 33.9,212.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "33.9,212.9 32.4,215 31.9,215.3 33.3,213.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "31.9,215.3 31.9,213.8 32.6,212.8 33.3,213.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "33.9,212.9 32.4,215 31.9,215.3 33.3,213.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "33.8,214.4 33.8,212.9 34.5,211.9 35.2,212.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "35.2,212.3 34.5,211.9 35,211.6 35.8,212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "35.8,212 34.3,214 33.8,214.4 35.2,212.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "33.8,214.4 33.8,212.9 34.5,211.9 35.2,212.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "35.8,212 34.3,214 33.8,214.4 35.2,212.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "36.6,207.4 36.6,211.7 27.9,216.7 27.9,212.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.9,212.5 25.4,211 34.1,206 36.6,207.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.9,216.7 25.4,215.3 25.4,211 27.9,212.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "27.9,212.5 25.4,211 34.1,206 36.6,207.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "27.9,216.7 25.4,215.3 25.4,211 27.9,212.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.6,211.6 26.1,207.9 26.1,209.3 26.8,211.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "27.6,211.6 28.1,211.3 26.7,207.5 26.1,207.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.6,211.6 26.1,207.9 26.1,209.3 26.8,211.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "27.6,211.6 28.1,211.3 26.7,207.5 26.1,207.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "29.2,210.6 27.8,206.9 27.8,208.3 28.5,210.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "29.2,210.6 29.8,210.3 28.3,206.6 27.8,206.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.2,210.6 27.8,206.9 27.8,208.3 28.5,210.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.2,210.6 29.8,210.3 28.3,206.6 27.8,206.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "30.9,209.7 29.5,205.9 29.5,207.4 30.2,209.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "30.9,209.7 31.5,209.3 30,205.6 29.5,205.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "30.9,209.7 29.5,205.9 29.5,207.4 30.2,209.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "30.9,209.7 31.5,209.3 30,205.6 29.5,205.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.6,208.7 31.1,205 31.1,206.4 31.9,208.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.6,208.7 33.1,208.4 31.7,204.6 31.1,205  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.6,208.7 31.1,205 31.1,206.4 31.9,208.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.6,208.7 33.1,208.4 31.7,204.6 31.1,205  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.3,207.7 32.8,204 32.8,205.5 33.5,207.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.3,207.7 34.8,207.4 33.4,203.7 32.8,204  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "34.3,207.7 32.8,204 32.8,205.5 33.5,207.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "34.3,207.7 34.8,207.4 33.4,203.7 32.8,204  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M28,239.4c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0v0L28,239.4L28,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M29.9,236c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0l0,0L29.9,236L29.9,236z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,239.4c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0v0L28,239.4L28,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.9,236c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0l0,0L29.9,236L29.9,236z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M40,239.9c-0.5-0.3-1.2-0.2-1.9,0.2c-1.5,0.9-2.7,3-2.7,4.7c0,0.9,0.3,1.5,0.8,1.8l-9.1-5.2 c-0.5-0.3-0.8-0.9-0.8-1.8c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2l0,0L40,239.9L40,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M35.4,244.8c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2c0.5,0.3,0.8,0.9,0.8,1.8 c0,1.7-1.2,3.8-2.7,4.7c-0.7,0.4-1.4,0.5-1.9,0.2C35.7,246.3,35.4,245.7,35.4,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M34.5,236.8c-0.5-0.3-1.2-0.2-1.9,0.2c-1.5,0.9-2.7,3-2.7,4.7c0,0.9,0.3,1.5,0.8,1.8l-1.3-0.7 c-0.5-0.3-0.8-0.9-0.8-1.8c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2l0,0L34.5,236.8L34.5,236.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M37.6,245c1-0.6,1.8-1.9,1.8-3.1c0-0.4-0.1-0.8-0.3-1c0.1,0,0.2,0.1,0.3,0.1c0.3,0.2,0.5,0.6,0.5,1.2 c0,1.1-0.8,2.5-1.8,3.1c-0.5,0.3-0.9,0.3-1.3,0.1c-0.1,0-0.2-0.1-0.2-0.2C36.9,245.3,37.3,245.2,37.6,245z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M36.3,244.3c0-1.1,0.8-2.5,1.8-3.1c0.4-0.2,0.7-0.3,1-0.2c0.2,0.2,0.3,0.6,0.3,1c0,1.1-0.8,2.5-1.8,3.1 c-0.4,0.2-0.7,0.3-1,0.2C36.5,245,36.3,244.7,36.3,244.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.7,258.7 34.7,264.7 29.6,267.7 29.6,261.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "33.4,260.4 34,260.1 34,264.3 30.3,266.4 30.3,265.7 33.4,263.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "33.4,260.4 33.4,263.9 30.3,265.7 30.3,262.2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "29.6,261.7 25.7,259.5 30.9,256.5 34.7,258.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "29.6,267.7 25.7,265.5 25.7,259.5 29.6,261.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "30.1,259.9 27.5,258.4 28.2,258 30.8,259.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "29.1,260.5 26.5,259 27.2,258.6 29.8,260.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "32.1,258.8 29.5,257.3 30.2,256.9 32.8,258.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "31.1,259.4 28.5,257.9 29.2,257.5 31.8,259  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "27.5,257.5 27.5,258.4 28.2,258 28.2,257.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "26.5,258.1 26.5,259 27.2,258.6 27.2,257.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "29.5,256.4 29.5,257.3 30.2,256.9 30.2,256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "28.5,256.9 28.5,257.9 29.2,257.5 29.2,256.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.5,249.6 34.5,255.6 29.3,258.5 29.3,252.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "33.1,251.2 33.7,250.9 33.7,255.1 30.1,257.2 30.1,256.5 33.2,254.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "33.1,251.2 33.2,254.8 30.1,256.5 30.1,253  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "29.3,252.5 25.4,250.3 30.6,247.3 34.5,249.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "29.3,258.5 25.5,256.3 25.4,250.3 29.3,252.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "29.9,250.8 27.3,249.3 28,248.9 30.6,250.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "28.9,251.4 26.3,249.9 27,249.4 29.6,250.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "31.9,249.6 29.3,248.1 30,247.7 32.6,249.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "30.9,250.2 28.3,248.7 29,248.3 31.6,249.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "27.3,248.4 27.3,249.3 28,248.9 28,247.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "26.3,248.9 26.3,249.9 27,249.4 27,248.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "29.3,247.2 29.3,248.1 30,247.7 30,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "28.3,247.8 28.3,248.7 29,248.3 29,247.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "43,232.2 43.6,231.8 43.7,259.8 43.1,260.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.2,231.5 44.8,231.2 44.8,259.1 44.3,259.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.4,230.8 45.9,230.5 46,258.4 45.5,258.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.6,230.1 47.1,229.8 47.2,257.7 46.6,258.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.7,229.4 48.3,229.1 48.4,257.1 47.8,257.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.4,228.4 49.5,256.4 49,256.7 48.9,228.8  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "41.9,219.2 41.9,218.8 45.7,216.6 45.7,216.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "41.9,219.8 41.9,219.5 45.7,217.2 45.7,217.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "41.9,220.4 41.9,220.1 45.7,217.9 45.7,218.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "41.9,221.1 41.9,220.8 45.8,218.5 45.8,218.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "41.9,221.7 41.9,221.4 45.8,219.2 45.8,219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "41.9,222.3 41.9,222 45.8,219.8 45.8,220.1  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "47,216.1 47,215.8 50.9,213.6 50.9,213.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "47.1,216.7 47.1,216.4 50.9,214.2 50.9,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "47.1,217.4 47.1,217.1 50.9,214.8 50.9,215.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "47.1,218 47.1,217.7 50.9,215.5 50.9,215.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "47.1,218.7 47.1,218.4 50.9,216.1 50.9,216.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "47.1,219.3 47.1,219 50.9,216.7 50.9,217  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "90.6,179.8 69.3,192.2 69.3,191.5 90.6,179.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.6,181.1 69.3,193.5 69.3,192.9 90.6,180.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.6,182.5 69.3,194.9 69.3,194.2 90.6,181.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.6,183.8 69.3,196.2 69.3,195.6 90.6,183.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.6,185.2 69.3,197.6 69.3,196.9 90.6,184.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.6,186.5 69.3,198.9 69.3,198.3 90.6,185.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "87.8,166.8 87.7,159.7 89.4,158.7 89.4,165.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "84.9,168.4 84.8,161.3 86.5,160.4 86.5,167.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82,170.1 82,163 83.6,162.1 83.6,169.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "79.1,171.8 79.1,164.7 80.7,163.7 80.8,170.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "41.8,230.6 41.8,229.7 42.3,229 42.8,229.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "42.8,229.3 42.3,229 42.6,228.8 43.1,229.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "43.1,229.1 42.2,230.4 41.8,230.6 42.8,229.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "41.8,230.6 41.8,229.7 42.3,229 42.8,229.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "43.1,229.1 42.2,230.4 41.8,230.6 42.8,229.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "43,230 43,229.1 43.5,228.4 44,228.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "44,228.7 43.5,228.4 43.9,228.2 44.3,228.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "44.3,228.5 43.4,229.8 43,230 44,228.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "43,230 43,229.1 43.5,228.4 44,228.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "44.3,228.5 43.4,229.8 43,230 44,228.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "44.2,229.4 44.2,228.5 44.7,227.8 45.2,228.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.2,228.1 44.7,227.8 45.1,227.6 45.5,227.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.5,227.9 44.6,229.2 44.2,229.4 45.2,228.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "44.2,229.4 44.2,228.5 44.7,227.8 45.2,228.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "45.5,227.9 44.6,229.2 44.2,229.4 45.2,228.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.4,228.9 45.4,227.9 45.9,227.3 46.4,227.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "46.4,227.5 45.9,227.3 46.3,227.1 46.7,227.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "46.7,227.3 45.8,228.7 45.4,228.9 46.4,227.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "45.4,228.9 45.4,227.9 45.9,227.3 46.4,227.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "46.7,227.3 45.8,228.7 45.4,228.9 46.4,227.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "46.7,228.3 46.6,227.3 47.1,226.7 47.6,226.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "47.6,226.9 47.1,226.7 47.5,226.5 47.9,226.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "47.9,226.7 47,228.1 46.7,228.3 47.6,226.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "46.7,228.3 46.6,227.3 47.1,226.7 47.6,226.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "47.9,226.7 47,228.1 46.7,228.3 47.6,226.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "48.4,223.9 48.5,226.6 42.9,229.8 42.9,227.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "42.9,227.1 41.3,226.1 46.8,222.9 48.4,223.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "42.9,229.8 41.3,228.9 41.3,226.1 42.9,227.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "42.9,227.1 41.3,226.1 46.8,222.9 48.4,223.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "42.9,229.8 41.3,228.9 41.3,226.1 42.9,227.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "42.7,226.5 41.8,224.1 41.8,225 42.2,226.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "42.7,226.5 43,226.3 42.1,223.9 41.8,224.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "42.7,226.5 41.8,224.1 41.8,225 42.2,226.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "42.7,226.5 43,226.3 42.1,223.9 41.8,224.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "43.8,225.9 42.8,223.5 42.8,224.4 43.3,225.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "43.8,225.9 44.1,225.7 43.2,223.3 42.8,223.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "43.8,225.9 42.8,223.5 42.8,224.4 43.3,225.6  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "43.8,225.9 44.1,225.7 43.2,223.3 42.8,223.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "44.8,225.3 43.9,222.9 43.9,223.8 44.4,225  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "44.8,225.3 45.2,225.1 44.3,222.7 43.9,222.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "44.8,225.3 43.9,222.9 43.9,223.8 44.4,225  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "44.8,225.3 45.2,225.1 44.3,222.7 43.9,222.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.9,224.6 45,222.3 45,223.2 45.4,224.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.9,224.6 46.3,224.4 45.3,222.1 45,222.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "45.9,224.6 45,222.3 45,223.2 45.4,224.4  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "45.9,224.6 46.3,224.4 45.3,222.1 45,222.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "47,224 46,221.6 46,222.6 46.5,223.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "47,224 47.3,223.8 46.4,221.4 46,221.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "47,224 46,221.6 46,222.6 46.5,223.8  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "47,224 47.3,223.8 46.4,221.4 46,221.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "49.9,225.8 49.9,224.9 50.3,224.3 50.8,224.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "50.8,224.5 50.3,224.3 50.7,224 51.2,224.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "51.2,224.3 50.2,225.6 49.9,225.8 50.8,224.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "49.9,225.8 49.9,224.9 50.3,224.3 50.8,224.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "51.2,224.3 50.2,225.6 49.9,225.8 50.8,224.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "51.1,225.3 51.1,224.3 51.5,223.7 52,223.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "52,223.9 51.5,223.7 51.9,223.5 52.4,223.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "52.4,223.7 51.4,225.1 51.1,225.3 52,223.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "51.1,225.3 51.1,224.3 51.5,223.7 52,223.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "52.4,223.7 51.4,225.1 51.1,225.3 52,223.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "52.3,224.7 52.3,223.8 52.8,223.1 53.2,223.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.2,223.4 52.8,223.1 53.1,222.9 53.6,223.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.6,223.1 52.7,224.5 52.3,224.7 53.2,223.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "52.3,224.7 52.3,223.8 52.8,223.1 53.2,223.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "53.6,223.1 52.7,224.5 52.3,224.7 53.2,223.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.5,224.1 53.5,223.2 54,222.5 54.4,222.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54.4,222.8 54,222.5 54.3,222.3 54.8,222.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54.8,222.6 53.9,223.9 53.5,224.1 54.4,222.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "53.5,224.1 53.5,223.2 54,222.5 54.4,222.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "54.8,222.6 53.9,223.9 53.5,224.1 54.4,222.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54.7,223.5 54.7,222.6 55.2,221.9 55.6,222.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.6,222.2 55.2,221.9 55.5,221.7 56,222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56,222 55.1,223.3 54.7,223.5 55.6,222.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "54.7,223.5 54.7,222.6 55.2,221.9 55.6,222.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "56,222 55.1,223.3 54.7,223.5 55.6,222.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56.5,219.1 56.5,221.8 50.9,225 50.9,222.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "50.9,222.3 49.3,221.4 54.9,218.2 56.5,219.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "50.9,225 49.3,224.1 49.3,221.4 50.9,222.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "50.9,222.3 49.3,221.4 54.9,218.2 56.5,219.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "50.9,225 49.3,224.1 49.3,221.4 50.9,222.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "50.7,221.7 49.8,219.4 49.8,220.3 50.3,221.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "50.7,221.7 51.1,221.5 50.2,219.2 49.8,219.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "50.7,221.7 49.8,219.4 49.8,220.3 50.3,221.5  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "50.7,221.7 51.1,221.5 50.2,219.2 49.8,219.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "51.8,221.1 50.9,218.7 50.9,219.7 51.3,220.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "51.8,221.1 52.2,220.9 51.2,218.5 50.9,218.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "51.8,221.1 50.9,218.7 50.9,219.7 51.3,220.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "51.8,221.1 52.2,220.9 51.2,218.5 50.9,218.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "52.9,220.5 51.9,218.1 51.9,219.1 52.4,220.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "52.9,220.5 53.2,220.3 52.3,217.9 51.9,218.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "52.9,220.5 51.9,218.1 51.9,219.1 52.4,220.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "52.9,220.5 53.2,220.3 52.3,217.9 51.9,218.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.9,219.9 53,217.5 53,218.4 53.5,219.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.9,219.9 54.3,219.7 53.4,217.3 53,217.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "53.9,219.9 53,217.5 53,218.4 53.5,219.6  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "53.9,219.9 54.3,219.7 53.4,217.3 53,217.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55,219.3 54.1,216.9 54.1,217.8 54.6,219  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55,219.3 55.4,219.1 54.4,216.7 54.1,216.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55,219.3 54.1,216.9 54.1,217.8 54.6,219  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55,219.3 55.4,219.1 54.4,216.7 54.1,216.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.9,201.8 72,198.8 72,192.8 66.8,195.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "67.6,199.8 67.6,200.4 71.3,198.3 71.2,194.1 70.7,194.5 70.7,198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "67.6,199.8 70.7,198 70.7,194.5 67.6,196.3  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "66.8,195.8 63,193.6 63,199.6 66.9,201.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "72,192.8 68.1,190.6 63,193.6 66.8,195.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "65.6,197.2 63,195.7 63,196.5 65.6,198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "65.6,196 63,194.5 63,195.4 65.6,196.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "65.6,199.5 63,198 63,198.8 65.6,200.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "65.6,198.3 63,196.8 63,197.7 65.6,199.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "62.2,196.2 63,195.7 63,196.5 62.2,197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "62.2,195 63,194.5 63,195.4 62.2,195.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "62.2,198.5 63,198 63,198.8 62.2,199.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "62.2,197.3 63,196.8 63,197.7 62.2,198.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54.6,233.2 58.5,230.9 58.5,226.4 54.6,228.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "55.2,231.7 55.2,232.1 57.9,230.6 57.9,227.4 57.5,227.7 57.5,230.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "55.2,231.7 57.5,230.3 57.5,227.7 55.2,229  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "54.6,228.7 51.7,227 51.7,231.5 54.6,233.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "58.5,226.4 55.6,224.7 51.7,227 54.6,228.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "53.7,229.7 51.7,228.6 51.7,229.2 53.7,230.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "53.6,228.8 51.7,227.7 51.7,228.3 53.7,229.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "53.7,231.4 51.7,230.3 51.7,230.9 53.7,232.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "53.7,230.6 51.7,229.4 51.7,230.1 53.7,231.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "51.1,228.9 51.7,228.6 51.7,229.2 51.1,229.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "51.1,228.1 51.7,227.7 51.7,228.3 51.1,228.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "51.1,230.7 51.7,230.3 51.7,230.9 51.1,231.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "51.1,229.8 51.7,229.4 51.7,230.1 51.1,230.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "53.5,194.2 53.5,204.4 44.7,209.5 44.7,199.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "44.7,199.3 39.3,196.2 48.1,191.2 53.5,194.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "44.7,209.5 39.4,206.5 39.3,196.2 44.7,199.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "53.5,194.2 53.5,204.4 44.7,209.5 44.7,199.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "44.7,199.3 39.3,196.2 48.1,191.2 53.5,194.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "44.7,209.5 39.4,206.5 39.3,196.2 44.7,199.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M52.5,199.5c-0.5-0.3-1.2-0.2-1.9,0.2c-1.5,0.9-2.7,3-2.7,4.7c0,0.9,0.3,1.5,0.8,1.8l-1.5-0.9 c-0.5-0.3-0.8-0.9-0.8-1.8c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2l0,0L52.5,199.5L52.5,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M47.9,204.3c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2c0.5,0.3,0.8,0.9,0.8,1.8 c0,1.7-1.2,3.8-2.7,4.7c-0.7,0.4-1.4,0.5-1.9,0.2C48.2,205.8,47.9,205.2,47.9,204.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "76.7,179.1 90.6,171.1 90.6,171.5 76.6,179.6 73.4,177.8 67.5,181.2 67.5,180.7 73.5,177.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "77.1,178.1 90.6,170.3 90.6,170.7 76.9,178.6 73.8,176.8 67.5,180.3 67.5,179.9 73.9,176.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "77.5,177 90.6,169.5 90.6,169.9 77.3,177.6 74.1,175.7 67.5,179.5 67.5,179.1 74.3,175.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "77.8,176 90.6,168.6 90.6,169.1 77.7,176.5 74.5,174.7 67.5,178.7 67.5,178.3 74.7,174.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "78.2,174.9 90.6,167.8 90.6,168.3 78,175.5 74.9,173.6 67.5,177.9 67.5,177.4 75,173.1  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "84,221.2 84,230.7 83.7,230.9 83.6,221.2 86.6,216.1 86.6,190.5 86.9,190.3 86.9,216.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "85.3,221.2 85.3,230 85,230.2 85,221.2 87.9,216.1 87.9,189.8 88.2,189.6 88.2,216.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "89.2,216.2 89.2,189 89.5,188.8 89.5,216.2 86.6,221.3 86.6,229.2 86.3,229.4 86.3,221.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "86,221.2 86,229.6 85.6,229.8 85.6,221.3 88.5,216.2 88.5,189.4 88.9,189.2 88.9,216.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "84.6,221.2 84.7,230.3 84.3,230.5 84.3,221.2 87.2,216.1 87.2,190.1 87.6,189.9 87.6,216.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.4,223.2 85.6,223.6 85.2,224.4 85.7,224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "85.7,224.6 85.2,224.4 85.2,224.8 85.7,225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "85.7,225 86.4,223.6 86.4,223.2 85.7,224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "86.4,223.2 85.6,223.6 85.2,224.4 85.7,224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "85.7,225 86.4,223.6 86.4,223.2 85.7,224.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.5,224.5 85.7,224.9 85.3,225.7 85.8,225.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "85.8,225.9 85.3,225.7 85.3,226.1 85.8,226.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "85.8,226.3 86.5,224.9 86.5,224.5 85.8,225.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "86.5,224.5 85.7,224.9 85.3,225.7 85.8,225.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "85.8,226.3 86.5,224.9 86.5,224.5 85.8,225.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.6,225.8 85.8,226.2 85.4,227 85.9,227.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "85.9,227.2 85.4,227 85.4,227.4 85.9,227.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "85.9,227.6 86.6,226.2 86.6,225.8 85.9,227.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "86.6,225.8 85.8,226.2 85.4,227 85.9,227.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "85.9,227.6 86.6,226.2 86.6,225.8 85.9,227.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.7,227.1 85.9,227.5 85.5,228.3 86,228.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86,228.5 85.5,228.3 85.5,228.7 86,228.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86,228.9 86.7,227.5 86.7,227.1 86,228.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "86.7,227.1 85.9,227.5 85.5,228.3 86,228.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "86,228.9 86.7,227.5 86.7,227.1 86,228.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.8,228.4 86,228.8 85.6,229.6 86.1,229.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.1,229.8 85.6,229.6 85.7,230 86.1,230.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.1,230.2 86.8,228.8 86.8,228.4 86.1,229.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "86.8,228.4 86,228.8 85.6,229.6 86.1,229.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "86.1,230.2 86.8,228.8 86.8,228.4 86.1,229.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.9,232.1 86.2,230.7 86.2,224.5 83.9,225.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.9,225.8 82.3,224.9 82.4,231.2 83.9,232.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.2,224.5 84.6,223.6 82.3,224.9 83.9,225.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "83.9,225.8 82.3,224.9 82.4,231.2 83.9,232.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "86.2,224.5 84.6,223.6 82.3,224.9 83.9,225.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,225.9 80.9,226.3 81.6,225.9 82.9,225.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,225.9 83.3,226.3 80.9,226.7 80.9,226.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,225.9 80.9,226.3 81.6,225.9 82.9,225.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,225.9 83.3,226.3 80.9,226.7 80.9,226.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,227.1 80.9,227.5 81.6,227.1 82.9,226.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,227.1 83.3,227.5 80.9,227.9 80.9,227.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,227.1 80.9,227.5 81.6,227.1 82.9,226.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,227.1 83.3,227.5 80.9,227.9 80.9,227.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,228.3 80.9,228.7 81.7,228.3 82.9,228.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,228.3 83.3,228.7 80.9,229.1 80.9,228.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,228.3 80.9,228.7 81.7,228.3 82.9,228.1  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,228.3 83.3,228.7 80.9,229.1 80.9,228.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,229.5 80.9,229.9 81.7,229.5 82.9,229.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.3,229.5 83.3,229.9 80.9,230.3 80.9,229.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,229.5 80.9,229.9 81.7,229.5 82.9,229.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.3,229.5 83.3,229.9 80.9,230.3 80.9,229.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.4,230.7 80.9,231.1 81.7,230.7 82.9,230.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "83.4,230.7 83.4,231.1 80.9,231.5 80.9,231.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.4,230.7 80.9,231.1 81.7,230.7 82.9,230.5  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "83.4,230.7 83.4,231.1 80.9,231.5 80.9,231.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.5,227.1 78.7,227.6 78.4,228.3 78.9,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "78.9,228.6 78.4,228.3 78.4,228.7 78.9,229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "78.9,229 79.5,227.5 79.5,227.1 78.9,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "79.5,227.1 78.7,227.6 78.4,228.3 78.9,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "78.9,229 79.5,227.5 79.5,227.1 78.9,228.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.6,228.4 78.8,228.9 78.5,229.6 79,229.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79,229.9 78.5,229.6 78.5,230 79,230.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79,230.3 79.6,228.8 79.6,228.4 79,229.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "79.6,228.4 78.8,228.9 78.5,229.6 79,229.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "79,230.3 79.6,228.8 79.6,228.4 79,229.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.7,229.7 78.9,230.2 78.6,230.9 79.1,231.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.1,231.2 78.6,230.9 78.6,231.3 79.1,231.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.1,231.6 79.7,230.1 79.7,229.7 79.1,231.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "79.7,229.7 78.9,230.2 78.6,230.9 79.1,231.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "79.1,231.6 79.7,230.1 79.7,229.7 79.1,231.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.8,231 79,231.5 78.7,232.2 79.2,232.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.2,232.5 78.7,232.2 78.7,232.6 79.2,232.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.2,232.9 79.8,231.4 79.8,231 79.2,232.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "79.8,231 79,231.5 78.7,232.2 79.2,232.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "79.2,232.9 79.8,231.4 79.8,231 79.2,232.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.9,232.3 79.1,232.8 78.8,233.5 79.3,233.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.3,233.8 78.8,233.5 78.8,233.9 79.3,234.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.3,234.2 79.9,232.7 79.9,232.3 79.3,233.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "79.9,232.3 79.1,232.8 78.8,233.5 79.3,233.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "79.3,234.2 79.9,232.7 79.9,232.3 79.3,233.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "77.1,236 79.4,234.7 79.3,228.4 77.1,229.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "77.1,229.8 75.5,228.9 75.5,235.1 77.1,236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "79.3,228.4 77.8,227.5 75.5,228.9 77.1,229.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "77.1,229.8 75.5,228.9 75.5,235.1 77.1,236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "79.3,228.4 77.8,227.5 75.5,228.9 77.1,229.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,229.9 74,230.3 74.8,229.8 76,229.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,229.9 76.5,230.3 74,230.7 74,230.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,229.9 74,230.3 74.8,229.8 76,229.6  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,229.9 76.5,230.3 74,230.7 74,230.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,231.1 74,231.5 74.8,231 76,230.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,231.1 76.5,231.5 74,231.9 74,231.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,231.1 74,231.5 74.8,231 76,230.8  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,231.1 76.5,231.5 74,231.9 74,231.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,232.3 74,232.7 74.8,232.2 76,232  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,232.3 76.5,232.7 74,233.1 74,232.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,232.3 74,232.7 74.8,232.2 76,232  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,232.3 76.5,232.7 74,233.1 74,232.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,233.5 74,233.9 74.8,233.4 76.1,233.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,233.5 76.5,233.9 74,234.3 74,233.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,233.5 74,233.9 74.8,233.4 76.1,233.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,233.5 76.5,233.9 74,234.3 74,233.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,234.7 74,235.1 74.8,234.6 76.1,234.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "76.5,234.7 76.5,235.1 74.1,235.5 74,235.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,234.7 74,235.1 74.8,234.6 76.1,234.4  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.5,234.7 76.5,235.1 74.1,235.5 74,235.1  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58,186.4 57.3,186.8 57.1,187.4 57.4,187.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.4,187.6 57.1,187.4 57.1,187.7 57.4,187.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.4,187.9 58,186.8 58,186.4 57.4,187.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "58,186.4 57.3,186.8 57.1,187.4 57.4,187.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "57.4,187.9 58,186.8 58,186.4 57.4,187.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58,187.5 57.4,187.8 57.1,188.4 57.5,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.5,188.6 57.1,188.4 57.1,188.7 57.5,189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.5,189 58,187.8 58,187.5 57.5,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "58,187.5 57.4,187.8 57.1,188.4 57.5,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "57.5,189 58,187.8 58,187.5 57.5,188.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58.1,188.5 57.5,188.9 57.2,189.5 57.6,189.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.6,189.7 57.2,189.5 57.2,189.8 57.6,190  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.6,190 58.1,188.8 58.1,188.5 57.6,189.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "58.1,188.5 57.5,188.9 57.2,189.5 57.6,189.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "57.6,190 58.1,188.8 58.1,188.5 57.6,189.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58.2,189.6 57.6,189.9 57.3,190.5 57.7,190.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.7,190.7 57.3,190.5 57.3,190.8 57.7,191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.7,191 58.2,189.9 58.2,189.6 57.7,190.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "58.2,189.6 57.6,189.9 57.3,190.5 57.7,190.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "57.7,191 58.2,189.9 58.2,189.6 57.7,190.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58.3,190.6 57.7,191 57.4,191.6 57.8,191.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.8,191.8 57.4,191.6 57.4,191.9 57.8,192.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.8,192.1 58.3,190.9 58.3,190.6 57.8,191.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "58.3,190.6 57.7,191 57.4,191.6 57.8,191.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "57.8,192.1 58.3,190.9 58.3,190.6 57.8,191.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56,193.6 57.8,192.5 57.8,187.5 56,188.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56,188.5 54.7,187.8 54.7,192.9 56,193.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "57.8,187.5 56.6,186.8 54.7,187.8 56,188.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "56,188.5 54.7,187.8 54.7,192.9 56,193.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "57.8,187.5 56.6,186.8 54.7,187.8 56,188.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,188.6 53.5,188.9 54.2,188.6 55.2,188.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,188.6 55.5,189 53.5,189.3 53.5,188.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,188.6 53.5,188.9 54.2,188.6 55.2,188.4  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,188.6 55.5,189 53.5,189.3 53.5,188.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,189.6 53.5,189.9 54.2,189.6 55.2,189.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,189.6 55.5,189.9 53.5,190.2 53.5,189.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,189.6 53.5,189.9 54.2,189.6 55.2,189.4  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,189.6 55.5,189.9 53.5,190.2 53.5,189.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,190.6 53.5,190.9 54.2,190.5 55.2,190.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,190.6 55.5,190.9 53.5,191.2 53.5,190.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,190.6 53.5,190.9 54.2,190.5 55.2,190.4  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,190.6 55.5,190.9 53.5,191.2 53.5,190.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,191.5 53.5,191.9 54.2,191.5 55.2,191.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,191.5 55.5,191.9 53.6,192.2 53.5,191.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,191.5 53.5,191.9 54.2,191.5 55.2,191.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,191.5 55.5,191.9 53.6,192.2 53.5,191.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,192.5 53.6,192.8 54.2,192.5 55.2,192.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "55.5,192.5 55.5,192.8 53.6,193.2 53.6,192.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,192.5 53.6,192.8 54.2,192.5 55.2,192.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.5,192.5 55.5,192.8 53.6,193.2 53.6,192.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.5,183.2 62.9,183.6 62.6,184.2 63,184.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63,184.4 62.6,184.2 62.6,184.5 63,184.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63,184.7 63.5,183.5 63.5,183.2 63,184.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "63.5,183.2 62.9,183.6 62.6,184.2 63,184.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "63,184.7 63.5,183.5 63.5,183.2 63,184.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.6,184.3 63,184.6 62.7,185.2 63.1,185.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.1,185.4 62.7,185.2 62.7,185.5 63.1,185.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.1,185.7 63.6,184.6 63.6,184.3 63.1,185.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "63.6,184.3 63,184.6 62.7,185.2 63.1,185.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "63.1,185.7 63.6,184.6 63.6,184.3 63.1,185.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.7,185.3 63.1,185.7 62.8,186.3 63.2,186.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.2,186.5 62.8,186.3 62.8,186.6 63.2,186.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.2,186.8 63.7,185.6 63.7,185.3 63.2,186.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "63.7,185.3 63.1,185.7 62.8,186.3 63.2,186.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "63.2,186.8 63.7,185.6 63.7,185.3 63.2,186.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.8,186.4 63.1,186.7 62.9,187.3 63.2,187.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.2,187.5 62.9,187.3 62.9,187.6 63.2,187.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.2,187.8 63.8,186.7 63.8,186.4 63.2,187.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "63.8,186.4 63.1,186.7 62.9,187.3 63.2,187.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "63.2,187.8 63.8,186.7 63.8,186.4 63.2,187.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.9,187.4 63.2,187.8 63,188.3 63.3,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.3,188.6 63,188.3 63,188.7 63.3,188.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.3,188.9 63.9,187.7 63.9,187.4 63.3,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "63.9,187.4 63.2,187.8 63,188.3 63.3,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "63.3,188.9 63.9,187.7 63.9,187.4 63.3,188.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.6,190.4 63.4,189.3 63.4,184.3 61.5,185.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.5,185.3 60.3,184.6 60.3,189.6 61.6,190.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "63.4,184.3 62.1,183.5 60.3,184.6 61.5,185.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "61.5,185.3 60.3,184.6 60.3,189.6 61.6,190.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "63.4,184.3 62.1,183.5 60.3,184.6 61.5,185.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,185.4 59.1,185.7 59.7,185.4 60.7,185.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,185.4 61.1,185.7 59.1,186.1 59.1,185.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,185.4 59.1,185.7 59.7,185.4 60.7,185.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,185.4 61.1,185.7 59.1,186.1 59.1,185.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,186.4 59.1,186.7 59.7,186.3 60.7,186.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,186.4 61.1,186.7 59.1,187 59.1,186.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,186.4 59.1,186.7 59.7,186.3 60.7,186.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,186.4 61.1,186.7 59.1,187 59.1,186.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,187.4 59.1,187.7 59.7,187.3 60.7,187.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,187.4 61.1,187.7 59.1,188 59.1,187.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,187.4 59.1,187.7 59.7,187.3 60.7,187.1  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,187.4 61.1,187.7 59.1,188 59.1,187.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,188.3 59.1,188.6 59.7,188.3 60.7,188.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,188.3 61.1,188.7 59.1,189 59.1,188.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,188.3 59.1,188.6 59.7,188.3 60.7,188.1  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,188.3 61.1,188.7 59.1,189 59.1,188.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,189.3 59.1,189.6 59.8,189.2 60.7,189.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "61.1,189.3 61.1,189.6 59.1,189.9 59.1,189.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,189.3 59.1,189.6 59.8,189.2 60.7,189.1  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.1,189.3 61.1,189.6 59.1,189.9 59.1,189.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "69.1,180 68.5,180.4 68.2,180.9 68.6,181.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.6,181.2 68.2,180.9 68.2,181.3 68.6,181.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.6,181.5 69.1,180.3 69.1,180 68.6,181.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "69.1,180 68.5,180.4 68.2,180.9 68.6,181.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "68.6,181.5 69.1,180.3 69.1,180 68.6,181.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "69.2,181 68.5,181.4 68.3,182 68.6,182.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.6,182.2 68.3,182 68.3,182.3 68.6,182.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.6,182.5 69.2,181.4 69.2,181 68.6,182.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "69.2,181 68.5,181.4 68.3,182 68.6,182.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "68.6,182.5 69.2,181.4 69.2,181 68.6,182.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "69.3,182.1 68.6,182.5 68.4,183 68.7,183.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.7,183.2 68.4,183 68.4,183.4 68.7,183.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.7,183.6 69.3,182.4 69.3,182.1 68.7,183.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "69.3,182.1 68.6,182.5 68.4,183 68.7,183.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "68.7,183.6 69.3,182.4 69.3,182.1 68.7,183.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "69.3,183.1 68.7,183.5 68.4,184.1 68.8,184.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.8,184.3 68.4,184.1 68.4,184.4 68.8,184.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.8,184.6 69.3,183.5 69.3,183.1 68.8,184.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "69.3,183.1 68.7,183.5 68.4,184.1 68.8,184.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "68.8,184.6 69.3,183.5 69.3,183.1 68.8,184.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "69.4,184.2 68.8,184.6 68.5,185.1 68.9,185.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.9,185.3 68.5,185.1 68.5,185.5 68.9,185.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "68.9,185.7 69.4,184.5 69.4,184.2 68.9,185.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "69.4,184.2 68.8,184.6 68.5,185.1 68.9,185.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "68.9,185.7 69.4,184.5 69.4,184.2 68.9,185.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "67.1,187.2 69,186.1 69,181 67.1,182.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "67.1,182.1 65.9,181.4 65.9,186.4 67.1,187.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "69,181 67.7,180.3 65.9,181.4 67.1,182.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "67.1,182.1 65.9,181.4 65.9,186.4 67.1,187.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "69,181 67.7,180.3 65.9,181.4 67.1,182.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,182.2 64.7,182.5 65.3,182.1 66.3,182  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,182.2 66.7,182.5 64.7,182.8 64.7,182.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,182.2 64.7,182.5 65.3,182.1 66.3,182  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,182.2 66.7,182.5 64.7,182.8 64.7,182.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,183.2 64.7,183.5 65.3,183.1 66.3,183  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,183.2 66.7,183.5 64.7,183.8 64.7,183.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,183.2 64.7,183.5 65.3,183.1 66.3,183  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,183.2 66.7,183.5 64.7,183.8 64.7,183.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,184.1 64.7,184.5 65.3,184.1 66.3,183.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,184.1 66.7,184.5 64.7,184.8 64.7,184.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,184.1 64.7,184.5 65.3,184.1 66.3,183.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,184.1 66.7,184.5 64.7,184.8 64.7,184.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,185.1 64.7,185.4 65.3,185.1 66.3,184.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,185.1 66.7,185.4 64.7,185.8 64.7,185.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,185.1 64.7,185.4 65.3,185.1 66.3,184.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,185.1 66.7,185.4 64.7,185.8 64.7,185.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,186.1 64.7,186.4 65.3,186 66.3,185.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66.7,186.1 66.7,186.4 64.7,186.7 64.7,186.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,186.1 64.7,186.4 65.3,186 66.3,185.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.7,186.1 66.7,186.4 64.7,186.7 64.7,186.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.7,176.8 74,177.2 73.8,177.7 74.1,177.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.1,177.9 73.8,177.7 73.8,178 74.1,178.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.1,178.3 74.7,177.1 74.7,176.8 74.1,177.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "74.7,176.8 74,177.2 73.8,177.7 74.1,177.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "74.1,178.3 74.7,177.1 74.7,176.8 74.1,177.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.7,177.8 74.1,178.2 73.8,178.8 74.2,179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.2,179 73.8,178.8 73.8,179.1 74.2,179.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.2,179.3 74.8,178.2 74.7,177.8 74.2,179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "74.7,177.8 74.1,178.2 73.8,178.8 74.2,179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "74.2,179.3 74.8,178.2 74.7,177.8 74.2,179  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.8,178.9 74.2,179.2 73.9,179.8 74.3,180  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.3,180 73.9,179.8 73.9,180.1 74.3,180.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.3,180.4 74.8,179.2 74.8,178.9 74.3,180  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "74.8,178.9 74.2,179.2 73.9,179.8 74.3,180  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "74.3,180.4 74.8,179.2 74.8,178.9 74.3,180  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.9,179.9 74.3,180.3 74,180.9 74.4,181.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.4,181.1 74,180.9 74,181.2 74.4,181.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.4,181.4 74.9,180.2 74.9,179.9 74.4,181.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "74.9,179.9 74.3,180.3 74,180.9 74.4,181.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "74.4,181.4 74.9,180.2 74.9,179.9 74.4,181.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "75,181 74.4,181.3 74.1,181.9 74.5,182.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.5,182.1 74.1,181.9 74.1,182.2 74.5,182.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.5,182.4 75,181.3 75,181 74.5,182.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "75,181 74.4,181.3 74.1,181.9 74.5,182.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "74.5,182.4 75,181.3 75,181 74.5,182.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.7,183.9 74.5,182.9 74.5,177.8 72.7,178.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.7,178.9 71.4,178.2 71.5,183.2 72.7,183.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "74.5,177.8 73.3,177.1 71.4,178.2 72.7,178.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "72.7,178.9 71.4,178.2 71.5,183.2 72.7,183.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "74.5,177.8 73.3,177.1 71.4,178.2 72.7,178.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,179 70.2,179.3 70.9,178.9 71.9,178.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,179 72.2,179.3 70.2,179.6 70.2,179.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,179 70.2,179.3 70.9,178.9 71.9,178.8  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,179 72.2,179.3 70.2,179.6 70.2,179.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,180 70.2,180.3 70.9,179.9 71.9,179.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,180 72.2,180.3 70.2,180.6 70.2,180.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,180 70.2,180.3 70.9,179.9 71.9,179.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,180 72.2,180.3 70.2,180.6 70.2,180.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,180.9 70.2,181.2 70.9,180.9 71.9,180.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,180.9 72.2,181.2 70.2,181.6 70.2,181.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,180.9 70.2,181.2 70.9,180.9 71.9,180.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,180.9 72.2,181.2 70.2,181.6 70.2,181.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,181.9 70.3,182.2 70.9,181.8 71.9,181.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,181.9 72.2,182.2 70.3,182.5 70.3,182.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,181.9 70.3,182.2 70.9,181.8 71.9,181.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,181.9 72.2,182.2 70.3,182.5 70.3,182.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,182.9 70.3,183.2 70.9,182.8 71.9,182.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "72.2,182.9 72.2,183.2 70.3,183.5 70.3,183.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,182.9 70.3,183.2 70.9,182.8 71.9,182.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.2,182.9 72.2,183.2 70.3,183.5 70.3,183.2  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M46.4,213.3c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1 c0,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L46.4,213.3L46.4,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M47.8,211c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L47.8,211L47.8,211z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.4,213.3c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L46.4,213.3L46.4,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.8,211c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L47.8,211L47.8,211z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M54.7,213.7c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-6.2-3.6 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1v0L54.7,213.7L54.7,213.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M51.5,217c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1c0.3,0.2,0.5,0.6,0.5,1.2c0,1.2-0.8,2.6-1.8,3.2 c-0.5,0.3-1,0.3-1.3,0.1C51.7,218,51.5,217.6,51.5,217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M50.9,211.5c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-0.9-0.5 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1l0,0L50.9,211.5L50.9,211.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M53,217.1c0.7-0.4,1.2-1.3,1.2-2.1c0-0.3-0.1-0.5-0.2-0.7c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.4,0.4,0.4,0.8 c0,0.8-0.5,1.7-1.2,2.1c-0.3,0.2-0.6,0.2-0.9,0.1c-0.1,0-0.1-0.1-0.1-0.1C52.6,217.3,52.8,217.3,53,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M52.2,216.6c0-0.8,0.5-1.7,1.2-2.1c0.2-0.1,0.5-0.2,0.7-0.2c0.1,0.1,0.2,0.4,0.2,0.7 c0,0.8-0.5,1.7-1.2,2.1c-0.2,0.1-0.5,0.2-0.7,0.2C52.2,217.1,52.2,216.9,52.2,216.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M51.6,209.7c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1 c0,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L51.6,209.7L51.6,209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M53,207.4c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L53,207.4L53,207.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.6,209.7c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L51.6,209.7L51.6,209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53,207.4c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L53,207.4L53,207.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M59.9,210.1c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-6.2-3.6 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1v0L59.9,210.1L59.9,210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M56.7,213.4c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1c0.3,0.2,0.5,0.6,0.5,1.2c0,1.2-0.8,2.6-1.8,3.2 c-0.5,0.3-1,0.3-1.3,0.1C56.9,214.4,56.7,214,56.7,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M56.1,207.9c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-0.9-0.5 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1l0,0L56.1,207.9L56.1,207.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M58.2,213.6c0.7-0.4,1.2-1.3,1.2-2.1c0-0.3-0.1-0.5-0.2-0.7c0.1,0,0.1,0,0.2,0.1 c0.2,0.1,0.4,0.4,0.4,0.8c0,0.8-0.5,1.7-1.2,2.1c-0.3,0.2-0.6,0.2-0.9,0.1c-0.1,0-0.1-0.1-0.1-0.1 C57.8,213.8,58,213.7,58.2,213.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M57.4,213.1c0-0.8,0.5-1.7,1.2-2.1c0.2-0.1,0.5-0.2,0.7-0.2c0.1,0.1,0.2,0.4,0.2,0.7 c0,0.8-0.5,1.7-1.2,2.1c-0.2,0.1-0.5,0.2-0.7,0.2C57.4,213.6,57.4,213.4,57.4,213.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M53,252c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L53,252L53,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M54.3,249.7c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1 c0,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L54.3,249.7L54.3,249.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53,252c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L53,252L53,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.3,249.7c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L54.3,249.7L54.3,249.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M61.2,252.4c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-6.2-3.6 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1v0L61.2,252.4L61.2,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M58.1,255.7c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1c0.3,0.2,0.5,0.6,0.5,1.2c0,1.2-0.8,2.6-1.8,3.2 c-0.5,0.3-1,0.3-1.3,0.1C58.3,256.7,58.1,256.3,58.1,255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M57.5,250.2c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-0.9-0.5 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1l0,0L57.5,250.2L57.5,250.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M59.6,255.8c0.7-0.4,1.2-1.3,1.2-2.1c0-0.3-0.1-0.5-0.2-0.7c0.1,0,0.1,0,0.2,0.1 c0.2,0.1,0.4,0.4,0.4,0.8c0,0.8-0.5,1.7-1.2,2.1c-0.3,0.2-0.6,0.2-0.9,0.1c-0.1,0-0.1-0.1-0.1-0.1 C59.1,256,59.3,256,59.6,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M58.7,255.3c0-0.8,0.5-1.7,1.2-2.1c0.2-0.1,0.5-0.2,0.7-0.2c0.1,0.1,0.2,0.4,0.2,0.7 c0,0.8-0.5,1.7-1.2,2.1c-0.2,0.1-0.5,0.2-0.7,0.2C58.8,255.8,58.7,255.6,58.7,255.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M58.2,248.4c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1 c0,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L58.2,248.4L58.2,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M59.5,246.1c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1 c0,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L59.5,246.1L59.5,246.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.2,248.4c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L58.2,248.4L58.2,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.5,246.1c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.1l-1.9-1.1c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1,0,0.1,0l0,0L59.5,246.1L59.5,246.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M66.4,248.8c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-6.2-3.6 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1l0,0L66.4,248.8L66.4,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M63.3,252.1c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1c0.3,0.2,0.5,0.6,0.5,1.2c0,1.2-0.8,2.6-1.8,3.2 c-0.5,0.3-1,0.3-1.3,0.1C63.5,253.1,63.3,252.7,63.3,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M62.7,246.6c-0.3-0.2-0.8-0.2-1.3,0.1c-1,0.6-1.8,2-1.8,3.2c0,0.6,0.2,1,0.5,1.2l-0.9-0.5 c-0.3-0.2-0.5-0.6-0.5-1.2c0-1.2,0.8-2.6,1.8-3.2c0.5-0.3,1-0.3,1.3-0.1l0,0L62.7,246.6L62.7,246.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M64.8,252.3c0.7-0.4,1.2-1.3,1.2-2.1c0-0.3-0.1-0.5-0.2-0.7c0.1,0,0.1,0,0.2,0.1 c0.2,0.1,0.4,0.4,0.4,0.8c0,0.8-0.5,1.7-1.2,2.1c-0.3,0.2-0.6,0.2-0.9,0.1c-0.1,0-0.1-0.1-0.1-0.1 C64.3,252.5,64.5,252.4,64.8,252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M63.9,251.8c0-0.8,0.5-1.7,1.2-2.1c0.2-0.1,0.5-0.2,0.7-0.2c0.1,0.1,0.2,0.4,0.2,0.7 c0,0.8-0.5,1.7-1.2,2.1c-0.2,0.1-0.5,0.2-0.7,0.2C64,252.3,63.9,252.1,63.9,251.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M54.4,239.2c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0l0,0L54.4,239.2L54.4,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M56.3,235.8c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0h0L56.3,235.8L56.3,235.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.4,239.2c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0l0,0L54.4,239.2L54.4,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.3,235.8c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0,0.2,0.1,0.2l-2.8-1.6 c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1,0,0.2-0.1,0.2,0h0L56.3,235.8L56.3,235.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M63,237.8c-0.5-0.3-1.2-0.2-1.9,0.2c-1.5,0.9-2.7,3-2.7,4.7c0,0.9,0.3,1.5,0.8,1.8l-5.7-3.3 c-0.5-0.3-0.8-0.9-0.8-1.8c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2l0,0L63,237.8L63,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M58.4,242.7c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2c0.5,0.3,0.8,0.9,0.8,1.8 c0,1.7-1.2,3.8-2.7,4.7c-0.7,0.4-1.4,0.5-1.9,0.2C58.7,244.2,58.4,243.5,58.4,242.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M60.9,236.6c-0.5-0.3-1.2-0.2-1.9,0.2c-1.5,0.9-2.7,3-2.7,4.7c0,0.9,0.3,1.5,0.8,1.8l-1.3-0.7 c-0.5-0.3-0.8-0.9-0.8-1.8c0-1.7,1.2-3.8,2.7-4.7c0.7-0.4,1.4-0.5,1.9-0.2l0,0L60.9,236.6L60.9,236.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M60.6,242.9c1-0.6,1.8-1.9,1.8-3.1c0-0.4-0.1-0.8-0.3-1c0.1,0,0.2,0.1,0.3,0.1c0.3,0.2,0.5,0.6,0.5,1.2 c0,1.1-0.8,2.5-1.8,3.1c-0.5,0.3-0.9,0.3-1.3,0.1c-0.1,0-0.2-0.1-0.2-0.2C59.9,243.2,60.2,243.1,60.6,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M59.3,242.2c0-1.1,0.8-2.5,1.8-3.1c0.4-0.2,0.7-0.3,1-0.2c0.2,0.2,0.3,0.6,0.3,1c0,1.1-0.8,2.5-1.8,3.1 c-0.4,0.2-0.7,0.3-1,0.2C59.4,242.9,59.3,242.6,59.3,242.2z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.1,
    y: 241.8,
    className: "st47",
    width: 11.5,
    height: 15.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M212,257.3h-12.2v-15.8H212V257.3z M200.5,256.6h10.8v-14.4h-10.8V256.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M211.6,241.8v3.8c0,0.2-0.2,0.4-0.4,0.4c-1.7,0.1-3.5,0.2-5.3,0.2c-1.9,0-3.7-0.1-5.6-0.2 c-0.2,0-0.4-0.2-0.4-0.4v-3.8H211.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M206,246.9c-1.9,0-3.8-0.1-5.6-0.2c-0.6,0-1-0.5-1-1.1v-4.5h12.9v4.5c0,0.6-0.4,1-1,1.1 C209.6,246.8,207.8,246.9,206,246.9z M200.8,245.3c3.3,0.2,6.8,0.2,10.1,0v-2.8h-10.1V245.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M211.6,249.8v3.9c-1.8,0.1-3.7,0.2-5.6,0.2c-2,0-4-0.1-5.9-0.2v-3.9c0-0.2,0.1-0.3,0.3-0.3h10.9 C211.5,249.5,211.6,249.6,211.6,249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M206,254.5c-2,0-4.1-0.1-6-0.2l-0.7,0v-4.5c0-0.6,0.5-1,1-1h10.9c0.6,0,1,0.5,1,1v4.5l-0.7,0 C209.9,254.5,208,254.5,206,254.5z M200.8,253c3.3,0.2,6.8,0.2,10.1,0v-2.8h-10.1V253z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M155.8,272.6c-0.6,0.1-1.2,0.2-1.8,0.3c-2.8,0.3-5.3,0.4-7.6,0.1c-1.2-0.1-2.4-0.3-3.5-0.5 c0,0-0.1,0-0.1,0c-0.6-0.1-1.1-0.3-1.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.2c-0.5-0.2-1.1-0.4-1.6-0.6c-1.2-0.5-2.3-1-3.3-1.6 c-4-2.3-6-5-6.1-5.2l-4.9,3.3c0.2,0.3,3.2,4.6,9.5,7.8c1.2,0.6,2.6,1.2,4.2,1.7c1.1,0.4,2.4,0.7,3.6,1 c0.2,0.1,0.5,0.1,0.7,0.1c0.9,0.2,1.7,0.3,2.7,0.4c0.2,0,0.5,0.1,0.7,0.1c1.1,0.1,2.2,0.2,3.3,0.2c2.3,0,4.8-0.2,7.5-0.6 l-0.2-1.4L155.8,272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M149.4,279.4C149.3,279.4,149.3,279.4,149.4,279.4c-1.2,0-2.3-0.1-3.4-0.2c-0.2,0-0.3,0-0.5,0l-0.2,0 c-0.9-0.1-1.8-0.2-2.7-0.4c-0.3,0-0.5-0.1-0.8-0.1c-1.3-0.3-2.5-0.6-3.7-1c-1.4-0.5-2.8-1.1-4.2-1.8c-6.5-3.3-9.6-7.8-9.6-7.9 l-0.2-0.3l5.4-3.7l0.2,0.3c0,0,1.9,2.8,6,5.1c1,0.6,2.1,1.1,3.2,1.6c0.6,0.2,1.1,0.4,1.5,0.6c0.2,0.1,0.5,0.2,0.8,0.2 c0.6,0.2,1.1,0.3,1.6,0.4l0.1,0c1.1,0.2,2.3,0.4,3.5,0.5c2.4,0.2,4.9,0.2,7.6-0.1c0.6-0.1,1.2-0.2,1.7-0.3l0.3-0.1l1.1,6.5 l-0.3,0.1C154.3,279.2,151.8,279.4,149.4,279.4z M125.1,267.9c0.8,1,3.7,4.6,9.1,7.4c1.3,0.7,2.7,1.3,4.1,1.7 c1.2,0.4,2.4,0.7,3.6,1c0.2,0.1,0.5,0.1,0.7,0.1c0.9,0.2,1.7,0.3,2.6,0.4l0.2,0c0.2,0,0.3,0,0.5,0c1.1,0.1,2.2,0.2,3.3,0.2 c0,0,0,0,0.1,0c2.3,0,4.6-0.2,7-0.6l-0.9-5.1c-0.5,0.1-1,0.1-1.4,0.2c-2.7,0.3-5.3,0.4-7.7,0.1c-1.2-0.1-2.4-0.3-3.5-0.5 c0,0-0.1,0-0.2,0c-0.5-0.1-1-0.2-1.6-0.4c-0.3-0.1-0.5-0.2-0.8-0.2c-0.5-0.2-1-0.3-1.6-0.6c-1.2-0.5-2.3-1-3.3-1.6 c-3.5-2-5.4-4.3-6-5L125.1,267.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M154.9,272.9c-2.6,0.3-5,0.4-7.1,0.2c-0.2,0-0.4,0.2-0.3,0.4c0.8,1.8,1.7,3.7,2.6,5.4 c0.1,0.1,0.2,0.2,0.3,0.2c2.3,0,4.7-0.2,7.3-0.6l-0.2-1.4L154.9,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M150.4,279.8c-0.4,0-0.7-0.2-0.9-0.6c-0.8-1.7-1.8-3.7-2.6-5.4c-0.2-0.3-0.1-0.7,0.1-1 c0.2-0.3,0.6-0.5,0.9-0.4c2.2,0.2,4.6,0.1,7-0.2l0.5-0.1l2.8,4.7l0.4,2.2l-0.7,0.1C155.2,279.5,152.8,279.8,150.4,279.8 C150.4,279.8,150.4,279.8,150.4,279.8z M148.4,273.8c0.7,1.5,1.5,3.1,2.2,4.5c2,0,4.1-0.2,6.2-0.5l-0.1-0.6l-2.2-3.7 C152.5,273.9,150.4,273.9,148.4,273.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M138.7,271.2c-1.2-0.5-2.2-1-3.1-1.5l-1.5,5.9c1.2,0.6,2.5,1.2,3.9,1.7c0.1,0,0.3,0,0.3-0.2 c0.2-1.7,0.4-3.9,0.6-5.7C138.8,271.3,138.7,271.2,138.7,271.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M138,277.9c-0.1,0-0.2,0-0.3,0c-1.4-0.5-2.7-1-4-1.7l-0.5-0.3l1.9-7.3l0.8,0.5c1,0.6,2,1,3,1.5 c0.4,0.1,0.6,0.5,0.6,0.9c-0.2,1.8-0.4,4-0.6,5.7c0,0.3-0.2,0.5-0.4,0.7C138.4,277.9,138.2,277.9,138,277.9z M134.9,275.2 c0.9,0.4,1.8,0.8,2.7,1.2c0.1-1.5,0.3-3.2,0.5-4.6c-0.7-0.3-1.4-0.6-2-1L134.9,275.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M143.8,272.9c-0.1-0.2-0.2-0.3-0.4-0.3c-0.2,0-0.3-0.1-0.5-0.1c0,0-0.1,0-0.1,0c-0.5-0.1-1.3-0.3-1.6-0.4 c0,0-0.1,0-0.1,0.1l1.4,6c0,0.2,0.2,0.4,0.4,0.4c0.7,0.1,2.4,0.3,2.9,0.4c0,0,0.1,0,0.1-0.1 C145.2,276.8,144.4,274.6,143.8,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M145.9,279.6C145.8,279.6,145.8,279.6,145.9,279.6c-0.6-0.1-2.3-0.3-3-0.4c-0.5-0.1-0.9-0.5-1-0.9 l-1.5-6.4l0.3-0.3c0.2-0.2,0.5-0.3,0.7-0.2l0.1,0c0.3,0.1,1,0.3,1.4,0.4l0.2,0c0.1,0,0.3,0.1,0.4,0.1c0.4,0.1,0.7,0.4,0.9,0.8 l2.3,6.2l-0.2,0.4C146.3,279.5,146.1,279.6,145.9,279.6z M143.2,277.8c0.4,0.1,1.1,0.2,1.7,0.2l-1.8-4.8 c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.3-0.1-0.5-0.1L143.2,277.8z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M126.2,274.5c3.6,2.8,10,6.5,10.5,5.9c0.5-0.5,0.6-2.3,0.8-3l2.2-8.6c0.4-1.6-0.5-3.2-2.1-3.7 c-4-1.2-7.7-3.5-11.2-6.1c-1-0.7-2.4-0.8-3.4-0.2l-5.7,3.4c-1,0.6-1.2,1.9-0.4,2.7C119.3,267.7,124,272.8,126.2,274.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M136.6,280.8c-1.9,0-8.4-4.3-10.6-6c-2.3-1.8-7.4-7.3-9.4-9.5c-0.4-0.5-0.6-1.1-0.5-1.7 c0.1-0.6,0.5-1.2,1-1.5l5.7-3.4c1.2-0.7,2.7-0.6,3.8,0.2c3.1,2.3,6.8,4.8,11,6c1.8,0.5,2.8,2.3,2.4,4.1l-2.2,8.6 c0,0.2-0.1,0.5-0.1,0.8c-0.2,1.1-0.3,2-0.7,2.4C136.9,280.8,136.8,280.8,136.6,280.8z M126.4,274.3c3.6,2.8,9.1,5.9,10.1,5.9 c0.3-0.3,0.4-1.3,0.5-1.9c0.1-0.3,0.1-0.7,0.2-0.9l2.2-8.6c0.4-1.4-0.5-2.9-1.9-3.3c-4.3-1.3-8.1-3.8-11.3-6.2 c-0.9-0.7-2.1-0.7-3-0.2l-5.7,3.4c-0.4,0.2-0.6,0.6-0.7,1c-0.1,0.4,0.1,0.8,0.4,1.2C119.2,267.1,124.2,272.5,126.4,274.3z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M254.9,271.9c0.6,0,1.2,0,1.8,0c2.8-0.1,5.3-0.4,7.6-1c1.2-0.3,2.3-0.7,3.4-1c0,0,0.1,0,0.1,0 c0.5-0.2,1.1-0.4,1.6-0.7c0.2-0.1,0.5-0.2,0.7-0.3c0.5-0.3,1-0.5,1.5-0.8c1.1-0.6,2.1-1.3,3-2c3.7-2.9,5.2-5.8,5.3-6l5.3,2.6 c-0.2,0.3-2.5,5-8.2,9.1c-1.1,0.8-2.4,1.6-3.9,2.3c-1.1,0.5-2.2,1.1-3.5,1.5c-0.2,0.1-0.5,0.2-0.7,0.3 c-0.8,0.3-1.7,0.5-2.6,0.8c-0.2,0.1-0.5,0.1-0.7,0.2c-1,0.3-2.1,0.5-3.3,0.6c-2.3,0.3-4.8,0.5-7.5,0.5l0-1.4L254.9,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M255.8,278.2c-0.3,0-0.7,0-1,0l-0.4,0l0.1-6.6l0.4,0c0.6,0,1.2,0,1.8,0c2.6-0.1,5.2-0.4,7.5-1 c1.1-0.3,2.3-0.6,3.3-1l0.1,0c0.5-0.2,1-0.4,1.5-0.6c0.2-0.1,0.5-0.2,0.7-0.3c0.5-0.2,0.9-0.5,1.5-0.8c1-0.6,2-1.3,2.9-2 c3.7-2.9,5.2-5.9,5.2-5.9l0.2-0.3l5.9,2.9l-0.1,0.3c0,0-2.4,5-8.4,9.2c-1.2,0.9-2.6,1.7-3.9,2.4c-1.1,0.6-2.3,1.1-3.5,1.5 c-0.2,0.1-0.5,0.2-0.7,0.3c-0.8,0.3-1.7,0.5-2.6,0.8l-0.2,0c-0.2,0-0.4,0.1-0.5,0.1c-1,0.3-2.2,0.5-3.3,0.6 C260.2,278,258,278.2,255.8,278.2z M255.1,277.5c2.4,0,4.8-0.1,7.1-0.5c1.1-0.2,2.2-0.4,3.2-0.6c0.2,0,0.3-0.1,0.5-0.1l0.2,0 c0.9-0.2,1.7-0.5,2.5-0.8c0.2-0.1,0.5-0.2,0.7-0.2c1.2-0.4,2.3-0.9,3.4-1.5c1.3-0.7,2.6-1.4,3.8-2.3c5-3.5,7.4-7.5,8-8.6 l-4.7-2.3c-0.5,0.9-2.1,3.4-5.2,5.9c-0.9,0.7-2,1.4-3,2.1c-0.5,0.3-1,0.6-1.5,0.8c-0.2,0.1-0.5,0.2-0.7,0.3 c-0.6,0.3-1.1,0.5-1.6,0.7c0,0-0.1,0-0.1,0.1c-1.1,0.4-2.2,0.8-3.4,1c-2.4,0.6-5,0.9-7.7,1c-0.5,0-1,0-1.4,0L255.1,277.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M255.8,272.1c2.6-0.1,5-0.4,7.1-0.8c0.2-0.1,0.4,0.2,0.3,0.4c-0.6,1.9-1.2,3.9-1.8,5.7 c0,0.1-0.1,0.2-0.2,0.2c-2.2,0.3-4.7,0.5-7.3,0.4l0-1.4L255.8,272.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M254.9,278.7c-0.3,0-0.7,0-1,0l-0.7,0l0-2.2l2.1-5l0.5,0c2.4-0.1,4.8-0.3,6.9-0.8c0.3-0.1,0.7,0,1,0.3 c0.2,0.3,0.3,0.6,0.2,1c-0.6,1.9-1.2,3.9-1.8,5.7c-0.1,0.4-0.4,0.6-0.8,0.7C259.2,278.5,257.1,278.7,254.9,278.7z  M254.6,277.3c2.1,0,4.2-0.1,6.2-0.4c0.5-1.6,1-3.2,1.5-4.8c-1.9,0.4-4,0.6-6.1,0.7l-1.6,3.9L254.6,277.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M271.6,268c1.1-0.6,2-1.3,2.9-2l2.3,5.6c-1.1,0.8-2.3,1.5-3.6,2.2c-0.1,0.1-0.3,0-0.3-0.1 c-0.4-1.7-1-3.8-1.4-5.5C271.5,268.1,271.6,268.1,271.6,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M273.1,274.6c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.4-0.3-0.5-0.6c-0.4-1.7-1-3.8-1.4-5.5 c-0.1-0.4,0.1-0.8,0.4-1c1-0.6,1.9-1.2,2.8-1.9l0.7-0.6l2.9,7l-0.5,0.3c-1.2,0.8-2.4,1.6-3.7,2.3 C273.4,274.6,273.2,274.6,273.1,274.6z M272.3,268.4c0.4,1.4,0.8,3.1,1.1,4.5c0.9-0.5,1.7-1,2.5-1.5l-1.8-4.2 C273.6,267.6,273,268,272.3,268.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M266.8,270.5c0-0.2,0.2-0.3,0.3-0.4c0.2-0.1,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1,0c0.5-0.2,1.2-0.5,1.5-0.6 c0,0,0.1,0,0.1,0.1l-0.5,6.1c0,0.2-0.2,0.4-0.4,0.5c-0.7,0.2-2.4,0.7-2.8,0.8c0,0-0.1,0-0.1-0.1 C266,274.5,266.5,272.2,266.8,270.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M265.4,277.5l-0.3-0.3c-0.2-0.2-0.3-0.5-0.2-0.7l1.3-6.1c0.1-0.4,0.4-0.7,0.8-0.9 c0.1-0.1,0.3-0.1,0.4-0.2l0.2-0.1c0.5-0.2,1.2-0.5,1.5-0.6l0.4-0.2l0.4,0.2c0.2,0.2,0.3,0.4,0.3,0.7l-0.5,6.1 c0,0.5-0.4,0.9-0.8,1.1c-0.7,0.2-2.4,0.7-2.9,0.8L265.4,277.5z M267.5,270.7l-1.1,5c0.6-0.2,1.3-0.4,1.7-0.5l0.4-4.9 c-0.2,0.1-0.3,0.1-0.5,0.2c0,0-0.1,0-0.2,0.1C267.8,270.6,267.6,270.7,267.5,270.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M284.4,269.5c-3.1,3.3-8.9,7.9-9.6,7.4c-0.5-0.4-0.9-2.2-1.2-2.8l-3.4-8.2c-0.6-1.5,0-3.3,1.5-4 c3.8-1.8,7.1-4.6,10.2-7.7c0.9-0.9,2.2-1.1,3.4-0.7l6.2,2.6c1,0.4,1.4,1.7,0.8,2.6C290.3,261.7,286.4,267.5,284.4,269.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M274.9,277.3c-0.1,0-0.2,0-0.3-0.1c-0.4-0.3-0.7-1.2-1-2.2c-0.1-0.3-0.2-0.6-0.3-0.8l-3.4-8.2 c-0.7-1.7,0-3.7,1.7-4.4c4-1.8,7.3-4.9,10.1-7.6c1-1,2.5-1.3,3.7-0.7l6.2,2.6c0.6,0.2,1,0.7,1.2,1.3c0.2,0.6,0.1,1.3-0.3,1.8 c-1.7,2.5-5.9,8.7-7.9,10.8C282.7,271.9,276.6,277.3,274.9,277.3z M284.1,253.7c-0.7,0-1.4,0.3-1.9,0.8 c-2.8,2.8-6.2,5.9-10.3,7.7c-1.3,0.6-1.9,2.2-1.4,3.5l3.4,8.2c0.1,0.2,0.2,0.5,0.3,0.8c0.2,0.6,0.5,1.6,0.8,1.8 c0.9-0.1,5.9-4,9.1-7.3c2-2.1,6.2-8.2,7.8-10.7c0.2-0.4,0.3-0.8,0.2-1.2c-0.1-0.4-0.4-0.7-0.8-0.9l-6.2-2.6 C284.9,253.8,284.5,253.7,284.1,253.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M285.9,242.8l4.1,5l-1.8,1.4l-3.6-5.4c-0.2-0.4-0.2-0.9,0.2-1.1C285.2,242.4,285.7,242.4,285.9,242.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M288.2,249.7l-3.8-5.7c-0.4-0.5-0.2-1.2,0.3-1.6c0.5-0.4,1.2-0.3,1.6,0.2l4.4,5.3L288.2,249.7z  M285.3,242.8c-0.1,0-0.2,0-0.3,0.1c-0.2,0.2-0.3,0.4-0.1,0.7l3.4,5.1l1.3-0.9l-3.9-4.7C285.6,242.9,285.4,242.8,285.3,242.8 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M287.2,246.1c1.2-2.7,4.7-4,7.3-2.9c2.6,1.1,4,4.8,2.8,7.5c-1.2,2.7-5.4,4.8-8.1,3.6 C286.6,253.3,286,248.9,287.2,246.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M291,255.1c-0.7,0-1.3-0.1-1.8-0.4c-1.3-0.6-2.3-1.9-2.7-3.8c-0.3-1.7-0.2-3.5,0.4-5 c0.6-1.4,1.8-2.5,3.3-3.1c1.5-0.6,3.1-0.6,4.5,0c2.8,1.2,4.3,5.1,3,8C296.6,253.4,293.6,255.1,291,255.1z M292.4,243.2 c-0.7,0-1.3,0.1-2,0.4c-1.3,0.5-2.4,1.5-2.9,2.7c-0.6,1.3-0.7,3-0.4,4.5c0.3,1.7,1.1,2.8,2.3,3.3c2.4,1,6.5-0.8,7.6-3.4 c1.1-2.6-0.2-6-2.6-7.1C293.8,243.3,293.1,243.2,292.4,243.2z"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M168.5,266.8v14.2c0,3.1-2.5,5.6-5.6,5.6h-5.1c-3.7,0-6.7-3-6.7-6.7v-12.2c0-3.7,3-6.7,6.7-6.7h5.1 C166,261.2,168.5,263.7,168.5,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M162.9,287h-5.1c-3.9,0-7-3.1-7-7v-12.2c0-3.9,3.1-7,7-7h5.1c3.3,0,6,2.7,6,6v14.2 C168.9,284.3,166.2,287,162.9,287z M157.8,261.5c-3.5,0-6.3,2.8-6.3,6.3V280c0,3.5,2.8,6.3,6.3,6.3h5.1c2.9,0,5.3-2.4,5.3-5.3 v-14.2c0-2.9-2.4-5.3-5.3-5.3H157.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M259.9,267.8V280c0,3.7-3,6.7-6.7,6.7h-5.1c-3.1,0-5.6-2.5-5.6-5.6v-14.2c0-3.1,2.5-5.6,5.6-5.6h5.1 C256.9,261.2,259.9,264.2,259.9,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M253.2,287h-5.1c-3.3,0-6-2.7-6-6v-14.2c0-3.3,2.7-6,6-6h5.1c3.9,0,7,3.1,7,7V280 C260.2,283.9,257.1,287,253.2,287z M248.1,261.5c-2.9,0-5.3,2.4-5.3,5.3v14.2c0,2.9,2.4,5.3,5.3,5.3h5.1c3.5,0,6.3-2.8,6.3-6.3 v-12.2c0-3.5-2.8-6.3-6.3-6.3H248.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M250.2,279.7l-6.3,14L231.8,321c-4.5,10.2-14.6,17-25.8,17.1h-0.5c-11.2-0.1-21.2-6.8-25.8-17.1 l-12.1-27.2l-6.3-14c-7.2-12.4,1.8-27.9,16.1-27.9h56.6C248.4,251.8,257.4,267.3,250.2,279.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M206,338.4h-0.5c-11.2-0.1-21.5-6.9-26.1-17.3L161,279.9c-3.4-5.9-3.4-13,0-18.9c3.4-5.9,9.6-9.5,16.4-9.5 h56.6c6.9,0,13,3.5,16.4,9.5c3.4,5.9,3.4,13,0,19l-18.4,41.2C227.5,331.6,217.3,338.3,206,338.4z M177.5,252.2 c-6.6,0-12.5,3.4-15.8,9.1c-3.3,5.7-3.3,12.6,0,18.3l18.4,41.3c4.5,10.2,14.5,16.8,25.5,16.8h0.5c10.9-0.1,20.9-6.7,25.5-16.8 l18.4-41.3c3.3-5.7,3.3-12.6,0-18.3c-3.3-5.7-9.2-9.1-15.8-9.1H177.5z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M249.4,281.4l-5.8,13.3c-0.2,0.4-0.6,0.7-1.1,0.7h-21.9c-0.7,0-1.2-0.5-1.2-1.2v-15.4 c0-0.7-0.5-1.2-1.2-1.2h-26.5c-0.7,0-1.2,0.5-1.2,1.2v15.4c0,0.7-0.5,1.2-1.2,1.2h-20c-0.5,0-0.9-0.3-1.1-0.7l-5.8-13.3 c0,0,0-0.1,0-0.1c-7-12.4,1.8-27.9,15.8-27.9h55.5C247.6,253.4,256.4,268.8,249.4,281.4C249.4,281.3,249.4,281.3,249.4,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M242.4,295.7h-21.9c-0.9,0-1.6-0.7-1.6-1.6v-15.4c0-0.5-0.4-0.9-0.9-0.9h-26.5c-0.5,0-0.9,0.4-0.9,0.9 v15.4c0,0.9-0.7,1.6-1.6,1.6h-20c-0.6,0-1.2-0.4-1.4-0.9l-5.8-13.3c-3.4-6.1-3.4-13.2,0.1-19.2c3.4-5.8,9.4-9.3,16-9.3h55.5 c6.6,0,12.6,3.5,16,9.3c3.5,6,3.6,13.1,0.2,19.2l0,0.1l-5.8,13.3C243.6,295.3,243.1,295.7,242.4,295.7z M191.6,277.2h26.5 c0.9,0,1.6,0.7,1.6,1.6v15.4c0,0.5,0.4,0.9,0.9,0.9h21.9c0.3,0,0.7-0.2,0.8-0.5l5.8-13.3c0,0,0-0.1,0.1-0.1 c3.3-5.8,3.2-12.7-0.2-18.5c-3.3-5.6-9-8.9-15.4-8.9h-55.5c-6.4,0-12.1,3.3-15.4,8.9c-3.4,5.8-3.4,12.7-0.2,18.5 c0,0,0,0.1,0.1,0.1l5.8,13.3c0.1,0.3,0.4,0.5,0.8,0.5h20c0.5,0,0.9-0.4,0.9-0.9v-15.4C190.1,277.9,190.8,277.2,191.6,277.2z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M168.5,266.8v14.2c0,3.1-2.5,5.6-5.6,5.6h-0.5l-2.9-6.5c-3.7-6.4-3.1-13.5,0.2-19h3.2 C166,261.2,168.5,263.7,168.5,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M162.9,287h-0.7l-3-6.7c-3.5-6.1-3.4-13.3,0.2-19.3l0.1-0.2h3.4c3.3,0,6,2.7,6,6v14.2 C168.9,284.3,166.2,287,162.9,287z M162.6,286.3h0.2c2.9,0,5.3-2.4,5.3-5.3v-14.2c0-2.9-2.4-5.3-5.3-5.3h-3 c-3.4,5.8-3.5,12.6-0.1,18.5L162.6,286.3z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M252,280l-3,6.7h-0.5c-3.1,0-5.6-2.5-5.6-5.6v-14.2c0-3.1,2.5-5.6,5.6-5.6h3.4 C255.1,266.6,255.6,273.7,252,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M249.2,287h-0.8c-3.3,0-6-2.7-6-6v-14.2c0-3.3,2.7-6,6-6h3.6l0.1,0.2c3.5,6,3.6,13.1,0.1,19.1L249.2,287z  M248.4,261.5c-2.9,0-5.3,2.4-5.3,5.3v14.2c0,2.9,2.4,5.3,5.3,5.3h0.3l2.9-6.5c3.3-5.7,3.3-12.5,0-18.3H248.4z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M250.2,279.7l-6.3,14h-22.7c-0.2,0-0.4-0.2-0.4-0.4v-16.3c0-0.6-0.5-1.1-1.1-1.1h-29.7 c-0.6,0-1.1,0.5-1.1,1.1v16.3c0,0.2-0.2,0.4-0.4,0.4h-20.8l-6.3-14c-7.2-12.4,1.8-27.9,16.1-27.9h56.6 C248.4,251.8,257.4,267.3,250.2,279.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M244.2,294.1h-23c-0.4,0-0.7-0.3-0.7-0.7v-16.3c0-0.4-0.4-0.8-0.8-0.8h-29.7c-0.4,0-0.8,0.4-0.8,0.8v16.3 c0,0.4-0.3,0.7-0.7,0.7h-21l-6.3-14.2c-3.4-5.9-3.4-13,0-18.9c3.4-5.9,9.6-9.5,16.4-9.5h56.6c6.9,0,13,3.5,16.4,9.5 c3.4,5.9,3.4,13,0,19L244.2,294.1z M167.8,293.4h20.6l0-16.3c0-0.8,0.7-1.5,1.5-1.5h29.7c0.8,0,1.5,0.7,1.5,1.5v16.3l22.6,0 l6.2-13.9c3.3-5.7,3.3-12.6,0-18.3c-3.3-5.7-9.2-9.1-15.8-9.1h-56.6c-6.6,0-12.5,3.4-15.8,9.1c-3.3,5.7-3.3,12.6,0,18.3 L167.8,293.4z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M217.5,301.8c0,1-0.8,1.8-1.8,1.8h-21.5c-0.7,0-1.3-0.6-1.3-1.3c0,0,0.2-20,0.2-20c0-1.4,1.1-2.5,2.4-2.5 l20.7-0.8c0.4,0,0.8,0.2,1.1,0.6c0.1,0.2,0.2,0.4,0.2,0.6V301.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M215.7,303.9h-21.5c-0.9,0-1.7-0.7-1.7-1.6l0.2-20c0-1.5,1.2-2.8,2.8-2.9l20.7-0.8c0.6,0,1.1,0.3,1.4,0.7 c0.1,0.2,0.2,0.5,0.2,0.8v21.5C217.8,303,216.9,303.9,215.7,303.9z M216.3,279.4c0,0-20.7,0.8-20.7,0.8c-1.2,0-2.1,1-2.1,2.2 l-0.2,20c0,0.5,0.4,0.9,1,0.9h21.5c0.8,0,1.4-0.6,1.4-1.4v-21.5c0-0.2,0-0.3-0.1-0.4C216.8,279.6,216.6,279.4,216.3,279.4z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M215.6,302.7h-21.5c-0.7,0-1.2-0.5-1.2-1.2v-21.3c0-0.7,0.5-1.2,1.2-1.2h21.5c0.7,0,1.2,0.5,1.2,1.2v21.3 C216.8,302.2,216.3,302.7,215.6,302.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M215.8,303.1h-21.9c-0.7,0-1.4-0.6-1.4-1.4v-21.6c0-0.7,0.6-1.4,1.4-1.4h21.9c0.7,0,1.4,0.6,1.4,1.4v21.6 C217.1,302.5,216.5,303.1,215.8,303.1z M193.9,279.4c-0.4,0-0.7,0.3-0.7,0.7v21.6c0,0.4,0.3,0.7,0.7,0.7h21.9 c0.4,0,0.7-0.3,0.7-0.7v-21.6c0-0.4-0.3-0.7-0.7-0.7H193.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M147.5,188.3c-0.1,1.9-0.2,3.8-0.1,5.7c0.1,1.9,0.2,3.8,0.5,5.6c0.2,1.9,0.6,3.7,1,5.5 c0.4,1.8,1,3.6,1.5,5.4l-2.4,0.7c-0.5-1.9-0.9-3.8-1.1-5.7c-0.3-1.9-0.5-3.8-0.6-5.8c-0.1-1.9-0.1-3.9,0-5.8 c0.1-1.9,0.2-3.8,0.6-5.7L147.5,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M147.8,211.6l-0.1-0.4c-0.4-1.7-0.9-3.7-1.1-5.8c-0.3-1.8-0.5-3.7-0.6-5.8c-0.1-1.9-0.1-3.8,0-5.8 c0.1-2.2,0.3-4,0.6-5.8l0.1-0.3l1.3,0.2l0,0.3c-0.1,1.7-0.2,3.5-0.1,5.6c0.1,1.9,0.2,3.8,0.5,5.6c0.3,2,0.6,3.8,1,5.5 c0.4,1.9,1,3.7,1.5,5.3l0.1,0.3L147.8,211.6z M147.1,189.2c-0.2,1.4-0.3,3-0.4,4.8c-0.1,2-0.1,3.9,0,5.7 c0.1,2.1,0.3,3.9,0.6,5.7c0.3,1.9,0.7,3.7,1,5.3l1.7-0.5c-0.5-1.6-1-3.3-1.4-5.1c-0.4-1.7-0.7-3.5-1-5.6 c-0.2-1.8-0.4-3.7-0.5-5.7C147,192.2,147,190.6,147.1,189.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M150.4,186.4c0.2,1.4-0.7,2.7-2,2.9c-1.4,0.2-2.7-0.7-2.9-2c-0.2-1.4,0.7-2.7,2-2.9 C148.8,184.1,150.1,185,150.4,186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M147.9,189.7c-1.3,0-2.5-1-2.8-2.3c-0.3-1.5,0.7-3,2.3-3.3c1.5-0.3,3,0.7,3.3,2.3c0.3,1.5-0.7,3-2.3,3.3 C148.3,189.7,148.1,189.7,147.9,189.7z M147.9,184.7c-0.1,0-0.3,0-0.4,0c-1.2,0.2-1.9,1.3-1.7,2.5c0.2,1.2,1.3,1.9,2.5,1.7 c1.2-0.2,1.9-1.3,1.7-2.5C149.8,185.4,148.9,184.7,147.9,184.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.3,199c0.5,0,1-0.1,1.5-0.1c0-0.1,0-0.2,0-0.3c-0.5,0-1,0.1-1.5,0.1 C146.3,198.8,146.3,198.9,146.3,199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146,199.3l0-1l0.3,0c0.5,0,1-0.1,1.5-0.1l0.3,0l0.1,1l-0.4,0c-0.5,0-1,0.1-1.5,0.1L146,199.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M149.1,206c0-0.1-0.1-0.2-0.1-0.3c-0.6,0.5-1.3,0.9-1.9,1.4c0,0.1,0,0.2,0.1,0.3 C147.9,206.9,148.5,206.4,149.1,206z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M147,208l-0.2-1.1l0.2-0.1c0.6-0.5,1.3-0.9,1.9-1.4l0.4-0.3l0.3,1.1l-0.2,0.1c-0.6,0.5-1.3,0.9-1.9,1.4 L147,208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.3,195c0.4,0,0.8-0.1,1.2-0.1c0-0.1,0-0.2,0-0.3c-0.4,0-0.8,0.1-1.2,0.1 C146.3,194.8,146.3,194.9,146.3,195z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M145.9,195.4l0-1l0.5,0c0.3,0,0.6-0.1,1-0.1l0.4,0l0.1,1l-0.3,0c-0.4,0-0.8,0.1-1.2,0.1L145.9,195.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M148,200.3c0-0.1,0-0.2,0-0.3c-0.5,0.3-1,0.6-1.5,1c0,0.1,0,0.2,0,0.3C147,200.9,147.5,200.6,148,200.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.2,201.9l-0.1-1.1l0.2-0.1c0.5-0.3,1-0.7,1.5-1l0.5-0.3l0.2,1.1l-0.2,0.1c-0.5,0.3-1,0.6-1.6,1 L146.2,201.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.6,190.6l0.8,0.1c0-0.1,0-0.2,0-0.3l-0.8-0.1C146.6,190.4,146.6,190.5,146.6,190.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "147.8,191.1 146.2,190.9 146.3,189.9 147.8,190  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.4,193.1c0,0.1,0,0.2,0,0.4l1-0.6c0-0.1,0-0.2,0-0.4L146.4,193.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "146,194.1 146.1,192.9 147.7,191.9 147.8,193.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.7,203.8c0,0.1,0,0.2,0,0.3c0.2,0,0.4-0.1,0.6-0.1c0.4-0.1,0.9-0.1,1.3-0.2c0-0.1,0-0.2-0.1-0.3 c-0.4,0.1-0.8,0.1-1.3,0.2C147.1,203.8,146.9,203.8,146.7,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.4,204.6l-0.1-1l0.3-0.1l2.2-0.3l0.2,1l-0.4,0c-0.4,0-0.8,0.1-1.2,0.2L146.4,204.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M146.3,196.8c0,0.1,0,0.2,0,0.4l1.3-0.8c0-0.1,0-0.2,0-0.3L146.3,196.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "145.9,197.8 145.9,196.6 147.9,195.5 148,196.6  "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M242.9,170.9c0.8,1.7,1.5,3.5,2.1,5.3c0.6,1.8,1.1,3.6,1.5,5.4c0.4,1.8,0.8,3.7,1,5.5 c0.3,1.9,0.4,3.7,0.5,5.6l2.5-0.2c-0.2-1.9-0.5-3.9-0.9-5.8c-0.4-1.9-0.9-3.8-1.5-5.6c-0.6-1.8-1.3-3.6-2-5.4 c-0.8-1.8-1.6-3.5-2.5-5.2L242.9,170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M247.6,193.1l0-0.4c-0.1-1.8-0.2-3.6-0.4-5.5c-0.2-1.8-0.5-3.5-1-5.5c-0.4-1.8-0.9-3.6-1.5-5.4 c-0.7-2-1.3-3.7-2.1-5.2l-0.1-0.3l1.1-0.6l0.2,0.3c0.9,1.5,1.7,3.2,2.6,5.2c0.8,1.8,1.5,3.7,2,5.4c0.6,2,1.1,3.8,1.5,5.6 c0.5,2,0.7,4,1,5.8l0,0.4L247.6,193.1z M243.6,171.6c0.6,1.3,1.1,2.8,1.7,4.4c0.6,1.8,1.1,3.7,1.5,5.5c0.5,2,0.8,3.8,1,5.6 c0.3,1.8,0.4,3.6,0.4,5.2l1.8-0.1c-0.2-1.6-0.5-3.5-0.9-5.3c-0.4-1.8-0.9-3.6-1.5-5.6c-0.6-1.8-1.2-3.6-2-5.4 C245,174.3,244.3,172.9,243.6,171.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M239.6,170.1c0.2,1.4,1.5,2.3,2.9,2c1.4-0.2,2.3-1.5,2-2.9c-0.2-1.4-1.5-2.3-2.9-2 C240.2,167.5,239.3,168.8,239.6,170.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M242,172.5c-0.6,0-1.1-0.2-1.6-0.5c-0.6-0.4-1-1.1-1.2-1.8c-0.1-0.7,0-1.5,0.5-2.1 c0.4-0.6,1.1-1,1.8-1.2c0.7-0.1,1.5,0,2.1,0.5c0.6,0.4,1,1.1,1.2,1.8c0.1,0.7,0,1.5-0.5,2.1c-0.4,0.6-1.1,1-1.8,1.2 C242.4,172.5,242.2,172.5,242,172.5z M242,167.6c-0.1,0-0.3,0-0.4,0c-0.6,0.1-1.1,0.4-1.4,0.9c-0.3,0.5-0.4,1-0.3,1.6 c0.1,0.6,0.4,1.1,0.9,1.4c0.5,0.3,1,0.4,1.6,0.3c1.2-0.2,1.9-1.3,1.7-2.5c-0.1-0.6-0.4-1.1-0.9-1.4 C242.9,167.7,242.5,167.6,242,167.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M247.8,180.5c-0.5,0.2-1,0.3-1.4,0.4c0-0.1,0-0.2-0.1-0.3c0.5-0.1,1-0.3,1.4-0.4 C247.7,180.3,247.8,180.4,247.8,180.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M246.1,181.4l-0.2-1l0.3-0.1c0.5-0.1,0.9-0.3,1.4-0.4l0.3-0.1l0.3,1l-0.3,0.1c-0.5,0.2-1,0.3-1.5,0.4 L246.1,181.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M247.6,188c0-0.1,0-0.2,0-0.3c0.8,0.2,1.5,0.4,2.3,0.6c0,0.1,0,0.2,0.1,0.3 C249.1,188.5,248.4,188.3,247.6,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M250.4,189.2l-0.5-0.2c-0.8-0.2-1.5-0.4-2.3-0.7l-0.2-0.1l-0.1-1.1l0.5,0.1c0.8,0.2,1.5,0.4,2.3,0.6 l0.2,0.1L250.4,189.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M246.4,176.8c-0.4,0.1-0.8,0.2-1.1,0.3c0-0.1-0.1-0.2-0.1-0.3c0.4-0.1,0.7-0.2,1.1-0.3 C246.3,176.6,246.4,176.7,246.4,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M245,177.5l-0.3-0.9l0.3-0.1c0.3-0.1,0.6-0.2,1-0.3l0.4-0.1l0.4,0.9l-0.4,0.1c-0.4,0.1-0.8,0.2-1.2,0.3 L245,177.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M246.7,182.3c0-0.1,0-0.2-0.1-0.3c0.6,0.1,1.2,0.2,1.8,0.4c0,0.1,0.1,0.2,0.1,0.3 C247.9,182.6,247.3,182.4,246.7,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M249,183.2l-0.6-0.1c-0.6-0.1-1.2-0.3-1.8-0.4l-0.2,0l-0.2-1.1l0.5,0.1c0.6,0.1,1.2,0.2,1.8,0.4l0.2,0 L249,183.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M244.6,172.8l-0.7,0.4c0-0.1-0.1-0.2-0.1-0.3l0.7-0.3C244.5,172.6,244.6,172.7,244.6,172.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "243.7,173.6 243.3,172.7 244.6,172 245.1,172.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M245.7,175.1c0.1,0.1,0.1,0.2,0.2,0.3l-1.2-0.2c0-0.1-0.1-0.2-0.1-0.3L245.7,175.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "246.4,175.9 244.4,175.5 244,174.4 245.9,174.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M249.2,185.2c0,0.1,0,0.2,0.1,0.3c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.9,0.2-1.3,0.3c0-0.1,0-0.2,0-0.3 c0.4-0.1,0.8-0.2,1.3-0.3C248.8,185.3,249,185.2,249.2,185.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M247.1,186.4l-0.2-1l2.5-0.6l0.2,1l-0.9,0.2c-0.5,0.1-0.9,0.2-1.4,0.3L247.1,186.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M247.1,178.5c0,0.1,0.1,0.2,0.1,0.3l-1.5-0.3c0-0.1-0.1-0.2-0.1-0.3L247.1,178.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "247.7,179.3 245.4,178.9 245.1,177.8 247.3,178.2  "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M161.5,215.4l2,10.8c0.6,3.5-1,6.9-3.8,8.7c-0.9,0.6-1.9,1-3,1.2c-4.6,0.8-10.6-2.1-11.4-6.7l-2-10.8 c-0.8-4.3,3.3-8.6,7.6-9.8c0.2-0.1,0.5-0.1,0.7-0.2c2.3-0.4,4.5,0.1,6.3,1.4C159.8,211.2,161.1,213.1,161.5,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M155.1,236.6c-4.4,0-9.4-2.8-10.2-7.1l-2-10.8c-0.8-4.6,3.4-9,7.9-10.2c0.3-0.1,0.5-0.1,0.8-0.2 c2.3-0.4,4.7,0.1,6.6,1.4c1.9,1.3,3.2,3.4,3.7,5.7l2,10.8c0.6,3.5-0.9,7.1-3.9,9c-0.9,0.6-2,1-3.1,1.2 C156.2,236.6,155.7,236.6,155.1,236.6z M153.2,208.8c-0.5,0-1,0-1.5,0.1c-0.2,0-0.5,0.1-0.7,0.2c-4.1,1.1-8.1,5.2-7.4,9.4 l2,10.8c0.8,4.5,6.7,7.2,11,6.4c1-0.2,2-0.6,2.9-1.1c2.8-1.8,4.2-5,3.6-8.3l-2-10.8c-0.4-2.1-1.6-4-3.4-5.2 C156.4,209.3,154.8,208.8,153.2,208.8z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M257.4,199.6l1.4,7.8c1,5.4-2.6,10.7-8.1,11.7c-0.8,0.1-1.6,0.2-2.3,0.1c-3.7-0.3-6.8-3.1-7.5-6.9 l-2-10.8c-0.4-2.3,0.1-4.5,1.4-6.3c1.2-1.8,3.1-3.1,5.4-3.5c0.5-0.1,1.1-0.1,1.6-0.2C252.2,191.2,256.5,194.7,257.4,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M249.3,219.5c-0.3,0-0.6,0-0.8,0c-3.9-0.4-7.1-3.3-7.8-7.2l-2-10.8c-0.4-2.3,0.1-4.7,1.4-6.6 c1.3-1.9,3.4-3.2,5.7-3.7c0.5-0.1,1.1-0.2,1.6-0.2c5-0.2,9.5,3.5,10.4,8.5l1.4,7.8c0.5,2.7-0.1,5.5-1.7,7.8 c-1.6,2.3-3.9,3.8-6.7,4.3C250.3,219.4,249.8,219.5,249.3,219.5z M247.6,191.7c-0.1,0-0.1,0-0.2,0c-0.5,0-1,0.1-1.5,0.1 c-2.1,0.4-4,1.6-5.2,3.4c-1.2,1.8-1.7,3.9-1.3,6.1l2,10.8c0.6,3.6,3.6,6.3,7.2,6.6c0.7,0.1,1.5,0,2.2-0.1 c2.5-0.5,4.7-1.9,6.2-4c1.5-2.1,2-4.7,1.6-7.2l-1.4-7.8C256.3,195.1,252.2,191.7,247.6,191.7z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M161.5,215.4l2,10.8c0.6,3.5-1,6.9-3.8,8.7c-4.2-4.1-7.1-9.4-8.3-16.1c-0.6-3.3-0.7-6.7-0.5-10.1 c0.2-0.1,0.5-0.1,0.7-0.2c2.3-0.4,4.5,0.1,6.3,1.4C159.8,211.2,161.1,213.1,161.5,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M159.7,235.4l-0.2-0.2c-4.4-4.3-7.2-9.8-8.4-16.3c-0.6-3.3-0.8-6.7-0.5-10.1l0-0.2l0.2-0.1 c0.3-0.1,0.5-0.1,0.8-0.2c2.3-0.4,4.7,0.1,6.6,1.4c1.9,1.3,3.2,3.4,3.7,5.7l2,10.8c0.6,3.5-0.9,7.1-3.9,9L159.7,235.4z  M151.3,209.1c-0.2,3.3-0.1,6.6,0.5,9.7c1.1,6.2,3.8,11.5,8,15.7c2.6-1.8,4-5,3.4-8.1l-2-10.8c-0.4-2.1-1.6-4-3.4-5.2 c-1.8-1.2-3.9-1.7-6.1-1.3C151.6,209,151.4,209,151.3,209.1z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M250.6,201.1c1.2,6.6,0.4,12.7-2.1,18c-3.7-0.3-6.8-3.1-7.5-6.9l-2-10.8c-0.4-2.3,0.1-4.5,1.4-6.3 c1.2-1.8,3.1-3.1,5.4-3.5c0.5-0.1,1.1-0.1,1.6-0.2C248.9,194.5,250,197.8,250.6,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M248.7,219.5l-0.2,0c-3.9-0.4-7.1-3.3-7.8-7.2l-2-10.8c-0.4-2.3,0.1-4.7,1.4-6.6c1.3-1.9,3.4-3.2,5.7-3.7 c0.5-0.1,1.1-0.2,1.6-0.2l0.2,0l0.1,0.2c1.6,3.2,2.7,6.6,3.3,9.9c1.2,6.5,0.5,12.6-2.2,18.2L248.7,219.5z M247.1,191.7 c-0.4,0-0.9,0.1-1.3,0.1c-2.1,0.4-4,1.6-5.2,3.4c-1.2,1.8-1.7,3.9-1.3,6.1l2,10.8c0.6,3.5,3.5,6.2,7,6.6 c2.5-5.4,3.1-11.3,2-17.5C249.7,198,248.6,194.8,247.1,191.7z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M248.6,201.3c4.1,22.4-15.3,37.7-41.7,42.5c-26.4,4.8-49.7-2.8-53.8-25.2c-3.5-19,7.9-41.5,27.5-50.8 c3.5-1.7,7.3-2.9,11.3-3.7c4-0.7,7.9-0.9,11.8-0.6C225.7,165.4,245.1,182.3,248.6,201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M192.2,245.6c-21.4,0-36.3-9.8-39.4-26.8c-3.6-19.6,8.6-42.1,27.7-51.2c3.6-1.7,7.5-3,11.4-3.7 c3.9-0.7,7.9-0.9,11.9-0.6c21.7,1.7,41.5,18.4,45.1,38c3.8,20.8-12.7,37.6-41.9,42.9C201.8,245.2,196.8,245.6,192.2,245.6z  M200.1,163.9c-2.7,0-5.4,0.2-8.1,0.7c-3.9,0.7-7.7,1.9-11.3,3.6c-18.8,9-30.8,31.1-27.3,50.4c3.7,20.3,24.6,30.1,53.4,24.9 c28.8-5.2,45.1-21.8,41.4-42.1c-3.5-19.3-23-35.7-44.5-37.4C202.6,163.9,201.3,163.9,200.1,163.9z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M237.8,208.4c2.8,15.1-9.4,20.9-26.2,24.5l-1.8-5.4l-12,2.2l0.2,5.6c-16.7,2.4-29.9,1.2-32.6-13.8 c-3.1-17-3.1-37.8,28.7-43.6C225.8,172.2,234.7,191.4,237.8,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M186.5,236.7c-10.4,0-19.3-3.1-21.5-15c-1.4-7.7-2.5-17.7,1.3-26.2c4.2-9.3,13.2-15.2,27.7-17.8 c14.3-2.6,25.4-0.3,32.9,6.8c5.6,5.3,9.2,13.1,11.2,24c3,16.2-11,21.6-26.5,24.9l-0.3,0.1l-1.8-5.4l-11.4,2.1l0.2,5.6l-0.3,0 C194.2,236.3,190.2,236.7,186.5,236.7z M204.8,177.3c-3.3,0-6.9,0.3-10.7,1c-14.2,2.6-23.1,8.3-27.2,17.4 c-3.7,8.4-2.6,18.2-1.3,25.8c2.8,15.4,17,15.6,31.9,13.5l-0.2-5.6l12.6-2.3l1.8,5.4c15-3.3,28.5-8.5,25.6-24 c-2-10.7-5.5-18.4-11-23.6C221.1,179.9,213.8,177.3,204.8,177.3z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M236.7,208.4c2.7,14.7-9.1,20.3-25.5,23.8l-1.7-5.2l-11.6,2.1l0.2,5.5c-16.2,2.3-29.1,1.1-31.7-13.4 c-3-16.5-3-36.7,27.9-42.3C225.1,173.2,233.7,191.9,236.7,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M186.9,235.8c-10.1,0-18.8-3.1-20.9-14.6c-3.1-17-2.7-37.1,28.2-42.8c13.9-2.5,24.7-0.3,32,6.6 c5.4,5.1,9,12.7,10.9,23.3c2.9,15.8-10.7,20.9-25.7,24.2l-0.3,0.1l-1.7-5.2l-11,2l0.2,5.5l-0.3,0 C194.3,235.4,190.5,235.8,186.9,235.8z M204.6,178.2c-3.2,0-6.7,0.3-10.4,1c-30.2,5.5-30.6,25.3-27.6,41.9 c2.7,14.9,16.5,15.2,31,13.1l-0.2-5.5l12.2-2.2l1.7,5.2c14.6-3.2,27.6-8.2,24.9-23.3c-1.9-10.4-5.4-17.9-10.7-22.9 C220.4,180.6,213.4,178.2,204.6,178.2z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M190.4,204.2c1,5.5-2.6,10.8-8.1,11.8c-5.5,1-10.8-2.6-11.8-8.1c-1-5.5,2.6-10.8,8.1-11.8 C184.1,195,189.4,198.7,190.4,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M180.4,216.5c-5,0-9.4-3.6-10.3-8.6c-1-5.7,2.7-11.1,8.4-12.2c5.7-1,11.2,2.7,12.2,8.4 c0.5,2.8-0.1,5.5-1.7,7.8c-1.6,2.3-4,3.8-6.7,4.3C181.7,216.4,181,216.5,180.4,216.5z M180.4,196.2c-0.6,0-1.2,0.1-1.8,0.2 c-5.3,1-8.8,6.1-7.9,11.4c1,5.3,6.1,8.8,11.4,7.9c2.6-0.5,4.8-1.9,6.3-4.1c1.5-2.1,2-4.7,1.6-7.3 C189.2,199.5,185.1,196.2,180.4,196.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 180.4311,
    cy: 205.9853,
    r: 7.9468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M188.2,204.6c0.8,4.3-2.1,8.5-6.4,9.2c-4.3,0.8-8.5-2.1-9.2-6.4c-0.8-4.3,2.1-8.5,6.4-9.2 C183.3,197.4,187.5,200.2,188.2,204.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000135655390631824535820000012241746113757084562_",
    cx: 180.4303,
    cy: 205.986,
    r: 8.2973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135655390631824535820000012241746113757084562_)"
    },
    d: "M180.4,214.3c-3.9,0-7.4-2.8-8.2-6.8 c-0.4-2.2,0.1-4.4,1.3-6.2c1.3-1.8,3.2-3,5.3-3.4c4.5-0.8,8.8,2.2,9.6,6.7c0.8,4.5-2.2,8.8-6.7,9.6 C181.4,214.2,180.9,214.3,180.4,214.3z M180.4,198.4c-0.4,0-0.9,0-1.4,0.1c-2,0.4-3.7,1.5-4.9,3.1c-1.2,1.7-1.6,3.7-1.2,5.7 c0.7,4.1,4.7,6.9,8.8,6.1c4.1-0.7,6.9-4.7,6.1-8.8C187.2,201,184,198.4,180.4,198.4z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M185.1,205.1c0.5,2.6-1.2,5-3.8,5.5c-2.6,0.5-5-1.2-5.5-3.8c-0.5-2.6,1.2-5,3.8-5.5 C182.2,200.9,184.6,202.6,185.1,205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M180.4,211.1c-1,0-2-0.3-2.9-0.9c-1.1-0.8-1.9-1.9-2.1-3.3c-0.5-2.8,1.3-5.4,4.1-5.9 c2.7-0.5,5.4,1.3,5.9,4.1c0.2,1.3,0,2.7-0.8,3.8c-0.8,1.1-1.9,1.9-3.3,2.1C181,211,180.7,211.1,180.4,211.1z M180.4,201.6 c-0.3,0-0.5,0-0.8,0.1c-2.4,0.4-4,2.7-3.5,5.1c0.2,1.1,0.9,2.1,1.8,2.8c1,0.7,2.1,0.9,3.3,0.7c1.1-0.2,2.1-0.9,2.8-1.8 c0.7-1,0.9-2.1,0.7-3.3C184.4,203.1,182.5,201.6,180.4,201.6z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M227.8,197.4c1,5.5-2.6,10.8-8.1,11.8c-5.5,1-10.8-2.6-11.8-8.1c-1-5.5,2.6-10.8,8.1-11.8 C221.5,188.2,226.8,191.9,227.8,197.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M217.8,209.7c-5,0-9.4-3.6-10.3-8.6c-1-5.7,2.7-11.1,8.4-12.2c5.7-1,11.1,2.7,12.2,8.4 c1,5.7-2.7,11.1-8.4,12.2C219.1,209.6,218.4,209.7,217.8,209.7z M217.8,189.4c-0.6,0-1.2,0.1-1.8,0.2c-5.3,1-8.8,6.1-7.9,11.4 c1,5.3,6.1,8.8,11.4,7.9c5.3-1,8.8-6.1,7.9-11.4C226.6,192.7,222.5,189.4,217.8,189.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000023261271209013690920000010099037918371839637_",
    cx: 217.83,
    cy: 199.1786,
    r: 7.9468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023261271209013690920000010099037918371839637_)"
    },
    d: "M225.6,197.8c0.8,4.3-2.1,8.5-6.4,9.2 c-4.3,0.8-8.5-2.1-9.2-6.4c-0.8-4.3,2.1-8.5,6.4-9.2S224.9,193.4,225.6,197.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080929006301317078570000002629938003171264390_",
    cx: 217.8292,
    cy: 199.1779,
    r: 8.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080929006301317078570000002629938003171264390_)"
    },
    d: "M217.8,207.5c-3.9,0-7.4-2.8-8.2-6.8 c-0.4-2.2,0.1-4.4,1.3-6.2c1.3-1.8,3.2-3,5.3-3.4c2.2-0.4,4.4,0.1,6.2,1.3c1.8,1.3,3,3.2,3.4,5.3c0.8,4.5-2.2,8.8-6.7,9.6 C218.8,207.4,218.3,207.5,217.8,207.5z M217.8,191.6c-0.5,0-0.9,0-1.4,0.1c-2,0.4-3.7,1.5-4.9,3.1c-1.2,1.7-1.6,3.7-1.2,5.7 c0.7,4.1,4.7,6.9,8.8,6.1c4.1-0.7,6.9-4.7,6.1-8.8c-0.4-2-1.5-3.7-3.1-4.9C220.9,192,219.4,191.6,217.8,191.6z"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M222.5,198.3c0.5,2.6-1.2,5-3.8,5.5c-2.6,0.5-5-1.2-5.5-3.8c-0.5-2.6,1.2-5,3.8-5.5 C219.6,194.1,222,195.8,222.5,198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M217.8,204.3c-1,0-2-0.3-2.9-0.9c-1.1-0.8-1.9-1.9-2.1-3.3c-0.2-1.3,0-2.7,0.8-3.8 c0.8-1.1,1.9-1.9,3.3-2.1c1.3-0.2,2.7,0,3.8,0.8c1.1,0.8,1.9,1.9,2.1,3.3c0.2,1.3,0,2.7-0.8,3.8c-0.8,1.1-1.9,1.9-3.3,2.1 C218.4,204.2,218.1,204.3,217.8,204.3z M217.8,194.8c-0.3,0-0.5,0-0.8,0.1c-1.1,0.2-2.1,0.9-2.8,1.8c-0.7,1-0.9,2.1-0.7,3.3 c0.2,1.2,0.9,2.1,1.8,2.8c1,0.7,2.1,0.9,3.3,0.7c1.1-0.2,2.1-0.9,2.8-1.8c0.7-1,0.9-2.1,0.7-3.3c-0.2-1.2-0.9-2.1-1.8-2.8 C219.6,195.1,218.7,194.8,217.8,194.8z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M203.8,163.7l0.7,3.8c0.4,2.2-1.1,4.3-3.3,4.7l-15.2,2.8c-2.2,0.4-4.3-1.1-4.7-3.3l-0.7-3.7 c3.5-1.7,7.3-2.9,11.3-3.7C196,163.5,199.9,163.3,203.8,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M185.3,175.3c-2.1,0-3.9-1.5-4.3-3.6l-0.7-4l0.2-0.1c3.6-1.7,7.5-3,11.4-3.7c3.9-0.7,7.9-0.9,11.9-0.6 l0.3,0l0.7,4c0.4,2.4-1.2,4.7-3.5,5.1l-15.2,2.8C185.8,175.3,185.6,175.3,185.3,175.3z M181,168.1l0.6,3.4c0.4,2,2.3,3.3,4.3,3 l15.2-2.8c2-0.4,3.3-2.3,3-4.3l-0.6-3.5c-3.8-0.3-7.7-0.1-11.4,0.6C188.3,165.3,184.6,166.5,181,168.1z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M219.2,170c-1.5-0.4-3.2-0.4-4.6,0.1c-1.2,0.4-2,1-0.7,1.9c2.5,1.8,11.6,4.5,14.5,6.9 C231.2,181.1,231.3,173.5,219.2,170z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M229.3,179.6c-0.3,0-0.7-0.1-1.1-0.5c-1.6-1.2-5.2-2.7-8.3-4c-2.6-1.1-5.1-2.1-6.2-2.9 c-0.6-0.4-0.8-0.8-0.8-1.2c0.1-0.5,0.6-0.9,1.6-1.3c1.5-0.5,3.2-0.6,4.9-0.1c8.2,2.3,10.8,6.5,11,8.4c0.1,0.7-0.1,1.2-0.5,1.4 C229.7,179.6,229.5,179.6,229.3,179.6z M217,170.1c-0.8,0-1.6,0.1-2.3,0.4c-1,0.4-1.1,0.7-1.1,0.7c0,0.1,0.2,0.4,0.5,0.6 c1.1,0.8,3.5,1.8,6.1,2.8c3.3,1.4,6.8,2.8,8.5,4.1c0.4,0.3,0.7,0.4,0.8,0.3c0.1-0.1,0.2-0.4,0.2-0.7c-0.2-2-3.2-5.7-10.5-7.8 C218.4,170.2,217.7,170.1,217,170.1z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M250.8,193.8c0,0,3.7-0.1,4.8,4.4c1.1,4.5-0.3,6.7-1.1,4.3c-0.8-2.4-1.4-3.9-1.9-5.4 c-0.5-1.5-1.9-2.4-2-2.9C250.4,193.7,250.8,193.8,250.8,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M255.3,203.9c-0.3,0-0.7-0.2-1.1-1.2c-0.4-1.2-0.8-2.2-1.1-3.1c-0.3-0.9-0.6-1.6-0.8-2.3 c-0.3-0.9-0.9-1.5-1.4-2c-0.3-0.4-0.6-0.6-0.7-0.9c-0.1-0.3-0.1-0.5,0.1-0.7c0.1-0.2,0.4-0.2,0.5-0.2c0.4,0,4,0.2,5.2,4.7 c0.7,2.9,0.5,5.4-0.5,5.7C255.4,203.9,255.3,203.9,255.3,203.9z M250.9,194.2c0.1,0.1,0.3,0.4,0.5,0.6c0.5,0.5,1.2,1.3,1.5,2.3 c0.2,0.7,0.5,1.5,0.8,2.3c0.3,0.9,0.7,1.9,1.1,3.1c0.2,0.7,0.4,0.7,0.4,0.7c0.3-0.1,0.8-1.7,0-4.9 C254.3,194.5,251.4,194.2,250.9,194.2z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M205.7,218.4c0.6,2.1-0.3,4.3-2.1,4.8c-1.8,0.6-3.8-0.7-4.4-2.8c-0.6-2.1,0.3-4.3,2.1-4.8 C203,215.1,205,216.3,205.7,218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M202.7,223.8c-0.7,0-1.4-0.2-2-0.6c-0.9-0.6-1.6-1.5-1.9-2.6c-0.7-2.3,0.3-4.7,2.3-5.3c1-0.3,2-0.1,3,0.5 c0.9,0.6,1.6,1.5,1.9,2.6c0.3,1.1,0.3,2.3-0.1,3.3c-0.4,1-1.2,1.7-2.2,2C203.3,223.7,203,223.8,202.7,223.8z M202.1,215.8 c-0.3,0-0.5,0-0.8,0.1c-1.6,0.5-2.5,2.5-1.9,4.4c0.3,0.9,0.9,1.7,1.6,2.2c0.8,0.5,1.6,0.6,2.4,0.4c0.8-0.2,1.4-0.8,1.8-1.6 c0.4-0.8,0.4-1.8,0.1-2.8c-0.3-0.9-0.9-1.7-1.6-2.2C203.2,216,202.6,215.8,202.1,215.8z"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228.4,257.1c0,0,7.5-1.5,12.3,2.3c4.8,3.7,5.6,7.9,3.7,8.1c-1.9,0.2-6.6-3.9-9.1-4.6 C232.8,262.3,226.3,259.6,228.4,257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.3,267.8c-1.2,0-3-1.1-4.9-2.3c-1.5-1-3.1-2-4.2-2.2c-2-0.5-6.7-2.4-7.4-4.6c-0.2-0.6-0.1-1.3,0.4-1.8 l0.1-0.1l0.1,0c0.3-0.1,7.7-1.4,12.5,2.4c3.7,2.9,5.2,6.1,4.7,7.7c-0.2,0.6-0.6,0.9-1.2,1C244.4,267.8,244.3,267.8,244.3,267.8z  M228.6,257.4c-0.2,0.3-0.3,0.7-0.2,1.1c0.6,1.7,4.7,3.5,6.9,4.1c1.2,0.3,2.8,1.3,4.4,2.3c1.7,1.1,3.7,2.3,4.6,2.2 c0.3,0,0.5-0.2,0.6-0.5c0.3-1.2-0.8-4.1-4.5-7C236.2,256.3,229.6,257.3,228.6,257.4z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M305.9,259.8l-10,5.5c-1.2,0.7-2.7,0.2-3.4-1.1l-14.5-26.5c-0.7-1.3-0.3-2.8,0.9-3.5l10-5.5 c1.2-0.7,2.7-0.2,3.4,1.1l14.5,26.5C307.5,257.6,307.1,259.1,305.9,259.8z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.4,229.7l-1.9,1.1c-0.3,0.1-0.3,0.5-0.2,0.8l0.2,0.4c0.2,0.3,0.1,0.6-0.2,0.8l-3.8,2.1 c-0.3,0.1-0.6,0-0.8-0.3l-0.2-0.4c-0.2-0.3-0.5-0.4-0.8-0.3l-0.7,0.4l-1.7,0.9c-0.8,0.5-1.1,1.6-0.7,2.4l14.1,25.8 c0.5,0.9,1.6,1.2,2.4,0.8l10-5.5c0.8-0.5,1.1-1.6,0.7-2.4l-14.1-25.8C291.4,229.6,290.3,229.2,289.4,229.7z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M295.2,261.1l0.3,0.6c0,0.1,0,0.1-0.1,0.1l-0.7,0c-0.1,0-0.1-0.1-0.1-0.1l0.3-0.6 C295,261.1,295.1,261.1,295.2,261.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M299.4,259.2c0.1,0.2,0,0.5-0.2,0.7c-0.2,0.1-0.5,0-0.7-0.2c-0.1-0.2,0-0.5,0.2-0.7 C299,258.9,299.3,259,299.4,259.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M303.2,257.7L303.2,257.7c-0.2,0.1-0.5,0-0.6-0.2l0,0c-0.1-0.2,0-0.5,0.2-0.6l0,0 c0.2-0.1,0.5,0,0.6,0.2l0,0C303.5,257.3,303.4,257.6,303.2,257.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M295.6,241.1c1.5,2.7,0.5,6.2-2.2,7.7c-2.7,1.5-6.2,0.5-7.7-2.2c-1.5-2.7-0.5-6.2,2.2-7.7 C290.7,237.4,294.1,238.4,295.6,241.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M295.1,241.5c1.3,2.5,0.4,5.5-2,6.9c-2.5,1.3-5.5,0.4-6.9-2c-1.3-2.5-0.4-5.5,2-6.9 C290.7,238.1,293.7,239,295.1,241.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.2,
    y: 241.5,
    transform: "matrix(0.9597 0.281 -0.281 0.9597 80.209 -71.8622)",
    className: "st3",
    width: 1,
    height: 4.5
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.2,
    y: 241.5,
    transform: "matrix(0.281 -0.9597 0.9597 0.281 -24.9291 454.1826)",
    className: "st3",
    width: 1,
    height: 4.5
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M285.6,235.4c0-0.1,0.1-0.1,0.2-0.2l-0.1-0.2l0.3-0.2l0.2,0.2c0.1,0,0.2,0,0.2,0l0.1-0.2l0.4,0.1l0,0.2 c0.1,0,0.1,0.1,0.2,0.2l0.2-0.1l0.2,0.3l-0.2,0.2c0,0.1,0,0.2,0,0.2l0.2,0.1l-0.1,0.4l-0.2,0c0,0.1-0.1,0.1-0.2,0.2l0.1,0.2 l-0.3,0.2l-0.2-0.2c-0.1,0-0.2,0-0.2,0l-0.1,0.2l-0.4-0.1l0-0.2c-0.1,0-0.1-0.1-0.2-0.2l-0.2,0.1l-0.2-0.3l0.2-0.2 c0-0.1,0-0.2,0-0.2l-0.2-0.1l0.1-0.4L285.6,235.4L285.6,235.4z M286,235.7c-0.1,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4-0.1,0.5-0.3 c0.1-0.2-0.1-0.4-0.3-0.5C286.3,235.4,286.1,235.5,286,235.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M281.8,238.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.2,0.1-0.3,0.2-0.4,0.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c0,0,0-0.1,0-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.3-0.2,0.4-0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0 C281.9,238.3,281.9,238.4,281.8,238.4C281.9,238.4,281.8,238.4,281.8,238.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M281.5,239C281.5,239,281.5,239,281.5,239l-0.5-0.2c0,0,0,0,0-0.1l0.1-0.5c0,0,0,0,0.1,0c0,0,0,0,0,0.1 l-0.1,0.4l0.4,0.2C281.5,238.9,281.6,238.9,281.5,239C281.5,239,281.5,239,281.5,239z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M291.5,232.5c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1c0-0.1,0-0.2,0.1-0.2 C291.3,232.4,291.4,232.5,291.5,232.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M291.8,233c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1c0-0.1,0-0.2,0.1-0.2 C291.6,232.9,291.7,232.9,291.8,233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M292,233.5c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1c0-0.1,0-0.2,0.1-0.2 C291.9,233.4,292,233.4,292,233.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M291.1,252.5c0,0-0.3,0.2-0.7,0.4c-0.4,0.2-0.7,0.4-0.7,0.4s0.3-0.2,0.7-0.4 C290.7,252.6,291.1,252.4,291.1,252.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M294.5,252.7c0,0-0.9,0.5-1.9,1.1c-1.1,0.6-1.9,1-2,1c0,0,0.9-0.5,1.9-1.1 C293.6,253.2,294.5,252.7,294.5,252.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M295.4,254.4c0,0-0.9,0.5-1.9,1.1c-1.1,0.6-1.9,1-2,1c0,0,0.9-0.5,1.9-1.1 C294.5,254.8,295.4,254.4,295.4,254.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M300,250.5l-1.4,0.8c-0.3,0.2-0.8,0.1-1-0.3l0,0c-0.2-0.3-0.1-0.8,0.3-1l1.4-0.8c0.3-0.2,0.8-0.1,1,0.3 l0,0C300.4,249.9,300.3,250.4,300,250.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 298.2,
    cy: 250.7,
    r: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M300.9,252.2l-1.4,0.8c-0.3,0.2-0.8,0.1-1-0.3l0,0c-0.2-0.3-0.1-0.8,0.3-1l1.4-0.8 c0.3-0.2,0.8-0.1,1,0.3l0,0C301.3,251.6,301.2,252,300.9,252.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M299.6,252.1c0.2,0.3,0.1,0.6-0.2,0.8c-0.3,0.2-0.6,0.1-0.8-0.2c-0.2-0.3-0.1-0.6,0.2-0.8 C299.1,251.7,299.4,251.8,299.6,252.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M296.3,256c0,0-0.9,0.5-1.9,1.1c-1.1,0.6-1.9,1-2,1c0,0,0.9-0.5,1.9-1.1 C295.4,256.5,296.3,256,296.3,256z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M301.9,254l-1.4,0.8c-0.3,0.2-0.8,0.1-1-0.3l0,0c-0.2-0.3-0.1-0.8,0.3-1l1.4-0.8c0.3-0.2,0.8-0.1,1,0.3 l0,0C302.3,253.4,302.2,253.8,301.9,254z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M300.6,253.9c0.2,0.3,0.1,0.6-0.2,0.8c-0.3,0.2-0.6,0.1-0.8-0.2c-0.2-0.3-0.1-0.6,0.2-0.8 C300.1,253.5,300.5,253.6,300.6,253.9z"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M119,249.2c-2.2-2.6-6.5-3.1-9-1.2c-2.5,1.9-2.8,6.2-0.6,8.8c2.2,2.6,7.6,3.7,10.1,1.8 C122,256.7,121.2,251.8,119,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M111.7,258.9c-1-0.5-1.9-1.1-2.5-1.9c-1.1-1.3-1.7-3.1-1.6-4.9c0.1-1.8,0.9-3.4,2.2-4.4 c1.3-1,3.1-1.4,4.9-1.2c1.8,0.2,3.5,1.1,4.6,2.4c1.1,1.4,1.9,3.3,2.1,5.2c0.2,2.1-0.4,3.8-1.7,4.7c-1.3,1-3.3,1.3-5.4,0.9 C113.3,259.6,112.4,259.3,111.7,258.9z M116.7,247.9c-0.7-0.3-1.4-0.5-2.1-0.6c-1.6-0.2-3.2,0.2-4.4,1.1 c-1.1,0.9-1.8,2.3-2,3.9c-0.1,1.6,0.4,3.2,1.4,4.4c1,1.2,2.8,2.1,4.7,2.5c2,0.4,3.8,0.1,4.9-0.7c1.1-0.8,1.6-2.3,1.4-4.2 c-0.2-1.7-0.9-3.5-1.9-4.8C118.2,248.8,117.5,248.2,116.7,247.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M122.1,244.9l-3.8,6.5l2.4,1.2l3.1-6.9c0.2-0.5,0-1-0.4-1.3S122.4,244.4,122.1,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M120.9,253.1l-3-1.6l4-6.8c0.4-0.6,1.1-0.8,1.8-0.5c0.6,0.3,0.9,1.1,0.6,1.7L120.9,253.1z M118.8,251.3 l1.7,0.9l3-6.5c0.1-0.3,0-0.7-0.3-0.8c-0.3-0.2-0.7,0-0.8,0.2L118.8,251.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M120.3,252.8l-5.9-8.2c-0.4-0.5-1.1-0.6-1.6-0.2l-0.2,0.1c-0.5,0.4-0.6,1.1-0.2,1.6l6.5,7.8 c0.3,0.4,0.8,0.4,1.2,0.1C120.5,253.8,120.6,253.2,120.3,252.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M119.5,254.6c-0.3,0-0.7-0.1-0.9-0.4l-6.5-7.8c-0.2-0.3-0.4-0.7-0.3-1.1c0-0.4,0.2-0.8,0.6-1l0.2-0.1 c0.3-0.3,0.7-0.4,1.1-0.3c0.4,0.1,0.7,0.3,1,0.6l5.9,8.2c0.4,0.5,0.3,1.3-0.3,1.7C120.1,254.5,119.8,254.6,119.5,254.6z  M113.5,244.5c-0.2,0-0.3,0.1-0.5,0.2l-0.2,0.1c-0.2,0.1-0.3,0.3-0.3,0.6c0,0.2,0,0.4,0.2,0.6l6.5,7.8 c0.2,0.2,0.5,0.2,0.7,0.1c0.2-0.2,0.3-0.5,0.1-0.8l-5.9-8.2c-0.1-0.2-0.3-0.3-0.5-0.3C113.6,244.5,113.5,244.5,113.5,244.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M112.3,258.6l-5.3-5.4c-0.4-0.4-0.5-1.2-0.1-1.7c0.4-0.5,1.1-0.5,1.5,0l4.9,5.8c0.3,0.4,0.3,0.9,0,1.3 C113.1,258.9,112.6,258.9,112.3,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M112.8,259.2c-0.3,0-0.6-0.1-0.8-0.3l-5.3-5.4c-0.6-0.6-0.6-1.5-0.1-2.1c0.3-0.3,0.6-0.5,1-0.5 c0.4,0,0.8,0.2,1,0.5l4.9,5.8c0.4,0.5,0.4,1.2,0,1.7C113.4,259,113.1,259.1,112.8,259.2C112.8,259.2,112.8,259.2,112.8,259.2 z M107.6,251.4c-0.2,0-0.3,0.1-0.5,0.2c-0.3,0.4-0.3,0.9,0.1,1.3l5.3,5.4c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.2-0.1 c0.2-0.2,0.2-0.6,0-0.8l-4.9-5.8C108,251.5,107.8,251.4,107.6,251.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M114.9,257.7l-7-7.7c-0.3-0.4-0.3-1,0-1.5l0.1-0.2c0.4-0.4,1-0.5,1.3,0l6.6,8.1c0.2,0.3,0.2,0.8,0,1.1 C115.6,257.9,115.2,258,114.9,257.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M115.3,258.2c-0.3,0-0.5-0.1-0.7-0.3l-7-7.7c-0.5-0.5-0.5-1.3,0-1.9l0.1-0.2c0.3-0.3,0.6-0.5,1-0.5 c0.3,0,0.6,0.2,0.9,0.4l6.6,8.1c0.4,0.4,0.3,1.1,0,1.6C116,258.1,115.7,258.2,115.3,258.2 C115.3,258.2,115.3,258.2,115.3,258.2z M108.7,248.4c-0.2,0-0.3,0.1-0.4,0.2l-0.1,0.2c-0.3,0.3-0.3,0.8,0,1l7,7.7 c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.3-0.2c0.2-0.2,0.2-0.5,0-0.7l-6.6-8.1C109,248.5,108.9,248.4,108.7,248.4 C108.7,248.4,108.7,248.4,108.7,248.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M117,256.5l-7.4-9c-0.4-0.5-0.3-1.3,0.3-1.7c0.6-0.4,1.3-0.4,1.7,0.2l6.9,9.4c0.3,0.4,0.2,0.9-0.2,1.2 C117.8,256.9,117.2,256.8,117,256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M117.6,257.1c-0.3,0-0.7-0.1-0.9-0.4l-7.4-9c-0.2-0.3-0.4-0.7-0.3-1.1c0-0.4,0.3-0.8,0.6-1.1 c0.4-0.3,0.8-0.4,1.2-0.3c0.4,0.1,0.7,0.3,1,0.6l6.9,9.4c0.4,0.5,0.2,1.2-0.3,1.7C118.1,257,117.8,257.1,117.6,257.1z  M110.6,245.8c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.2-0.3,0.4-0.4,0.6c0,0.2,0,0.4,0.2,0.6l7.4,9c0.2,0.2,0.5,0.2,0.7,0 c0.2-0.2,0.3-0.5,0.2-0.7l-6.9-9.4c-0.1-0.2-0.3-0.3-0.5-0.3C110.7,245.8,110.6,245.8,110.6,245.8z"
  })))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M292.4,244.7l4.4-5.5c0.3-0.3,0.8-0.3,1.1,0.1l0.1,0.1c0.3,0.4,0.4,1,0.1,1.3l-4.8,5 c-0.2,0.2-0.6,0.2-0.9-0.1C292.3,245.4,292.2,245,292.4,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M293,246.4c-0.3,0-0.6-0.2-0.8-0.4c-0.4-0.4-0.4-1.1-0.1-1.5l4.4-5.5c0.2-0.2,0.4-0.3,0.7-0.3 c0.3,0,0.7,0.2,0.9,0.5l0.1,0.1c0.4,0.5,0.5,1.3,0.1,1.8l-4.8,5C293.5,246.3,293.3,246.4,293,246.4z M297.3,239.4 c-0.1,0-0.1,0-0.2,0.1l-4.4,5.5c-0.1,0.1-0.1,0.4,0.1,0.6c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.1,0,0.1,0l4.8-5 c0.1-0.2,0.1-0.6-0.1-0.8l-0.1-0.1C297.6,239.5,297.4,239.4,297.3,239.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M297.7,251.3l3.9-3.3c0.3-0.3,0.4-0.9,0.1-1.3c-0.3-0.5-0.7-0.6-1.1-0.3l-3.6,3.7 c-0.2,0.2-0.3,0.7-0.1,1C297.1,251.4,297.4,251.5,297.7,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M297.4,251.7c0,0-0.1,0-0.1,0c-0.3,0-0.5-0.2-0.6-0.5c-0.3-0.5-0.2-1.1,0.1-1.4l3.6-3.7 c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.3,0.8,0.6c0.3,0.6,0.3,1.4-0.2,1.8l-3.9,3.3C297.8,251.7,297.6,251.7,297.4,251.7z  M301,246.5c-0.1,0-0.1,0-0.2,0.1l-3.6,3.7c-0.1,0.1-0.1,0.4,0,0.6c0.1,0.1,0.1,0.1,0.1,0.1l0.3,0.2l-0.2-0.3l3.9-3.3 c0.2-0.1,0.2-0.6,0.1-0.9C301.3,246.6,301.2,246.5,301,246.5C301,246.5,301,246.5,301,246.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M295.8,250.3l5.2-4.8c0.3-0.2,0.3-0.8,0-1.2l-0.1-0.2c-0.2-0.4-0.7-0.5-0.9-0.3l-4.9,5.2 c-0.2,0.2-0.2,0.6,0,0.9C295.3,250.3,295.6,250.5,295.8,250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M295.6,250.7c0,0-0.1,0-0.1,0c-0.3,0-0.5-0.2-0.7-0.5c-0.3-0.5-0.2-1,0.1-1.3l4.9-5.2 c0.2-0.2,0.4-0.3,0.7-0.2c0.3,0,0.6,0.2,0.8,0.6l0.1,0.2c0.3,0.5,0.3,1.2-0.1,1.6l-5.2,4.8 C295.9,250.6,295.8,250.7,295.6,250.7z M300.3,244.1C300.3,244.1,300.3,244.1,300.3,244.1l-4.9,5.3c-0.1,0.1-0.1,0.3,0,0.5 c0.1,0.1,0.1,0.2,0.2,0.2l5.2-4.8c0.1-0.1,0.1-0.4,0-0.7l-0.1-0.2C300.5,244.2,300.4,244.1,300.3,244.1 C300.3,244.1,300.3,244.1,300.3,244.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M294.4,248.5l5.5-5.8c0.3-0.3,0.3-1-0.1-1.4c-0.4-0.4-0.9-0.5-1.2-0.2l-5.1,6.3c-0.2,0.2-0.1,0.7,0.1,1 C293.8,248.7,294.2,248.7,294.4,248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M294.1,249c-0.3,0-0.6-0.2-0.8-0.4c-0.4-0.4-0.4-1.1-0.1-1.4l5.1-6.3c0.2-0.2,0.4-0.3,0.7-0.3 c0.4,0,0.7,0.2,1,0.5c0.5,0.6,0.5,1.4,0.1,1.9l-5.5,5.8C294.5,248.9,294.3,249,294.1,249z M299,241.3c-0.1,0-0.1,0-0.2,0.1 l-5.1,6.3c-0.1,0.1-0.1,0.3,0.1,0.5c0.1,0.1,0.2,0.2,0.3,0.2l0.1,0l5.5-5.8c0.2-0.2,0.1-0.6-0.1-0.9 C299.4,241.4,299.2,241.3,299,241.3z"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M113.8,228.4c0-1,0.7-1.7,1.6-1.7c1,0,1.6,0.7,1.6,1.7c0,1-0.6,1.7-1.6,1.7 C114.4,230.1,113.8,229.3,113.8,228.4z M114.5,224.4l-0.4-13.3h2.7l-0.4,13.3H114.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M115.4,230.4c-1.1,0-2-0.9-2-2.1c0-1.2,0.9-2.1,2-2.1c1.2,0,2,0.8,2,2.1 C117.4,229.6,116.5,230.4,115.4,230.4z M115.4,227c-0.8,0-1.3,0.6-1.3,1.4c0,0.8,0.5,1.4,1.3,1.4c0.8,0,1.3-0.5,1.3-1.4 C116.7,227.6,116.2,227,115.4,227z M116.7,224.8h-2.6l-0.4-14h3.4L116.7,224.8z M114.8,224.1h1.2l0.4-12.6h-1.9L114.8,224.1z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M125.1,233h-19.9c-1.7,0-3.2-0.9-4-2.3c-0.8-1.4-0.8-3.2,0-4.6l9.9-17.2c0.8-1.4,2.3-2.3,4-2.3 s3.2,0.9,4,2.3l9.9,17.2c0.8,1.4,0.8,3.2,0,4.6C128.2,232.1,126.7,233,125.1,233z M115.1,207c-1.5,0-2.9,0.8-3.6,2.1 l-9.9,17.2c-0.8,1.3-0.8,2.9,0,4.2c0.8,1.3,2.1,2.1,3.6,2.1h19.9c1.5,0,2.9-0.8,3.6-2.1c0.8-1.3,0.8-2.9,0-4.2l-9.9-17.2 C118,207.7,116.6,207,115.1,207z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M125.1,233.4h-19.9c-1.8,0-3.4-0.9-4.3-2.5c-0.9-1.6-0.9-3.4,0-5l9.9-17.2c0.9-1.6,2.5-2.5,4.3-2.5 c1.8,0,3.4,0.9,4.3,2.5l9.9,17.2c0.9,1.6,0.9,3.4,0,5C128.5,232.4,126.9,233.4,125.1,233.4z M115.1,207.3 c-1.4,0-2.6,0.7-3.3,1.9l-9.9,17.2c-0.7,1.2-0.7,2.6,0,3.8c0.7,1.2,1.9,1.9,3.3,1.9h19.9c1.4,0,2.6-0.7,3.3-1.9 c0.7-1.2,0.7-2.6,0-3.8l-9.9-17.2C117.7,208.1,116.5,207.3,115.1,207.3z"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofotajet);
export default __webpack_public_path__ + "static/media/nofotajet.355b53df19537576e03b05b296a96485.svg";
export { ForwardRef as ReactComponent };